import React, { Component } from "react";
import Spinner from "./loader.js";
import Accordion from "react-bootstrap/Accordion";
import Card from "react-bootstrap/Card";
import { Resizable } from "react-resizable";
// import { pdfjs } from "react-pdf";
import { Link } from "react-router-dom";
import Select from "react-select";
import {
  ToastsContainer,
  ToastsContainerPosition,
  ToastsStore,
} from "react-toasts";
import { setTimeout } from "timers";

import { API_ENDPOINT, callApi } from "../../utils/api";
import SurveyItem, { Survey } from "./SurveyItem";
import PDFHighlighter from "../PDF-Highlighter";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import ZoomInIcon from "@material-ui/icons/ZoomIn";
import ZoomOutIcon from "@material-ui/icons/ZoomOut";
import FullscreenExitIcon from "@material-ui/icons/FullscreenExit";
import FullscreenIcon from "@material-ui/icons/Fullscreen";
import Rotate90DegreesCcwIcon from "@material-ui/icons/Rotate90DegreesCcw";
import { Loader } from "react-hyper-tree";
import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";
import DOMPurify from "dompurify";
import CountdownTimer from "../file/CountdownTimer";
import { Button, Modal } from "antd";
import { getExtentUnits } from "../../utils/staticData";
import QueryNote from "./QueryNote";
// pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.1.266/pdf.worker.min.js`;

export interface GeneralDetailEntity {
  id: string;
  fod_fk: string;
  applicant_name: string;
  co_applicant_name: string;
  // plot_no: string;
  address: string;
  created_by: string;
  door_no: string;
  flat_no: string;
  floor: string;
  buildup: string;
  appt_name: string;
  survey: Survey[];
  // measure_list: MeasureList[];
  // measurement_list: MeasureLabel[];
}
interface ScheduleList {
  survey_details: [];
  // measure_details: [];
  // measurement_list: [];
  nature_doc: string;
  builtup_unit: string;
  uds_unit: string;
  applicant_name: string;
  co_applicant_name: string;
  // plot_no: string;
  collapseid?: boolean;
  address: string;
  created_by: string;
  door_no: string;
  scheduleasper: string;
  flat_no: string;
  floor: string;
  buildup: string;
  appt_name: string;
  delete_items_schedule: [];
  uds: string;
  remark: string;
}
interface AllProps {
  history: any;
  location: any;
  match: any;
  id: any;
  goToTab: any;
}
export default class GeneralDetailForm extends Component<AllProps> {
  state = {
    showTable: false,
    surveyDetailsTD: [],
    address: "",
    boundary: [],
    measures: [],
    natureDocN: "",
    measureList: [],
    measDirList: [],
    timer: 0,
    loader: false,
    base: "",
    nature_doc: "",
    builtup_unit: "",
    uds_unit: "",
    numPages: 0,
    pageNumber: 1,
    type: "",
    categories: [],
    schedules: [],
    isLoading: false,
    isMergeLoading: false,
    documentWidth: 50,
    documentHeight: 850,
    formWidth: 50,
    formHeight: 600,
    total_extent: "",
    extent_unit: "",
    selectedDoc: "",
    allDocuments: [],
    titleDocuments: [],
    nature_docs: [],
    extentUnits: [],
    inactive: 0,
    isMergeWithSOP: 0,
    activeNormal: 0,
    activeEditor: 0,
    url: "",
    highlights: [],
    rotation: 0,
    disabled: true,
    enableWheel: false,
    panningEnabled: false,
    transformEnabled: false,
    pinchEnabled: false,
    enableTouchPadPinch: false,
    isDocPreviewLoading: false,
    velocityEqualToMove: false,
    enableVelocity: false,
    isHightlightsLoaded: false,
    docReportForPreview: "",
    docToPreview: false,
    required: false,
    normalMode: true,
    editorMode: false,
    qaList: [],
    editorcontent:
      "<p>All that piece and parcel of the landed property <strong>bearing Door No-##door_no##</strong> comprised in <strong>##survey_details##</strong> measuring an extent of <strong>##total_extent##</strong> in Plot No-<strong>##plot_no##</strong>, <strong>##layout##</strong> <strong>##street##</strong> of <strong>##village##</strong> <strong>Village</strong>,<strong> ##taluk## Taluk</strong>, <strong>##district## District</strong> lying within the <strong>Registration District</strong> <strong>of ##regd_district##</strong> and <strong>Sub-Registration District of ##sro##</strong> and being bounded on the\n</p><p><strong>Boundaries:-</strong>\n</p><p><strong>North ##Of / by##:</strong> #<strong>#</strong>north_directions##\n</p><p><strong>South ##Of / by##:</strong> ##south_directions##\n</p><p><strong>East ##Of / by##:</strong> ##east_directions##\n</p><p><strong>West ##Of / by##:</strong> ##west_directions##\n</p><p><strong>Within these boundaries measuring:-</strong>\n</p><p>East to West on the <strong>North Side: ##feet## feet</strong>\n</p><p>East to West on the <strong>South Side: ##feet## feet</strong>\n</p><p>South to North on the <strong>East Side: ##feet## feet</strong>\n</p><p>South to North on the <strong>West Side: ##feet## feet</strong>\n</p><p>Totally measuring of <strong>##total_extent## Square feet</strong>\n</p><p>with all easement rights and pathway<em>​</em>\n</p>",
    autoAssign: [
      {
        id: "1",
        module_name: "Auto Assign",
        status: false,
      },
    ],
    showdoor_no: false,
    ismergerequired: false,
    this_doc_no: "",
    title_doc_no: [],
    scheduleasper: "As Per Doc No",
    editorSave: false,
    showNormalModeCheckBox: true,
  };
  document = {
    base: "",
    numPages: 0,
    pageNumber: 1,
  };
  countdownTimerRef: CountdownTimer | null = null;
  componentDidMount() {
    this.getCategories(); // For getting category
    this.getGeneralDetail(); // For getting SOP over all
    this.getRevenueDocs(); // For getting PDF
    this.getAllDocuments(); // For getting Document dropdown
    this.getTitleDocuments(); //For getting Title doc drodown
    this.getNatureDocs();
    const extentUnits = getExtentUnits();
    this.setState({ extentUnits });
    this.liveinsert();
    // this.getAutoAssignStatus();
    setInterval(() => {
      this.incrementTimer();
    }, 1000);
  }
  componentWillUnmount(): void {
    localStorage.removeItem("bankTemplatemode");
    localStorage.removeItem("isVerifyFlow");
  }
  incrementTimer = () => {
    const { timer } = this.state;
    this.setState({ timer: timer + 1 });
  };
  getAutoAssignStatus = () => {
    callApi("GET", "module_option_select.php", "")
      .then((res) => res.data)
      .then((result) => {
        this.setState({ autoAssign: result.responseJson.data });
      })
      .catch((err) => {
        console.log(err);
      });
  };
  liveinsert = () => {
    const user: any = localStorage.getItem("user");
    const role_id = user ? JSON.parse(user)["team_type"] : "";
    const userId = user ? JSON.parse(user)["userId"] : "";
    const role = user ? JSON.parse(user)["teamType"] : "";
    const role_type = user ? JSON.parse(user)["roleType"] : "";
    const user_name = user ? JSON.parse(user)["userName"] : "";
    const bankName: any = localStorage.getItem("bankName");
    const fileNo: any = localStorage.getItem("filenumber");
    const in_reason: any = localStorage.getItem("inreasonlive");
    let dateTime = new Date();
    let curentTime = dateTime.toLocaleTimeString();
    const textRay = `File_No : ${this.props.match.params.id} On General detail}`;
    let obj = {
      file_no: fileNo,
      in_time: curentTime,
      reason: in_reason,
      user_id: userId,
      user_name: user_name,
      team_type: role,
      role_type: role_type,
      working_process: textRay,
      bank_name: bankName,
    };
    callApi("POST", "live_track_insert.php", obj)
      .then((res) => res.data)
      .then((response) => {});
  };
  onDocumentResize = (event, { element, size, handle }) => {
    if (size.width <= 60) {
      this.setState({
        documentWidth: size.width,
        documentHeight: size.height,
        formWidth: 90 - size.width,
      });
    }
  };
  onFormResize = (event, { element, size, handle }) => {
    this.setState({
      formWidth: size.width,
      formHeight: size.height,
      documentWidth: 90 - size.width,
    });
  };
  toggleDocStatus = () => {
    const inactive = this.state.inactive ? 0 : 1;
    callApi("POST", "doc_status_update.php", {
      id: this.props.match.params.docid,
      inactive,
      flag: "sop",
    })
      .then((res) => res.data)
      .then((response) => {
        localStorage.removeItem("overviewDocument");
        this.setState({ inactive });
      })
      .catch((err) => {
        console.log(err);
      });
  };
  toggleMergeSOPStatus = async (e) => {
    const isMergeWithSOP = e.target.checked ? 1 : 0;
    if (e.target.checked == false) {
      await this.setState({ this_doc_no: "", title_doc_no: "" });
    }
    await this.setState({ isMergeWithSOP });
    this.saveMergeSOP();
  };

  handleMergeSOPChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };
  getCategories = () => {
    callApi("POST", "category.php")
      .then((res) => res.data)
      .then((response) => {
        this.setState({ categories: response.data });
      })
      .catch((err) => {
        console.log(err);
      });
  };
  getGeneralDetail = () => {
    callApi("POST", "general_details_get.php", {
      id: this.props.match.params.docid,
    })
      .then((res) => res.data)
      .then((response) => {
        if (response.data) {
          const schedules = response.data.schedules;
          if (schedules && schedules?.[0]?.nature_doc != "") {
            this.setState({
              natureDocN: schedules?.[0]?.nature_doc,
              scheduleasper: schedules?.[0]?.scheduleasper
                ? schedules?.[0]?.scheduleasper
                : "As Per Doc No",
              showTable: true,
              surveyDetailsTD: schedules?.[0]?.survey_details,
              address: schedules?.[0]?.address,
              boundary: schedules?.[0]?.survey_details?.[0]?.boundary_details,
              measureList:
                schedules?.[0]?.survey_details?.[0]?.boundary_details?.[0]
                  ?.measurement_list,
              measDirList:
                schedules?.[0]?.survey_details?.[0]?.boundary_details?.[0]
                  ?.measurement_list?.[0]?.meas_dir_list,
              total_extent: schedules?.[0]?.total_extent,
              extent_unit: schedules?.[0]?.extent_unit,
              editorcontent: schedules?.[0]?.editorcontent
                ? schedules?.[0]?.editorcontent
                : '<p><span><span style="font-family:&quot;Bookman Old Style&quot;,serif">All that piece and parcel of the landed property <strong>bearing Door No-152 </strong>comprised in <strong>Old Survey No-48/1 and after sub division New Survey No-48/1A</strong> measuring an extent of <strong>1040 Sq.ft in Plot No-10, Ganapthi Nagar </strong>of <strong>Karuppur Village</strong>, <strong>Salem Taluk</strong>, <strong>Salem District</strong> lying within the <strong>registration district of Salem West </strong>and <strong>Sub-Registration District of Omalur</strong> and being bounded on the</span></span></p><p><span><strong><span style="font-family:&quot;Bookman Old Style&quot;,serif">Boundaries:-</span></strong></span></p><p><span><strong><span style="font-family:&quot;Bookman Old Style&quot;,serif">North of/by:</span></strong></span><span><span style="font-family:&quot;Bookman Old Style&quot;,serif"> Mathu House Property</span></span></p><p><span><strong><span style="font-family:&quot;Bookman Old Style&quot;,serif">South of/by:</span></strong></span><span><span style="font-family:&quot;Bookman Old Style&quot;,serif"> Mani Property</span></span></p><p><span><strong><span style="font-family:&quot;Bookman Old Style&quot;,serif">East of/by:</span></strong></span><span><span style="font-family:&quot;Bookman Old Style&quot;,serif"> Sathiskumar property, common wall</span></span></p><p><span><strong><span style="font-family:&quot;Bookman Old Style&quot;,serif">West of/by:</span></strong></span><span><span style="font-family:&quot;Bookman Old Style&quot;,serif"> 10 feet North South Road</span></span></p><p><span><strong><span style="font-family:&quot;Bookman Old Style&quot;,serif">Within these boundaries measuring:-</span></strong></span></p><p><span><span style="font-family:&quot;Bookman Old Style&quot;,serif">East to West on the <strong>North Side</strong>: 33 ½ feet</span></span></p><p><span><span style="font-family:&quot;Bookman Old Style&quot;,serif">East to West on the <strong>South Side</strong>: 30 ½ feet</span></span></p><p><span><span style="font-family:&quot;Bookman Old Style&quot;,serif">South to North on the <strong>East Side</strong>: 32 feet</span></span></p><p><span><span style="font-family:&quot;Bookman Old Style&quot;,serif">South to North on the <strong>West Side</strong>: 33 feet</span></span></p><p><span><span style="font-family:&quot;Bookman Old Style&quot;,serif">Totally measuring of <strong>1040 Square feet</strong></span></span></p><p><span><span style="font-family:&quot;Bookman Old Style&quot;,serif">with all easement rights and pathway</span></span></p>',
              normalMode: schedules?.[0]?.normalMode,
              editorMode: schedules?.[0]?.editorMode,
              showNormalModeCheckBox: schedules?.[0]?.showNormalCheckBox,
            });
            if (
              schedules?.[0]?.nature_doc == "Existing building" ||
              schedules?.[0]?.nature_doc == "appartment"
            ) {
              this.setState({ showdoor_no: true });
            } else {
              this.setState({ showdoor_no: false });
            }
          } else {
            this.setState({ showTable: false });
          }

          if (schedules == null || schedules.length == 0) {
            const bankTemplatemode: any =
              localStorage.getItem("bankTemplatemode");
            if (bankTemplatemode) {
              const normalMode = bankTemplatemode == "1" ? true : false;
              const editorMode = bankTemplatemode == "2" ? true : false;
              this.setState({
                normalMode,
                editorMode,
                showNormalModeCheckBox: editorMode == true ? false : true,
              });
            }
          } else {
            if (schedules?.[0]?.editorcontent != "") {
              this.setState({ editorSave: true });
            }
            this.setState({
              editorcontent: schedules?.[0]?.editorcontent
                ? schedules?.[0]?.editorcontent
                : '<p><span><span style="font-family:&quot;Bookman Old Style&quot;,serif">All that piece and parcel of the landed property <strong>bearing Door No-152 </strong>comprised in <strong>Old Survey No-48/1 and after sub division New Survey No-48/1A</strong> measuring an extent of <strong>1040 Sq.ft in Plot No-10, Ganapthi Nagar </strong>of <strong>Karuppur Village</strong>, <strong>Salem Taluk</strong>, <strong>Salem District</strong> lying within the <strong>registration district of Salem West </strong>and <strong>Sub-Registration District of Omalur</strong> and being bounded on the</span></span></p><p><span><strong><span style="font-family:&quot;Bookman Old Style&quot;,serif">Boundaries:-</span></strong></span></p><p><span><strong><span style="font-family:&quot;Bookman Old Style&quot;,serif">North of/by:</span></strong></span><span><span style="font-family:&quot;Bookman Old Style&quot;,serif"> Mathu House Property</span></span></p><p><span><strong><span style="font-family:&quot;Bookman Old Style&quot;,serif">South of/by:</span></strong></span><span><span style="font-family:&quot;Bookman Old Style&quot;,serif"> Mani Property</span></span></p><p><span><strong><span style="font-family:&quot;Bookman Old Style&quot;,serif">East of/by:</span></strong></span><span><span style="font-family:&quot;Bookman Old Style&quot;,serif"> Sathiskumar property, common wall</span></span></p><p><span><strong><span style="font-family:&quot;Bookman Old Style&quot;,serif">West of/by:</span></strong></span><span><span style="font-family:&quot;Bookman Old Style&quot;,serif"> 10 feet North South Road</span></span></p><p><span><strong><span style="font-family:&quot;Bookman Old Style&quot;,serif">Within these boundaries measuring:-</span></strong></span></p><p><span><span style="font-family:&quot;Bookman Old Style&quot;,serif">East to West on the <strong>North Side</strong>: 33 ½ feet</span></span></p><p><span><span style="font-family:&quot;Bookman Old Style&quot;,serif">East to West on the <strong>South Side</strong>: 30 ½ feet</span></span></p><p><span><span style="font-family:&quot;Bookman Old Style&quot;,serif">South to North on the <strong>East Side</strong>: 32 feet</span></span></p><p><span><span style="font-family:&quot;Bookman Old Style&quot;,serif">South to North on the <strong>West Side</strong>: 33 feet</span></span></p><p><span><span style="font-family:&quot;Bookman Old Style&quot;,serif">Totally measuring of <strong>1040 Square feet</strong></span></span></p><p><span><span style="font-family:&quot;Bookman Old Style&quot;,serif">with all easement rights and pathway</span></span></p>',
              normalMode: schedules?.[0]?.normalMode,
              editorMode: schedules?.[0]?.editorMode,
              showNormalModeCheckBox: schedules?.[0]?.showNormalCheckBox,
            });
          }
          this.setState({ schedules });
          this.setState({ highlights: schedules?.[0]?.highlights });
          if (!schedules || !schedules.length) {
            this.addItem();
          } else {
            const inactive = schedules?.[0]?.inactive;
            const isMergeWithSOP = schedules?.[0]?.merge_sop;
            const this_doc_no = schedules?.[0]?.this_doc_no;
            const title_doc_no = schedules?.[0]?.title_doc_no;
            this.setState({
              inactive,
              isMergeWithSOP,
              this_doc_no,
              title_doc_no,
            });
          }
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  getRevenueDocs = () => {
    this.setState({ loader: true });
    callApi("POST", "rev_get.php", { id: this.props.match.params.docid })
      .then((res) => res.data)
      .then((response) => {
        if (response.data && response.data.length) {
          const document = this.document;
          document.base = response.data[0].base[0].base;
          const state = this.state;
          state.type = response.data[0].base[0].type;
          state.selectedDoc = "";
          this.setState({
            ...document,
            state,
            isHightlightsLoaded: true,
            loader: false,
          });
          // loader:false
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  getAllDocuments = () => {
    callApi("POST", "all_doc_no_list.php", { id: this.props.match.params.id })
      .then((res) => res.data)
      .then((response) => {
        this.setState({ allDocuments: response.data });
      })
      .catch((err) => {
        console.log(err);
      });
  };
  getTitleDocuments = () => {
    callApi("POST", "title_doc_no_list.php", { id: this.props.match.params.id })
      .then((res) => res.data)
      .then((response) => {
        this.setState({ titleDocuments: response.data });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  getNatureDocs = () => {
    const nature_docs = [
      {
        id: "",
        name: "Select the Nature of property",
      },
      {
        id: "Agri",
        name: "Agri",
      },
      {
        id: "Existing building",
        name: "Existing building",
      },
      {
        id: "Under construction",
        name: "Under construction",
      },
      {
        id: "vacant land",
        name: "Vacant Land",
      },
      {
        id: "appartment",
        name: "Appartment",
      },
    ];
    this.setState({ nature_docs });
  };

  onDocumentLoadSuccess = ({ numPages }) => {
    this.setState({ numPages });
  };
  addItem = (): void => {
    const schedules: ScheduleList[] = this.state.schedules
      ? this.state.schedules
      : [];
    schedules.push({
      survey_details: [],
      // measure_details: [],
      // measurement_list: [],
      nature_doc: "",
      builtup_unit: "",
      uds_unit: "",
      applicant_name: "",
      co_applicant_name: "",
      // plot_no: "",
      address: "",
      created_by: "",
      door_no: "",
      scheduleasper: "",
      flat_no: "",
      floor: "",
      buildup: "",
      appt_name: "",
      delete_items_schedule: [],
      uds: "",
      remark: "",
    });
    this.setState({ schedules });
  };
  removeItem = (modal, index) => {
    const schedules: ScheduleList[] = this.state.schedules;
    const delete_items_schedule: any = this.state.schedules[index][
      "delete_items_schedule"
    ]
      ? this.state.schedules[index]["delete_items_schedule"]
      : [];
    delete_items_schedule.push(modal.schedule_id);
    schedules.splice(index, 1);
    this.setState({ schedules, delete_items_schedule });
  };
  collapsearray = (modal: ScheduleList, index: number): void => {
    const schedules: ScheduleList[] = this.state.schedules;
    if (schedules[index] !== undefined) {
      if (schedules[index].collapseid) {
        schedules[index].collapseid = false;
      } else {
        schedules[index].collapseid = true;
        this.setState({ schedules });
      }
    }
  };

  handleChange = (e, index, propName?, fieldType?) => {
    const schedules: any = this.state.schedules;
    let fieldName = fieldType === "singleselect" ? propName : e.target.name;
    let fieldValue = fieldType === "singleselect" ? e.value : e.target.value;
    schedules[index][fieldName] = fieldValue;
    this.setState({ schedules });
    if (fieldValue == "Existing building" || fieldValue == "appartment") {
      this.setState({ showdoor_no: true });
    } else if (fieldName === "scheduleasper") {
      if (e.target.checked == true) {
        this.setState({ scheduleasper: "As Per Patta" }, () => {});
        schedules[index]["scheduleasper"] = "As Per Patta";
      } else {
        this.setState({ scheduleasper: "As Per Doc No" }, () => {});
        schedules[index]["scheduleasper"] = "As Per Doc No";
      }
    } else {
      if (propName == "nature_doc") {
        schedules[index].door_no = "";
      }
      this.setState({ showdoor_no: false, scheduleasper: "As Per Doc No" });
    }
  };

  categChange = (e, propName?, fieldType?) => {
    const state: any = this.state;

    if (fieldType === "singleselect") {
      if (Array.isArray(e)) {
        // Handle multi-select: extract values or set an empty array if deselected
        state[propName] = e ? e.map((option: any) => option.value) : [];
      } else {
        // Handle single select: set the value or null if no value
        state[propName] = e ? e.value : null;
      }
    } else {
      // For other fields, handle normally
      let fieldName = e.target.name;
      let fieldValue = e.target.value;
      state[fieldName] = fieldValue;
    }
    this.setState({ ...state });
  };

  // categChange = (e, propName?, fieldType?) => {
  //   const state: any = this.state;
  //   let fieldName = fieldType === 'singleselect' ? propName : e.target.name;
  //   let fieldValue = fieldType === 'singleselect' ? e.value : e.target.value;
  //   state[fieldName] = fieldValue;
  //   this.setState({ ...state });
  // };
  FileTypeWithConfirmation = () => {
    Modal.confirm({
      title: "Are you sure?",
      content:
        "Changing the Document Category will clear all the data entered in this document. Do you want to continue?",
      okText: "Yes",
      cancelText: "No",
      onOk: () => {
        this.changeFileType();
      },
    });
  };
  changeFileType = () => {
    callApi("POST", "file_type.php", {
      id: this.props.match.params.docid,
      type: this.state.type,
    })
      .then((res) => res.data)
      .then((response) => {
        if (this.state.type === "ec_doc") {
          this.props.history.push(
            "/ec-form/" +
              this.props.match.params.id +
              "/" +
              this.props.match.params.docid +
              "/2",
          );
        } else if (
          this.state.type === "deed" ||
          this.state.type === "rev_rec_doc" ||
          this.state.type === "sale_agreement" ||
          this.state.type === "mother_doc"
        ) {
          this.props.history.push(
            "/scrutiny/" +
              this.props.match.params.id +
              "/" +
              this.props.match.params.docid +
              "/2",
          );
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  stateToProps = (event, index) => {
    const schedules: any = this.state.schedules;
    schedules[index][event.name] = event.value;
    this.setState({ schedules });
  };
  saveGeneralDoc = (status) => {
    const HaskKey = this.props.location.state?.hash || "";
    const isVerifyFlow =
      HaskKey.includes("Verify") || localStorage.getItem("isVerifyFlow");
    const state: any = this.state;
    state.fod_fk = this.props.match.params.id;
    state.id = this.props.match.params.docid;
    state.status = status;
    state.delete_items = {
      schedules: [],
      survey: [],
      measure_list: [],
      measurement_list: [],
      meas_dir_list: [],
    };
    this.state.schedules.forEach((sch: any) => {
      state.delete_items.schedules = state.delete_items_schedule;
      state.delete_items.survey = state.delete_items.survey
        .concat(sch.delete_items_survey)
        .filter((itm) => itm);
      state.delete_items.measure_list = state.delete_items.measure_list
        .concat(sch.delete_items_measure)
        .filter((itm) => itm);
      state.delete_items.measurement_list = state.delete_items.measurement_list
        .concat(sch.delete_items_measurements)
        .filter((itm) => itm);
      state.delete_items.meas_dir_list = state.delete_items.meas_dir_list
        .concat(sch.delete_items_measure_label)
        .filter((itm) => itm);
    });
    let remark: any;
    let address: any;
    let natureDoc: any;
    let flatNo: any;
    let floorNo: any;
    let apptName: any;
    let buildupArea: any;
    let builtupUnit: any;
    let uds: any;
    let udsUnit: any;
    const validateRemark = this.state.schedules.find((sch: ScheduleList) => {
      remark = sch.remark;
      address = sch.address;
      natureDoc = sch.nature_doc;
      flatNo = sch.flat_no;
      floorNo = sch.floor;
      // apptName = sch.appt_name;
      buildupArea = sch.buildup;
      builtupUnit = sch.builtup_unit;
      uds = sch.uds;
      udsUnit = sch.uds_unit;
    });
    if (this.state.inactive == 1) {
      this.setState({ isLoading: true });
      localStorage.removeItem("overviewDocument");
      callApi("POST", "general_details.php", state)
        .then((res) => res.data)
        .then((response) => {
          delete state.base;
          delete state.categories;
          delete state.state;
          delete state.measure_details;
          delete state.measurement_list;
          delete state.survey_details;
          delete state.numPages;
          delete state.pageNumber;
          delete state.delete_items_survey;
          delete state.delete_items_measure;
          delete state.delete_items_measure_label;
          delete state.delete_items_schedule;
          // this.props.goToTab("step2");
          this.setState({ isLoading: false }, () => {
            this.getGeneralDetail();
            if (isVerifyFlow) {
              ToastsStore.success(
                "Changes saved Successfully.\nRedirecting to Verify Details",
              );
              setTimeout(() => {
                window.history.back();
              }, 3000);
            } else {
              if (state.status == 1) {
                ToastsStore.success(
                  "Changes saved Successfully.\nRedirecting to Verify Details",
                );
              } else {
                this.props.history.push(
                  "/work-file/2/" + this.props.match.params.id,
                );
              }
            }
          });
        })
        .catch((err) => {
          console.log(err);
          this.setState({ isLoading: false });
        });
    } else {
      const schedule = state.schedules?.[0];
      const surveyDetails = schedule?.survey_details?.[0];
      const boundaryDetails = surveyDetails?.boundary_details?.[0];
      if (this.state.editorMode == true) {
        if (address == "") {
          this.setState({ required: true });
          ToastsStore.error("Required fields are Empty");
          return;
        }
        this.setState({ isLoading: true });
        localStorage.removeItem("overviewDocument");
        callApi("POST", "general_details.php", state)
          .then((res) => res.data)
          .then((response) => {
            // this.props.goToTab("step2");
            this.setState({ isLoading: false }, () => {
              this.getGeneralDetail();
              if (status == 1 && this.state.editorMode) {
                this.setState({ editorSave: true });
              }
              if (isVerifyFlow) {
                ToastsStore.success(
                  "Changes saved Successfully.\nRedirecting to Verify Details",
                );
                setTimeout(() => {
                  window.history.back();
                }, 3000);
              } else {
                if (state.status == 1 && state.editorSave == false) {
                  ToastsStore.success(
                    "Changes saved Successfully.\nRedirecting to Verify Details",
                  );
                } else if (state.status == 1 && state.editorSave == true) {
                  ToastsStore.success("saved Successfully.");
                } else {
                  this.props.history.push(
                    "/work-file/2/" + this.props.match.params.id,
                  );
                }
              }
            });
          })
          .catch((err) => {
            console.log(err);
            this.setState({ isLoading: false });
          });
      } else if (natureDoc == "appartment") {
        if (
          flatNo == "" ||
          floorNo == "" ||
          natureDoc == "" ||
          apptName == "" ||
          buildupArea == "" ||
          builtupUnit == "" ||
          uds == "" ||
          udsUnit == "" ||
          remark == "" ||
          address == "" ||
          natureDoc == "" ||
          !boundaryDetails ||
          boundaryDetails.land_aries == "" ||
          boundaryDetails.direction == "" ||
          boundaryDetails.unit == "" ||
          boundaryDetails.north == "" ||
          boundaryDetails.south == "" ||
          boundaryDetails.west == "" ||
          boundaryDetails.east == ""
        ) {
          this.setState({ required: true });
          ToastsStore.error("Required fields are Empty");
        } else {
          if (surveyDetails?.survey_type === "ts_no") {
            if (
              surveyDetails.ts_no === "" ||
              surveyDetails.ward === "" ||
              surveyDetails.block === "" ||
              surveyDetails.extent === "" ||
              surveyDetails.sur_extent_unit === ""
            ) {
              // if (state.schedules[0].survey_details[0].ts_no == "" || state.schedules[0].survey_details[0].extent == "" || state.schedules[0].survey_details[0].sur_extent_unit == "") {
              this.setState({ required: true });
              ToastsStore.error("Required fields are Empty");
            } else {
              this.callGeneralDetails(state, isVerifyFlow);
            }
          } else if (surveyDetails?.survey_type === "natham_survey_no") {
            // else if (state.schedules[0].survey_details[0].survey_type == "natham_survey_no") {
            if (
              surveyDetails.natham_survey_no === "" ||
              surveyDetails.extent === "" ||
              surveyDetails.sur_extent_unit === ""
            ) {
              // if (state.schedules[0].survey_details[0].natham_survey_no == "" || state.schedules[0].survey_details[0].extent == "" || state.schedules[0].survey_details[0].sur_extent_unit == "") {
              this.setState({ required: true });
              ToastsStore.error("Required fields are Empty");
            } else {
              this.callGeneralDetails(state, isVerifyFlow);
            }
          } else if (surveyDetails?.survey_type === "survey_no") {
            // else if (state.schedules[0].survey_details[0].survey_type == "survey_no") {
            if (
              surveyDetails.survey_no === "" ||
              surveyDetails.extent === "" ||
              surveyDetails.sur_extent_unit === ""
            ) {
              // if (state.schedules[0].survey_details[0].survey_no == "" || state.schedules[0].survey_details[0].extent == "" || state.schedules[0].survey_details[0].sur_extent_unit == "") {
              this.setState({ required: true });
              ToastsStore.error("Required fields are Empty");
            } else {
              this.callGeneralDetails(state, isVerifyFlow);
            }
          } else {
            this.setState({ required: true });
            ToastsStore.error("Required fields are Empty");
          }
        }
      } else if (natureDoc == "Agri") {
        if (remark == "" || address == "" || natureDoc == "") {
          this.setState({ required: true });
          ToastsStore.error("Required fields are Empty");
        }
        // if (state.schedules[0].survey_details[0].survey_type == "ts_no") {
        else if (surveyDetails?.survey_type === "ts_no") {
          if (
            surveyDetails.ts_no === "" ||
            surveyDetails.ward === "" ||
            surveyDetails.block === "" ||
            surveyDetails.extent === "" ||
            surveyDetails.sur_extent_unit === ""
          ) {
            // if (state.schedules[0].survey_details[0].ts_no == "" || state.schedules[0].survey_details[0].ward == "" || state.schedules[0].survey_details[0].block == "" || state.schedules[0].survey_details[0].extent == "" || state.schedules[0].survey_details[0].sur_extent_unit == "") {

            this.setState({ required: true });
            ToastsStore.error("Required fields are Empty");
          } else {
            this.callGeneralDetails(state, isVerifyFlow);
          }
        } else if (surveyDetails?.survey_type === "natham_survey_no") {
          //  else if (state.schedules[0].survey_details[0].survey_type == "natham_survey_no") {
          if (
            surveyDetails.natham_survey_no === "" ||
            surveyDetails.extent === "" ||
            surveyDetails.sur_extent_unit === ""
          ) {
            // if (state.schedules[0].survey_details[0].natham_survey_no == "" || state.schedules[0].survey_details[0].extent == "" || state.schedules[0].survey_details[0].sur_extent_unit == "") {
            this.setState({ required: true });
            ToastsStore.error("Required fields are Empty");
          } else {
            this.callGeneralDetails(state, isVerifyFlow);
          }
        } else if (surveyDetails?.survey_type === "survey_no") {
          // else if (state.schedules[0].survey_details[0].survey_type == "survey_no") {
          if (
            surveyDetails.survey_no === "" ||
            surveyDetails.extent === "" ||
            surveyDetails.sur_extent_unit === ""
          ) {
            // if (state.schedules[0].survey_details[0].survey_no == "" || state.schedules[0].survey_details[0].extent == "" || state.schedules[0].survey_details[0].sur_extent_unit == "") {
            this.setState({ required: true });
            ToastsStore.error("Required fields are Empty");
          } else {
            this.callGeneralDetails(state, isVerifyFlow);
          }
        } else {
          this.setState({ required: true });
          ToastsStore.error("Required fields are Empty");
        }
      } else {
        if (
          remark === "" ||
          address === "" ||
          natureDoc === "" ||
          !boundaryDetails || // Ensure boundaryDetails exists
          boundaryDetails.land_aries === "" ||
          boundaryDetails.direction === "" ||
          boundaryDetails.unit === "" ||
          boundaryDetails.north === "" ||
          boundaryDetails.south === "" ||
          boundaryDetails.west === "" ||
          boundaryDetails.east === ""
        ) {
          this.setState({ required: true });
          ToastsStore.error("Required fields are Empty");
        }
        // if (remark == "" || address == "" || natureDoc == "" || (state.schedules[0]?.survey_details && state.schedules[0]?.survey_details[0]?.boundary_details[0]?.land_aries == "" || state.schedules[0]?.survey_details[0]?.boundary_details[0]?.direction == "" || state.schedules[0]?.survey_details[0]?.boundary_details[0]?.unit == "" || state.schedules[0]?.survey_details[0]?.boundary_details[0]?.north == "" || state.schedules[0]?.survey_details[0]?.boundary_details[0]?.south == "" || state.schedules[0]?.survey_details[0]?.boundary_details[0]?.west == "" || state.schedules[0]?.survey_details[0]?.boundary_details[0]?.east == "")) {
        // if (state.schedules[0]?.survey_details[0]?.survey_type == "ts_no") {
        else if (surveyDetails?.survey_type === "ts_no") {
          if (
            surveyDetails.ts_no === "" ||
            surveyDetails.ward === "" ||
            surveyDetails.block === "" ||
            surveyDetails.extent === "" ||
            surveyDetails.sur_extent_unit === ""
          ) {
            // if (state.schedules[0]?.survey_details[0]?.ts_no == "" || state.schedules[0]?.survey_details[0]?.ward == "" || state.schedules[0]?.survey_details[0]?.block == "" || state.schedules[0]?.survey_details[0]?.extent == "" || state.schedules[0]?.survey_details[0]?.sur_extent_unit == "") {
            this.setState({ required: true });
            ToastsStore.error("Required fields are Empty");
          } else {
            this.callGeneralDetails(state, isVerifyFlow);
          }
        } else if (surveyDetails?.survey_type === "natham_survey_no") {
          //  else if (state.schedules[0]?.survey_details[0]?.survey_type == "natham_survey_no") {
          if (
            surveyDetails.natham_survey_no === "" ||
            surveyDetails.extent === "" ||
            surveyDetails.sur_extent_unit === ""
          ) {
            // if (state.schedules[0]?.survey_details[0]?.natham_survey_no == "" || state.schedules[0]?.survey_details[0]?.extent == "" || state.schedules[0]?.survey_details[0]?.sur_extent_unit == "") {
            this.setState({ required: true });
            ToastsStore.error("Required fields are Empty");
          } else {
            this.callGeneralDetails(state, isVerifyFlow);
          }
        } else if (surveyDetails?.survey_type === "survey_no") {
          // else if (state.schedules[0]?.survey_details[0]?.survey_type == "survey_no") {
          if (
            surveyDetails.survey_no === "" ||
            surveyDetails.extent === "" ||
            surveyDetails.sur_extent_unit === ""
          ) {
            // if (state.schedules[0]?.survey_details[0]?.survey_no == "" || state.schedules[0]?.survey_details[0]?.extent == "" || state.schedules[0]?.survey_details[0]?.sur_extent_unit == "") {
            this.setState({ required: true });

            ToastsStore.error("Required fields are Empty");
          } else {
            this.callGeneralDetails(state, isVerifyFlow);
          }
        } else {
          this.setState({ required: true });
          ToastsStore.error("Required fields are Empty");
        }
      }
    }
  };

  callGeneralDetails = (state, isVerifyFlow) => {
    this.setState({ isLoading: true });
    localStorage.removeItem("overviewDocument");
    callApi("POST", "general_details.php", state)
      .then((res) => res.data)
      .then((response) => {
        // this.props.goToTab("step2");
        this.setState({ isLoading: false }, () => {
          this.getGeneralDetail();
          if (isVerifyFlow) {
            ToastsStore.success(
              "Changes saved Successfully.\nRedirecting to Verify Details",
            );
            setTimeout(() => {
              window.history.back();
            }, 3000);
          } else {
            if (state.status == 1) {
              ToastsStore.success(
                "Changes saved Successfully.\nRedirecting to Verify Details",
              );
            } else {
              this.props.history.push(
                "/work-file/2/" + this.props.match.params.id,
              );
            }
          }
        });
      })
      .catch((err) => {
        console.log(err);
        this.setState({ isLoading: false });
      });
  };

  onModifyTotalExtent = () => {
    if (this.state.total_extent && this.state.extent_unit) {
      callApi("POST", "general_total_extent.php", {
        file_id: this.props.match.params.id,
        doc_id: this.props.match.params.docid,
        total_extent: this.state.total_extent,
        extent_unit: this.state.extent_unit,
      })
        .then((res) => res.data)
        .then((response) => {
          if (response.result) {
            ToastsStore.success(response.message);
          } else {
            ToastsStore.error(response.message);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };
  viewDocument = (e) => {
    // this.getAllDocuments();
    const selectedValue = e?.target?.value;
    const selectedIndex = e?.target?.options?.selectedIndex;
    const selectedId = e?.target?.options?.[selectedIndex]
      ?.getAttribute("data-id")
      ?.split("|")?.[0];
    if (selectedId) {
      callApi("POST", "getbaseby_id.php", { id: selectedId })
        .then((res) => res.data)
        .then((response) => {
          if (response.data && response.data.length) {
            const document = this.document;
            if (
              response.data &&
              response.data?.[0]?.base &&
              response.data[0].base?.length > 0
            ) {
              document.base = response.data[0].base[0].base;
            }
            this.setState({ ...document, selectedDoc: selectedValue });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };
  questionHandleChange = (e) => {
    const list: any[] = this.state.qaList;
    // list[i]['question'] = e;
    this.setState({
      isEdited: true,
      qaList: list,
    });
  };
  handleChangeNormal = (e) => {
    if (this.state.showNormalModeCheckBox == true) {
      this.state.normalMode = !this.state.normalMode;
      this.state.editorMode = !this.state.editorMode;
    }
  };
  previewDocument = () => {
    var docOverview = localStorage.getItem("overviewDocument");
    if (this.props.match.params.id == localStorage.getItem("currentFile")) {
      if (docOverview != null) {
        this.setState({
          docReportForPreview: docOverview,
          enableRefresh: true,
        });
        this.setState({ isDocPreviewLoading: false });
      } else {
        this.setState({ isDocPreviewLoading: true });
        const user: any = localStorage.getItem("user");
        const userId = user ? JSON.parse(user)["userId"] : "";
        callApi("POST", "template/tests/scrutiny_report.php", {
          file_idfk: this.props.match.params.id,
          check: false,
          userId,
        })
          .then((res) => res.data)
          .then((response) => {
            if (response && response.data) {
              localStorage.setItem("overviewDocument", response.data);
              var currentFile = response.file_name.split("-");
              localStorage.setItem("currentFile", currentFile[1]);
              this.setState({ docReportForPreview: response.data });
            }
          })
          .finally(() => this.setState({ isDocPreviewLoading: false }));
      }
    } else {
      this.setState({ isDocPreviewLoading: true });
      const user: any = localStorage.getItem("user");
      const userId = user ? JSON.parse(user)["userId"] : "";
      callApi("POST", "template/tests/scrutiny_report.php", {
        file_idfk: this.props.match.params.id,
        check: false,
        userId,
      })
        .then((res) => res.data)
        .then((response) => {
          if (response && response.data) {
            localStorage.setItem("overviewDocument------->>>", response.data);
            var currentFile = response.file_name.split("-");
            localStorage.setItem("currentFile", currentFile[1]);
            this.setState({ docReportForPreview: response.data });
          }
        })
        .finally(() => this.setState({ isDocPreviewLoading: false }));
    }
  };
  rotate = () => {
    let newRotation = this.state.rotation + 90;
    if (newRotation >= 360) {
      newRotation = -360;
    }
    this.setState({ rotation: newRotation });
  };
  onHighlightsChange = (highlights) => {
    this.setState({ highlights });
  };
  setContent(e) {
    // this.setState({ editorcontent: e });

    // Sanitize and remove specific tags like <em>
    const cleanHTML = DOMPurify.sanitize(e, {
      FORBID_TAGS: ["em"], // Forbid <em> tag but allow other safe tags
    });

    // Set the sanitized HTML content in state
    this.setState({ editorcontent: cleanHTML });
  }
  updatedRemainingTime(time) {}
  saveMergeSOP = () => {
    this.setState({ isMergeLoading: true });
    const { isMergeWithSOP, this_doc_no, title_doc_no } = this.state;
    let obj = {
      isMergeWithSOP: isMergeWithSOP,
      this_doc_no: this_doc_no,
      title_doc_no: title_doc_no,
      fod_fk: this.props.match.params.docid,
      file_idfk: this.props.match.params.id,
    };
    callApi("POST", "merge_SOP.php", obj)
      .then((res) => res.data)
      .then((response) => {
        if (response.result == true) {
          this.setState({ isMergeLoading: false });
          ToastsStore.success(response.message);
        } else {
          ToastsStore.error(response.message);
        }
      });
  };
  render() {
    const {
      rotation,
      velocityEqualToMove,
      enableVelocity,
      highlights,
      isHightlightsLoaded,
      base,
      docToPreview,
      loader,
      timer,
    } = this.state;
    const HaskKey = this.props.location.state?.hash || "";
    let isVerifyFlow: any = HaskKey.includes("Verify");
    if (isVerifyFlow) {
      localStorage.setItem("isVerifyFlow", JSON.stringify(isVerifyFlow));
    } else {
      isVerifyFlow = localStorage.getItem("isVerifyFlow");
    }
    const takenfile_id: any = localStorage.getItem("takenfile_id");
    const currentfile_Id: any = localStorage.getItem("currentfileId");
    const currentfile = JSON.parse(currentfile_Id);
    let takenfile = null;
    if (takenfile_id) {
      try {
        takenfile = JSON.parse(takenfile_id);
      } catch (error) {
        console.error("Error parsing takenfile_id JSON:", error);
      }
    }
    const user: any = localStorage.getItem("user");
    const roletype = user ? JSON.parse(user)["roleType"] : "";
    let initialTimeInMinutes: any = localStorage.getItem(
      "updatedRemainingTime",
    );

    const options = Array.isArray(this.state?.titleDocuments)
      ? this.state.titleDocuments.map((opt: any) => ({
          label: opt.id,
          value: opt.id,
        }))
      : []; // Default to an empty array if titleDocuments is not an array

    const selectedValues = Array.isArray(this.state.title_doc_no)
      ? this.state.title_doc_no.map((id) =>
          options.find((option) => option.value === id),
        )
      : []; // Default to an empty array if title_doc_no is not an array

    return (
      <>
        <div className="pcoded-content">
          <ToastsContainer
            store={ToastsStore}
            position={ToastsContainerPosition.TOP_RIGHT}
          />

          <div className="pcoded-inner-content">
            <div className="main-body">
              <div className="page-wrapper">
                <div className="row">
                  <div className="col-sm-12">
                    <div className="card">
                      <div
                        className="card-header"
                        style={{ padding: "11px", fontWeight: 900 }}
                      >
                        <div className="row">
                          <div className="col-md-12">
                            {initialTimeInMinutes &&
                              initialTimeInMinutes > 0 && (
                                <CountdownTimer
                                  initialTime={initialTimeInMinutes}
                                  updatedTime={(time) =>
                                    this.updatedRemainingTime(time)
                                  }
                                  ref={(ref) => (this.countdownTimerRef = ref)}
                                />
                              )}
                          </div>
                          <br />
                        </div>
                        <div className="d-flex justify-content-between align-items-center">
                          <span>
                            <h5>Scheduled of property</h5>
                          </span>
                          <span>
                            <button
                              className="btn btn-primary"
                              onClick={() => {
                                window.history.back();
                              }}
                            >
                              Back
                            </button>
                          </span>
                        </div>
                      </div>
                      <div className="card-body">
                        <div id="step-1">
                          <h5>General Detail</h5>
                          {/* <Link
                            to={"/query/add/0/" + this.props.match.params.id}
                            style={{ marginTop: "-42px" }}
                            className="btn btn-square btn-info float-right"
                          >
                            Raise Query
                          </Link> */}
                          {/* <button
                            data-toggle="modal"
                            data-target="#doc-preview"
                            onClick={this.previewDocument}
                            style={{ marginTop: "-42px", backgroundColor: '#b21fc6', color: "#fff" }}
                            className="btn btn-square btn-default float-right"
                          >
                            Document Preview
                          </button> */}
                          <hr />
                          <div className="row">
                            <Resizable
                              id="frame"
                              className="box"
                              height={this.state.documentHeight}
                              width={this.state.documentWidth}
                              onResize={this.onDocumentResize}
                              resizeHandles={["e"]}
                            >
                              <div
                                style={{
                                  overflow: "auto",
                                  marginRight: "0",
                                  maxWidth: "60%",
                                  minWidth: "40%",
                                  float: "left",
                                  width: this.state.documentWidth + "%",
                                }}
                              >
                                <div className="container">
                                  <div
                                    className="row"
                                    style={{
                                      width: "100%",
                                      border: "1px solid #e2e5e8",
                                      borderRadius: "10px",
                                      margin: "auto",
                                      padding: "7px",
                                    }}
                                  >
                                    <div className="col-md-4">
                                      <label>Document</label>
                                      {this.state.allDocuments &&
                                        this.state.allDocuments.length > 0 &&
                                        this.state.allDocuments.map(
                                          (opt: any) => {
                                            // opt.label = opt.status ? `Document-${opt.id}-${opt.status}` : `Document-${opt.id}`;
                                            opt.label =
                                              opt.id +
                                              (opt.status == 1
                                                ? "- (Not Related)"
                                                : "");
                                            opt.value = opt.base_id;
                                          },
                                        ) && (
                                          <select
                                            className="custom-select"
                                            name="selectedDoc"
                                            value={this.state.selectedDoc}
                                            onChange={this.viewDocument}
                                            required
                                          >
                                            <option value="">Select</option>
                                            {this.state.allDocuments &&
                                            this.state.allDocuments.length
                                              ? this.state.allDocuments.map(
                                                  (doc: any, index: number) => {
                                                    return (
                                                      <option
                                                        key={`${doc.id}|${index}`}
                                                        data-id={`${doc.value}|${index}`}
                                                        value={this.state.allDocuments.find(
                                                          (o: any) =>
                                                            o.value ===
                                                            this.state
                                                              .selectedDoc,
                                                        )}
                                                      >
                                                        {doc.label}
                                                      </option>
                                                    );
                                                  },
                                                )
                                              : ""}
                                          </select>
                                        )}
                                    </div>
                                    <div
                                      className="col-md-2"
                                      style={{ marginTop: "27px" }}
                                    >
                                      <button
                                        type="button"
                                        style={{ float: "right" }}
                                        className="btn btn-warning"
                                        onClick={this.getRevenueDocs}
                                      >
                                        Original
                                      </button>
                                    </div>
                                    <div className="col-md-2">
                                      <label>Not Related Document</label>
                                      <div>
                                        <label className="switch">
                                          <input
                                            type="checkbox"
                                            checked={
                                              this.state.inactive === 1
                                                ? true
                                                : false
                                            }
                                            onChange={this.toggleDocStatus}
                                          />
                                          <span className="slider round"></span>
                                        </label>
                                      </div>
                                      <label style={{ margin: "0px 10px" }}>
                                        No/Yes
                                      </label>
                                    </div>
                                    <div className="col-md-4">
                                      <label>
                                        Merge the same title Schedule of Details
                                      </label>
                                      <div>
                                        <label className="switch">
                                          <input
                                            type="checkbox"
                                            checked={
                                              this.state.isMergeWithSOP === 1
                                                ? true
                                                : false
                                            }
                                            onChange={(e) =>
                                              this.toggleMergeSOPStatus(e)
                                            }
                                          />
                                          <span className="slider round"></span>
                                        </label>
                                      </div>
                                      <label style={{ margin: "0px 10px" }}>
                                        No/Yes
                                      </label>
                                    </div>
                                  </div>
                                  {this.state.isMergeWithSOP == 1 && (
                                    <>
                                      <div
                                        className="row"
                                        style={{
                                          width: "100%",
                                          border: "1px solid #e2e5e8",
                                          borderRadius: "10px",
                                          margin: "20px auto",
                                          padding: "15px",
                                        }}
                                      >
                                        <div className="col-md-5">
                                          <div className="form-group">
                                            <label>Title Deed Doc No</label>
                                            {/* <input
                                            className={this.state.ismergerequired && this.state.this_doc_no === '' ? 'form-control is-invalid' : 'form-control'}
                                            placeholder=""
                                            name="this_doc_no"
                                            type="text"
                                            value={this.state.this_doc_no}
                                            onChange={e => this.handleMergeSOPChange(e)}
                                          /> */}
                                            {this.state.titleDocuments &&
                                              this.state.titleDocuments.length >
                                                0 &&
                                              this.state.titleDocuments.map(
                                                (opt: any) => {
                                                  opt.label = opt.id;
                                                  opt.value = opt.id;
                                                },
                                              ) && (
                                                <Select
                                                  options={
                                                    this.state.titleDocuments
                                                  }
                                                  name="this_doc_no"
                                                  value={this.state.titleDocuments.find(
                                                    (o: any) =>
                                                      o.value ===
                                                      this.state.this_doc_no,
                                                  )}
                                                  onChange={(e) =>
                                                    this.categChange(
                                                      e,
                                                      "this_doc_no",
                                                      "singleselect",
                                                    )
                                                  }
                                                />
                                              )}
                                            <div className="invalid-feedback">
                                              *Required Field
                                            </div>
                                          </div>
                                        </div>
                                        <div className="col-md-5">
                                          <div className="form-group">
                                            <label>Merge Doc No</label>
                                            {/* <input
                                            className={this.state.ismergerequired && this.state.title_doc_no === '' ? 'form-control is-invalid' : 'form-control'}
                                            placeholder=""
                                            name="title_doc_no"
                                            type="text"
                                            value={this.state.title_doc_no}
                                            onChange={e => this.handleMergeSOPChange(e)}
                                          /> */}
                                            {this.state.titleDocuments &&
                                              this.state.titleDocuments.length >
                                                0 && (
                                                <Select
                                                  options={
                                                    this.state.titleDocuments
                                                  }
                                                  name="title_doc_no"
                                                  value={selectedValues}
                                                  isMulti
                                                  closeMenuOnSelect={false}
                                                  onChange={(e) =>
                                                    this.categChange(
                                                      e,
                                                      "title_doc_no",
                                                      "singleselect",
                                                    )
                                                  }
                                                />
                                              )}
                                            <div className="invalid-feedback">
                                              *Required Field
                                            </div>
                                          </div>
                                        </div>
                                        <div className="col-md-2 mt-1">
                                          <button
                                            className="btn btn-primary mt-4"
                                            type="button"
                                            style={{ float: "right" }}
                                            onClick={this.saveMergeSOP}
                                          >
                                            {this.state.isMergeLoading ? (
                                              <>
                                                <i className="fa fa-spinner fa-spin"></i>
                                              </>
                                            ) : (
                                              <>Save</>
                                            )}
                                          </button>
                                        </div>
                                      </div>
                                    </>
                                  )}
                                  <br />
                                  <ul
                                    className="nav nav-tabs"
                                    id="myTab"
                                    role="tablist"
                                  >
                                    <li className="nav-item">
                                      <a
                                        className="nav-link active"
                                        id="old-view-tab"
                                        data-toggle="tab"
                                        href="#old-viewer"
                                        role="tab"
                                        aria-controls="home"
                                        aria-selected="true"
                                      >
                                        Old Viewer
                                      </a>
                                    </li>
                                    <li className="nav-item">
                                      <a
                                        className="nav-link"
                                        id="new-view-tab"
                                        data-toggle="tab"
                                        href="#new-viewer"
                                        role="tab"
                                        aria-controls="profile"
                                        aria-selected="false"
                                        onClick={() =>
                                          this.setState({ docToPreview: true })
                                        }
                                      >
                                        New Viewer
                                      </a>
                                    </li>
                                  </ul>
                                  {loader ? (
                                    <>
                                      <Spinner />
                                      <div className="text-center">
                                        <h4
                                          style={{
                                            marginTop: "49%",
                                            marginLeft: "90px",
                                          }}
                                        >
                                          <span>Please wait...{timer}</span>
                                        </h4>
                                      </div>
                                    </>
                                  ) : (
                                    <div
                                      className="tab-content"
                                      id="tab-content"
                                      style={{
                                        borderBottomRightRadius: "10px",
                                        borderBottomLeftRadius: "10px",
                                      }}
                                    >
                                      <div
                                        className="tab-pane fade show active"
                                        id="old-viewer"
                                        role="tabpanel"
                                        aria-labelledby="old-viewer"
                                      >
                                        <iframe
                                          src={this.document.base}
                                          width="100%"
                                          height={this.state.documentHeight}
                                        />
                                      </div>
                                      <div
                                        className="tab-pane fade"
                                        id="new-viewer"
                                        role="tabpanel"
                                        aria-labelledby="new-viewer"
                                      >
                                        <p style={{ color: "red" }}>
                                          NOTE: TO HIGHLIGHT [ ALT + RIGHT CLICK
                                          ON MOUSE AND DRAG ]
                                        </p>
                                        <br />
                                        <div
                                          className="App"
                                          style={{
                                            display: "flex",
                                            height: "820px",
                                          }}
                                        >
                                          <TransformWrapper
                                            pan={{
                                              disabled: true,
                                              velocityEqualToMove,
                                              velocity: enableVelocity,
                                            }}
                                            wheel={{
                                              disabled: true,
                                            }}
                                          >
                                            {({
                                              zoomIn,
                                              zoomOut,
                                              resetTransform,
                                              ...rest
                                            }) => (
                                              <React.Fragment>
                                                <div className="tools">
                                                  <Rotate90DegreesCcwIcon
                                                    className="pdf-icon rotate-icon"
                                                    onClick={this.rotate}
                                                  />
                                                  <ZoomInIcon
                                                    className="pdf-icon"
                                                    onClick={zoomIn}
                                                  />
                                                  <ZoomOutIcon
                                                    className="pdf-icon"
                                                    onClick={zoomOut}
                                                  />
                                                  <FullscreenExitIcon
                                                    className="pdf-icon"
                                                    onClick={resetTransform}
                                                  />
                                                  {this.state.base &&
                                                    this.state
                                                      .isHightlightsLoaded && (
                                                      <FullscreenIcon
                                                        className="pdf-icon"
                                                        onClick={() =>
                                                          this.setState({
                                                            docToPreview: true,
                                                          })
                                                        }
                                                      />
                                                    )}
                                                </div>
                                                <TransformComponent>
                                                  <div
                                                    style={{
                                                      height: "820px",
                                                      width: "45vw",
                                                      position: "relative",
                                                      transform: `rotate(${rotation}deg)`,
                                                    }}
                                                  >
                                                    {base && !docToPreview && (
                                                      <PDFHighlighter
                                                        url={base}
                                                        onHighlightsChange={
                                                          this
                                                            .onHighlightsChange
                                                        }
                                                        highlights={highlights}
                                                      />
                                                    )}
                                                  </div>
                                                </TransformComponent>
                                              </React.Fragment>
                                            )}
                                          </TransformWrapper>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </Resizable>
                            <Resizable
                              className="box"
                              height={this.state.formHeight}
                              width={this.state.formWidth}
                              onResize={this.onFormResize}
                              resizeHandles={[]}
                            >
                              <div
                                style={{
                                  width: this.state.formWidth + "%",
                                  height: this.state.formHeight + "px",
                                }}
                              >
                                <div
                                  className="row"
                                  style={{
                                    width: "100%",
                                    border: "1px solid #e2e5e8",
                                    borderRadius: "10px",
                                    margin: "auto",
                                    padding: "7px",
                                    height: "19%",
                                  }}
                                >
                                  <div className="col-md-9">
                                    <label>Category</label>
                                    {this.state.categories &&
                                      this.state.categories.length > 0 &&
                                      this.state.categories.map((opt: any) => {
                                        opt.label = opt.name;
                                        opt.value = opt.id;
                                      }) && (
                                        <Select
                                          options={this.state.categories}
                                          name="type"
                                          style={{ marginTop: "-2px" }}
                                          value={this.state.categories.find(
                                            (o: any) =>
                                              o.value === this.state.type,
                                          )}
                                          onChange={(e) =>
                                            this.categChange(
                                              e,
                                              "type",
                                              "singleselect",
                                            )
                                          }
                                        />
                                      )}
                                  </div>
                                  <div
                                    className="col-md-2"
                                    style={{ marginTop: "21px" }}
                                  >
                                    <button
                                      className="btn btn-primary sw-btn-next"
                                      type="button"
                                      onClick={() =>
                                        this.FileTypeWithConfirmation()
                                      }
                                    >
                                      Confirm
                                    </button>
                                  </div>
                                </div>
                                <div className="row">
                                  <div className="col-md-3">
                                    {this.state.showNormalModeCheckBox && (
                                      <>
                                        <div className="form-group">
                                          <label
                                            style={{
                                              textAlign: "center",
                                              display: "block",
                                            }}
                                          >
                                            Normal Mode
                                          </label>
                                          <input
                                            style={{ fontSize: "10px" }}
                                            className="form-control cursor-pointer"
                                            name="normalMode"
                                            type="checkbox"
                                            checked={this.state.normalMode}
                                            onChange={this.handleChangeNormal}
                                          />
                                        </div>
                                      </>
                                    )}
                                  </div>
                                  <div className="col-md-6"></div>
                                  <div className="col-md-3">
                                    <div className="form-group">
                                      <label
                                        style={{
                                          textAlign: "center",
                                          display: "block",
                                        }}
                                      >
                                        Editor Mode
                                      </label>
                                      <input
                                        style={{ fontSize: "10px" }}
                                        className="form-control border-0 cursor-pointer"
                                        name="editorMode"
                                        type="checkbox"
                                        checked={this.state.editorMode}
                                        onChange={this.handleChangeNormal}
                                      />
                                    </div>
                                  </div>
                                </div>
                                {this.state.editorMode == true && (
                                  <>
                                    <SunEditor
                                      autoFocus={true}
                                      width="100%"
                                      height="850px"
                                      setOptions={{
                                        buttonList: [
                                          // default
                                          ["undo", "redo"],
                                          ["bold", "underline"],
                                          ["table"],
                                          //  ["link", "image"],
                                          ["fullScreen"],
                                        ],
                                      }}
                                      setContents={this.state.editorcontent}
                                      onChange={(e) => this.setContent(e)}
                                    />
                                    {this.state.schedules &&
                                    this.state.schedules.length > 0
                                      ? this.state.schedules.map(
                                          (sched: ScheduleList, schIndex) => {
                                            return (
                                              <div className="row">
                                                <div className="col-md-12">
                                                  <div className="form-group">
                                                    <label>
                                                      Address
                                                      <span
                                                        style={{
                                                          color: "#FF0000",
                                                        }}
                                                      >
                                                        *
                                                      </span>{" "}
                                                      <span className="inputEgMsg">
                                                        Village/ Town, Taluk,
                                                        Regd.District, SRO "##
                                                        Layout Name##"
                                                      </span>
                                                    </label>
                                                    <textarea
                                                      placeholder="Eg.location, village,city, registration, sub-district etc"
                                                      className={
                                                        this.state.required &&
                                                        sched.address === ""
                                                          ? "form-control is-invalid"
                                                          : "form-control"
                                                      }
                                                      name="address"
                                                      id="address"
                                                      value={sched.address}
                                                      onChange={(e) =>
                                                        this.handleChange(
                                                          e,
                                                          schIndex,
                                                        )
                                                      }
                                                      aria-required="true"
                                                    />
                                                    <div className="invalid-feedback">
                                                      This is a required field,
                                                      kindly add property
                                                      Address here.
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            );
                                          },
                                        )
                                      : ""}
                                  </>
                                )}
                                {/* <div>{content}</div>
                                  <button onClick={() => onSubmit(content)}>Submit</button> */}
                                {this.state.normalMode == true && (
                                  <div
                                    style={{
                                      width: "100%",
                                      border: "1px solid #e2e5e8",
                                      borderRadius: "10px",
                                      margin: "auto",
                                      marginTop: "24px",
                                      maxHeight: "200%",
                                      height: "152%",
                                      maxWidth: "150%",
                                    }}
                                  >
                                    <div className="row">
                                      {/* <div className="col-md-4">
                                        <div className="form-group">
                                          <label>Total Extent</label>
                                          <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Enter Total Extent"
                                            name="total_extent"
                                            value={this.state.total_extent}
                                            onChange={e => this.categChange(e)}
                                          />
                                        </div>
                                      </div>
                                      <div className="col-md-3">
                                        <div className="form-group">
                                          <label style={{ width: "300px" }}>Select Unit <span className="inputEgMsg">Eg.434 Sq.Meter / Sq.Yards Etc...</span></label>
                                          {this.state.extentUnits && this.state.extentUnits.length > 0 && this.state.extentUnits.map((opt: any) => { opt.label = opt.name; opt.value = opt.id }) &&
                                            <Select options={this.state.extentUnits} name="extent_unit"
                                              value={this.state.extentUnits.find((o: any) => o.value === this.state.extent_unit)}
                                              onChange={(e) => this.categChange(e, "extent_unit", 'singleselect')}
                                            />
                                          }
                                        </div>
                                      </div>
                                      <div
                                        className="col-md-1"
                                        style={{ margin: "23px 0px 0px -13px" }}
                                      >
                                        <button
                                          className="btn btn-primary sw-btn-next"
                                          type="button"
                                          onClick={() => this.onModifyTotalExtent()}
                                        >
                                          Modify
                                        </button>
                                      </div> */}
                                      <div
                                        className="col-md-12"
                                        style={{
                                          marginTop: "10px",
                                          float: "right",
                                        }}
                                      >
                                        <a
                                          className="btn btn-primary"
                                          onClick={this.addItem}
                                          style={{
                                            float: "right",
                                          }}
                                        >
                                          + Add Schedule
                                        </a>
                                      </div>
                                    </div>
                                    <hr />
                                    <div
                                      className="form-document"
                                      style={{ maxHeight: "840px" }}
                                    >
                                      {this.state.schedules &&
                                      this.state.schedules.length > 0
                                        ? this.state.schedules.map(
                                            (sched: ScheduleList, schIndex) => {
                                              return (
                                                <div
                                                  className="sec_measurement"
                                                  style={{
                                                    border:
                                                      "5px solid rgb(204, 204, 204)",
                                                    padding: "10px",
                                                    borderRadius: "10px",
                                                    width: "99%",
                                                    margin: "auto",
                                                  }}
                                                  key={schIndex}
                                                >
                                                  <Accordion defaultActiveKey="0">
                                                    <Card
                                                      style={{
                                                        borderRadius: "10px",
                                                      }}
                                                    >
                                                      <Accordion.Toggle
                                                        as={Card.Header}
                                                        eventKey="0"
                                                        onClick={() =>
                                                          this.collapsearray(
                                                            sched,
                                                            schIndex,
                                                          )
                                                        }
                                                        className="card-border-c-green"
                                                      >
                                                        <div className="row">
                                                          <div
                                                            className="col-md-9"
                                                            style={{
                                                              paddingTop: "6px",
                                                            }}
                                                          >
                                                            <h2>
                                                              {sched.collapseid ? (
                                                                <i className="fa fa-angle-down rotate-icon"></i>
                                                              ) : (
                                                                <i className="fa fa-angle-up rotate-icon"></i>
                                                              )}
                                                              &nbsp;&nbsp;
                                                              Schedule -{" "}
                                                              {schIndex + 1}
                                                            </h2>
                                                          </div>
                                                          <div className="col-md-3">
                                                            <button
                                                              style={{
                                                                float: "right",
                                                                marginTop:
                                                                  "2px",
                                                                paddingTop:
                                                                  "8px",
                                                              }}
                                                              type="button"
                                                              className="btn btn-icon btn-rounded btn-danger"
                                                              disabled={
                                                                this.state
                                                                  .schedules
                                                                  .length === 1
                                                              }
                                                              onClick={() =>
                                                                this.removeItem(
                                                                  sched,
                                                                  schIndex,
                                                                )
                                                              }
                                                            >
                                                              <i className="feather icon-minus"></i>
                                                            </button>
                                                          </div>
                                                        </div>
                                                      </Accordion.Toggle>
                                                      <Accordion.Collapse eventKey="0">
                                                        <Card.Body>
                                                          <div className="row">
                                                            <div className="col-md-12">
                                                              <div
                                                                className="form-group"
                                                                style={{
                                                                  float: "left",
                                                                }}
                                                              >
                                                                <label>
                                                                  As Per Patta
                                                                  Extract
                                                                </label>
                                                                <input
                                                                  className="form-control"
                                                                  name="scheduleasper"
                                                                  type="checkbox"
                                                                  checked={
                                                                    sched.scheduleasper ==
                                                                    "As Per Patta"
                                                                      ? true
                                                                      : false
                                                                  }
                                                                  onChange={(
                                                                    e,
                                                                  ) =>
                                                                    this.handleChange(
                                                                      e,
                                                                      schIndex,
                                                                    )
                                                                  }
                                                                  required
                                                                />
                                                              </div>
                                                            </div>
                                                          </div>
                                                          <div
                                                            className="row"
                                                            style={{
                                                              marginTop: "-9px",
                                                            }}
                                                          >
                                                            <div className="col-md-12">
                                                              <div className="form-group">
                                                                <label>
                                                                  Nature of
                                                                  property
                                                                  <span
                                                                    style={{
                                                                      color:
                                                                        "#FF0000",
                                                                    }}
                                                                  >
                                                                    *
                                                                  </span>{" "}
                                                                  <span className="inputEgMsg">
                                                                    Eg. Agri /
                                                                    Existing
                                                                    Building /
                                                                    Under
                                                                    Construction
                                                                    / Vacant
                                                                    Land /
                                                                    Appartment
                                                                  </span>
                                                                </label>
                                                                {this.state
                                                                  .nature_docs &&
                                                                  this.state
                                                                    .nature_docs
                                                                    .length >
                                                                    0 &&
                                                                  this.state.nature_docs.map(
                                                                    (
                                                                      opt: any,
                                                                    ) => {
                                                                      opt.label =
                                                                        opt.name;
                                                                      opt.value =
                                                                        opt.id;
                                                                    },
                                                                  ) && (
                                                                    <Select
                                                                      options={
                                                                        this
                                                                          .state
                                                                          .nature_docs
                                                                      }
                                                                      name="nature_doc"
                                                                      className={
                                                                        this
                                                                          .state
                                                                          .required &&
                                                                        sched.nature_doc ===
                                                                          ""
                                                                          ? "form-select is-invalid"
                                                                          : "form-select"
                                                                      }
                                                                      value={this.state.nature_docs.find(
                                                                        (
                                                                          o: any,
                                                                        ) =>
                                                                          o.value ===
                                                                          sched.nature_doc,
                                                                      )}
                                                                      onChange={(
                                                                        e,
                                                                      ) =>
                                                                        this.handleChange(
                                                                          e,
                                                                          schIndex,
                                                                          "nature_doc",
                                                                          "singleselect",
                                                                        )
                                                                      }
                                                                    />
                                                                  )}
                                                                <div className="invalid-feedback">
                                                                  This is a
                                                                  required
                                                                  field, kindly
                                                                  add Total
                                                                  Extent here.
                                                                </div>
                                                              </div>
                                                            </div>
                                                          </div>
                                                          {sched.nature_doc ===
                                                            "Agri" && (
                                                            <>
                                                              <div className="row">
                                                                <div className="col-md-5">
                                                                  <div className="form-group">
                                                                    <label>
                                                                      Total
                                                                      Extent
                                                                    </label>
                                                                    <input
                                                                      type="text"
                                                                      className="form-control"
                                                                      placeholder="Enter Total Extent"
                                                                      name="total_extent"
                                                                      value={
                                                                        this
                                                                          .state
                                                                          .total_extent
                                                                      }
                                                                      onChange={(
                                                                        e,
                                                                      ) =>
                                                                        this.categChange(
                                                                          e,
                                                                        )
                                                                      }
                                                                    />
                                                                  </div>
                                                                </div>
                                                                <div className="col-md-5">
                                                                  <div className="form-group">
                                                                    <label
                                                                      style={{
                                                                        width:
                                                                          "300px",
                                                                      }}
                                                                    >
                                                                      Select
                                                                      Unit{" "}
                                                                      <span className="inputEgMsg">
                                                                        Eg.434
                                                                        Sq.Meter
                                                                        /
                                                                        Sq.Yards
                                                                        Etc...
                                                                      </span>
                                                                    </label>
                                                                    {this.state
                                                                      .extentUnits &&
                                                                      this.state
                                                                        .extentUnits
                                                                        .length >
                                                                        0 &&
                                                                      this.state.extentUnits.map(
                                                                        (
                                                                          opt: any,
                                                                        ) => {
                                                                          opt.label =
                                                                            opt.name;
                                                                          opt.value =
                                                                            opt.id;
                                                                        },
                                                                      ) && (
                                                                        <Select
                                                                          options={
                                                                            this
                                                                              .state
                                                                              .extentUnits
                                                                          }
                                                                          name="extent_unit"
                                                                          value={this.state.extentUnits.find(
                                                                            (
                                                                              o: any,
                                                                            ) =>
                                                                              o.value ===
                                                                              this
                                                                                .state
                                                                                .extent_unit,
                                                                          )}
                                                                          onChange={(
                                                                            e,
                                                                          ) =>
                                                                            this.categChange(
                                                                              e,
                                                                              "extent_unit",
                                                                              "singleselect",
                                                                            )
                                                                          }
                                                                        />
                                                                      )}
                                                                  </div>
                                                                </div>
                                                                <div
                                                                  className="col-md-2"
                                                                  style={{
                                                                    margin:
                                                                      "23px 0px 0px -13px",
                                                                  }}
                                                                >
                                                                  <button
                                                                    className="btn btn-primary sw-btn-next"
                                                                    type="button"
                                                                    onClick={() =>
                                                                      this.onModifyTotalExtent()
                                                                    }
                                                                  >
                                                                    Save
                                                                  </button>
                                                                </div>
                                                              </div>
                                                            </>
                                                          )}
                                                          {sched.nature_doc ===
                                                            "Existing building" && (
                                                            <>
                                                              <div className="row">
                                                                <div className="col-md-12">
                                                                  <div className="form-group">
                                                                    <label>
                                                                      Door No
                                                                    </label>
                                                                    <input
                                                                      className="form-control"
                                                                      placeholder="Maximum 100 Characters"
                                                                      id="door_no"
                                                                      name="door_no"
                                                                      type="text"
                                                                      value={
                                                                        sched.door_no
                                                                      }
                                                                      onChange={(
                                                                        e,
                                                                      ) =>
                                                                        this.handleChange(
                                                                          e,
                                                                          schIndex,
                                                                        )
                                                                      }
                                                                      required
                                                                    />
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            </>
                                                          )}
                                                          {sched.nature_doc ===
                                                            "appartment" && (
                                                            <div className="row">
                                                              <div className="col-md-6">
                                                                <div className="form-group">
                                                                  <label>
                                                                    Flat No
                                                                    <span
                                                                      style={{
                                                                        color:
                                                                          "#FF0000",
                                                                      }}
                                                                    >
                                                                      *
                                                                    </span>
                                                                  </label>
                                                                  <input
                                                                    className={
                                                                      this.state
                                                                        .required &&
                                                                      sched.flat_no ===
                                                                        ""
                                                                        ? "form-control is-invalid"
                                                                        : "form-control"
                                                                    }
                                                                    id="flat_no"
                                                                    name="flat_no"
                                                                    type="text"
                                                                    value={
                                                                      sched.flat_no
                                                                    }
                                                                    onChange={(
                                                                      e,
                                                                    ) =>
                                                                      this.handleChange(
                                                                        e,
                                                                        schIndex,
                                                                      )
                                                                    }
                                                                  />
                                                                  <div className="invalid-feedback">
                                                                    This is a
                                                                    required
                                                                    field,
                                                                    kindly add
                                                                    Flat Number
                                                                    here.
                                                                  </div>
                                                                </div>
                                                              </div>
                                                              <div className="col-md-6">
                                                                <div className="form-group">
                                                                  <label>
                                                                    Door No
                                                                  </label>
                                                                  <input
                                                                    className="form-control"
                                                                    id="door_no"
                                                                    name="door_no"
                                                                    type="text"
                                                                    value={
                                                                      sched.door_no
                                                                    }
                                                                    onChange={(
                                                                      e,
                                                                    ) =>
                                                                      this.handleChange(
                                                                        e,
                                                                        schIndex,
                                                                      )
                                                                    }
                                                                    required
                                                                  />
                                                                </div>
                                                              </div>
                                                              <div className="col-md-6">
                                                                <div className="form-group">
                                                                  <label>
                                                                    Floor No
                                                                    <span
                                                                      style={{
                                                                        color:
                                                                          "#FF0000",
                                                                      }}
                                                                    >
                                                                      *
                                                                    </span>
                                                                  </label>
                                                                  <input
                                                                    className={
                                                                      this.state
                                                                        .required &&
                                                                      sched.floor ===
                                                                        ""
                                                                        ? "form-control is-invalid"
                                                                        : "form-control"
                                                                    }
                                                                    id="floor"
                                                                    name="floor"
                                                                    type="text"
                                                                    value={
                                                                      sched.floor
                                                                    }
                                                                    onChange={(
                                                                      e,
                                                                    ) =>
                                                                      this.handleChange(
                                                                        e,
                                                                        schIndex,
                                                                      )
                                                                    }
                                                                  />
                                                                  <div className="invalid-feedback">
                                                                    This is a
                                                                    required
                                                                    field,
                                                                    kindly add
                                                                    Floor Number
                                                                    here.
                                                                  </div>
                                                                </div>
                                                              </div>
                                                              <div className="col-md-6">
                                                                <div className="form-group">
                                                                  <label>
                                                                    Apartment
                                                                    Name
                                                                    {/* <span style={{ color: "#FF0000" }}>*</span> */}
                                                                  </label>
                                                                  <input
                                                                    className="form-control"
                                                                    // className={this.state.required && sched.appt_name === '' ? 'form-control is-invalid' : 'form-control'}
                                                                    name="appt_name"
                                                                    type="text"
                                                                    value={
                                                                      sched.appt_name
                                                                    }
                                                                    onChange={(
                                                                      e,
                                                                    ) =>
                                                                      this.handleChange(
                                                                        e,
                                                                        schIndex,
                                                                      )
                                                                    }
                                                                  />
                                                                  {/* <div className="invalid-feedback">This is a required field, kindly add Apartment Name here.</div> */}
                                                                </div>
                                                              </div>
                                                              <div className="col-md-3">
                                                                <div className="form-group">
                                                                  <label>
                                                                    Builtup Area
                                                                    <span
                                                                      style={{
                                                                        color:
                                                                          "#FF0000",
                                                                      }}
                                                                    >
                                                                      *
                                                                    </span>
                                                                  </label>
                                                                  <input
                                                                    className={
                                                                      this.state
                                                                        .required &&
                                                                      sched.buildup ===
                                                                        ""
                                                                        ? "form-control is-invalid"
                                                                        : "form-control"
                                                                    }
                                                                    name="buildup"
                                                                    type="text"
                                                                    value={
                                                                      sched.buildup
                                                                    }
                                                                    onChange={(
                                                                      e,
                                                                    ) =>
                                                                      this.handleChange(
                                                                        e,
                                                                        schIndex,
                                                                      )
                                                                    }
                                                                  />
                                                                  <div className="invalid-feedback">
                                                                    This is a
                                                                    required
                                                                    field,
                                                                    kindly add
                                                                    Builtup Area
                                                                    here.
                                                                  </div>
                                                                </div>
                                                              </div>
                                                              <div className="col-md-3">
                                                                <div
                                                                  style={{
                                                                    padding:
                                                                      "0px",
                                                                    border:
                                                                      "none",
                                                                  }}
                                                                >
                                                                  <label
                                                                    style={{
                                                                      width:
                                                                        "300px",
                                                                    }}
                                                                  >
                                                                    Select Unit
                                                                    <span
                                                                      style={{
                                                                        color:
                                                                          "#FF0000",
                                                                      }}
                                                                    >
                                                                      *
                                                                    </span>{" "}
                                                                    <sup>
                                                                      (Eg.43
                                                                      Sq.Meter
                                                                      Etc...)
                                                                    </sup>
                                                                  </label>
                                                                  {this.state
                                                                    .extentUnits &&
                                                                    this.state
                                                                      .extentUnits
                                                                      .length >
                                                                      0 &&
                                                                    this.state.extentUnits.map(
                                                                      (
                                                                        opt: any,
                                                                      ) => {
                                                                        opt.label =
                                                                          opt.name;
                                                                        opt.value =
                                                                          opt.id;
                                                                      },
                                                                    ) && (
                                                                      <Select
                                                                        options={
                                                                          this
                                                                            .state
                                                                            .extentUnits
                                                                        }
                                                                        name="builtup_unit"
                                                                        style={{
                                                                          padding:
                                                                            "0px",
                                                                          border:
                                                                            "none",
                                                                          background:
                                                                            "transparent",
                                                                          margin:
                                                                            "-7px",
                                                                        }}
                                                                        className={
                                                                          this
                                                                            .state
                                                                            .required &&
                                                                          sched.builtup_unit ===
                                                                            ""
                                                                            ? "form-select is-invalid"
                                                                            : "form-select"
                                                                        }
                                                                        value={this.state.extentUnits.find(
                                                                          (
                                                                            o: any,
                                                                          ) =>
                                                                            o.value ===
                                                                            sched.builtup_unit,
                                                                        )}
                                                                        onChange={(
                                                                          e,
                                                                        ) =>
                                                                          this.handleChange(
                                                                            e,
                                                                            schIndex,
                                                                            "builtup_unit",
                                                                            "singleselect",
                                                                          )
                                                                        }
                                                                      />
                                                                    )}
                                                                  <div className="invalid-feedback">
                                                                    This is a
                                                                    required
                                                                    field
                                                                  </div>
                                                                </div>
                                                              </div>
                                                              <div className="col-md-3">
                                                                <div className="form-group">
                                                                  <label>
                                                                    UDS
                                                                    <span
                                                                      style={{
                                                                        color:
                                                                          "#FF0000",
                                                                      }}
                                                                    >
                                                                      *
                                                                    </span>
                                                                  </label>
                                                                  <input
                                                                    className={
                                                                      this.state
                                                                        .required &&
                                                                      sched.uds ===
                                                                        ""
                                                                        ? "form-control is-invalid"
                                                                        : "form-control"
                                                                    }
                                                                    name="uds"
                                                                    type="text"
                                                                    value={
                                                                      sched.uds
                                                                    }
                                                                    onChange={(
                                                                      e,
                                                                    ) =>
                                                                      this.handleChange(
                                                                        e,
                                                                        schIndex,
                                                                      )
                                                                    }
                                                                  />
                                                                  <div className="invalid-feedback">
                                                                    This is a
                                                                    required
                                                                    field
                                                                  </div>
                                                                </div>
                                                              </div>
                                                              <div className="col-md-3">
                                                                <div className="form-group">
                                                                  <label
                                                                    style={{
                                                                      width:
                                                                        "300px",
                                                                    }}
                                                                  >
                                                                    Select Unit
                                                                    <span
                                                                      style={{
                                                                        color:
                                                                          "#FF0000",
                                                                      }}
                                                                    >
                                                                      *
                                                                    </span>{" "}
                                                                    <sup>
                                                                      (Eg.43
                                                                      Sq.Meter
                                                                      Etc...)
                                                                    </sup>
                                                                  </label>
                                                                  {this.state
                                                                    .extentUnits &&
                                                                    this.state
                                                                      .extentUnits
                                                                      .length >
                                                                      0 &&
                                                                    this.state.extentUnits.map(
                                                                      (
                                                                        opt: any,
                                                                      ) => {
                                                                        opt.label =
                                                                          opt.name;
                                                                        opt.value =
                                                                          opt.id;
                                                                      },
                                                                    ) && (
                                                                      <Select
                                                                        options={
                                                                          this
                                                                            .state
                                                                            .extentUnits
                                                                        }
                                                                        name="uds_unit"
                                                                        className={
                                                                          this
                                                                            .state
                                                                            .required &&
                                                                          sched.uds_unit ===
                                                                            ""
                                                                            ? "form-select is-invalid"
                                                                            : "form-select"
                                                                        }
                                                                        value={this.state.extentUnits.find(
                                                                          (
                                                                            o: any,
                                                                          ) =>
                                                                            o.value ===
                                                                            sched.uds_unit,
                                                                        )}
                                                                        onChange={(
                                                                          e,
                                                                        ) =>
                                                                          this.handleChange(
                                                                            e,
                                                                            schIndex,
                                                                            "uds_unit",
                                                                            "singleselect",
                                                                          )
                                                                        }
                                                                      />
                                                                    )}
                                                                  <div className="invalid-feedback">
                                                                    This is a
                                                                    required
                                                                    field
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            </div>
                                                          )}
                                                          <SurveyItem
                                                            stateToProps={(e) =>
                                                              this.stateToProps(
                                                                e,
                                                                schIndex,
                                                              )
                                                            }
                                                            surveyDetail={
                                                              sched.survey_details
                                                            }
                                                            extentUnits={
                                                              this.state
                                                                .extentUnits
                                                            }
                                                            required={
                                                              this.state
                                                                .required
                                                            }
                                                          />
                                                          <div className="row">
                                                            <div className="col-md-12">
                                                              <div className="form-group">
                                                                <label>
                                                                  Address
                                                                  <span
                                                                    style={{
                                                                      color:
                                                                        "#FF0000",
                                                                    }}
                                                                  >
                                                                    *
                                                                  </span>{" "}
                                                                  <span className="inputEgMsg">
                                                                    Village/
                                                                    Town, Taluk,
                                                                    Regd.District,
                                                                    SRO "##
                                                                    Layout
                                                                    Name##"
                                                                  </span>
                                                                </label>
                                                                <textarea
                                                                  placeholder="Eg.location, village,city, registration, sub-district etc"
                                                                  className={
                                                                    this.state
                                                                      .required &&
                                                                    sched.address ===
                                                                      ""
                                                                      ? "form-control is-invalid"
                                                                      : "form-control"
                                                                  }
                                                                  name="address"
                                                                  id="address"
                                                                  value={
                                                                    sched.address
                                                                  }
                                                                  onChange={(
                                                                    e,
                                                                  ) =>
                                                                    this.handleChange(
                                                                      e,
                                                                      schIndex,
                                                                    )
                                                                  }
                                                                  aria-required="true"
                                                                />
                                                                <div className="invalid-feedback">
                                                                  This is a
                                                                  required
                                                                  field, kindly
                                                                  add property
                                                                  Address here.
                                                                </div>
                                                              </div>
                                                            </div>

                                                            <div className="col-md-12">
                                                              <div className="form-group">
                                                                <label>
                                                                  Remark
                                                                  <span
                                                                    style={{
                                                                      color:
                                                                        "#FF0000",
                                                                    }}
                                                                  >
                                                                    *
                                                                  </span>
                                                                </label>
                                                                <textarea
                                                                  className={
                                                                    this.state
                                                                      .required &&
                                                                    sched.remark ===
                                                                      ""
                                                                      ? "form-control is-invalid"
                                                                      : "form-control"
                                                                  }
                                                                  name="remark"
                                                                  id="remark"
                                                                  placeholder="Remarks display in Scheduled of Property info card"
                                                                  value={
                                                                    sched.remark
                                                                  }
                                                                  onChange={(
                                                                    e,
                                                                  ) =>
                                                                    this.handleChange(
                                                                      e,
                                                                      schIndex,
                                                                    )
                                                                  }
                                                                />
                                                                <div className="invalid-feedback">
                                                                  This is a
                                                                  required
                                                                  field, kindly
                                                                  add your
                                                                  Remarks here.
                                                                </div>
                                                              </div>
                                                            </div>

                                                            {/* Add Query Note Component */}
                                                            <div className="col-md-12 mt-4">
                                                              <QueryNote
                                                                fileId={this.props.match.params.id}
                                                                fod_fk={this.props.match.params.docid}
                                                                hideAccordion={false}  
                                                              />
                                                            </div>
                                                          </div>
                                                          {/* <MeasurementItem
                                              stateToProps={e =>
                                                this.stateToProps(e, schIndex)
                                              }
                                              measurementDetail={
                                                sched.measure_details
                                              }
                                            /> */}
                                                          {/* <MeasureLabelItem
                                              stateToProps={e =>
                                                this.stateToProps(e, schIndex)
                                              }
                                              measurementDetail={
                                                sched.measurement_list
                                              }
                                            /> */}
                                                        </Card.Body>
                                                      </Accordion.Collapse>
                                                    </Card>
                                                  </Accordion>
                                                </div>
                                              );
                                            },
                                          )
                                        : ""}
                                    </div>
                                  </div>
                                )}
                              </div>
                            </Resizable>
                          </div>
                        </div>
                        <div className="btn-toolbar sw-toolbar sw-toolbar-bottom justify-content-end mt-3">
                          <div
                            className="btn-group mr-2 sw-btn-group"
                            role="group"
                          >
                            <button
                              className="btn mt-2 btn-warning sw-btn-next"
                              type="button"
                              onClick={() => {
                                isVerifyFlow
                                  ? window.history.back()
                                  : this.props.history.push(
                                      "/work-file/1/" +
                                        this.props.match.params.id,
                                    );
                              }}
                            >
                              Back
                            </button>
                          </div>
                          {/* {!isVerifyFlow ? */}
                          <div
                            className="btn-group mr-2 sw-btn-group"
                            role="group"
                          >
                            <a href="#previewTable">
                              {this.state.autoAssign &&
                              this.state.autoAssign.find(
                                (data: any) =>
                                  data.module_name === "Auto Assign" &&
                                  data.status,
                              ) ? (
                                <>
                                  {takenfile &&
                                  currentfile &&
                                  takenfile === currentfile ? (
                                    <>
                                      {/* <p>{takenfile}-{currentfile}-{takenfile == currentfile}</p> */}
                                      <button
                                        style={{ marginTop: "8px" }}
                                        className="btn btn-primary sw-btn-next"
                                        type="button"
                                        onClick={() => this.saveGeneralDoc(1)}
                                        disabled={this.state.isLoading}
                                      >
                                        {this.state.isLoading && (
                                          <i className="fa fa-spinner fa-spin"></i>
                                        )}
                                        Save
                                      </button>
                                      {this.state.editorMode &&
                                        this.state.editorSave && (
                                          <>
                                            <button
                                              className="btn btn-success sw-btn-next mt-1 ml-3"
                                              type="button"
                                              onClick={() =>
                                                this.saveGeneralDoc(2)
                                              }
                                              disabled={this.state.isLoading}
                                            >
                                              {this.state.isLoading && (
                                                <i className="fa fa-spinner fa-spin"></i>
                                              )}
                                              Save & Submit
                                            </button>
                                          </>
                                        )}
                                    </>
                                  ) : (
                                    <>
                                      {isVerifyFlow ? (
                                        <>
                                          <button
                                            style={{ marginTop: "8px" }}
                                            className="btn btn-success sw-btn-next"
                                            type="button"
                                            onClick={() =>
                                              this.saveGeneralDoc(1)
                                            }
                                            disabled={this.state.isLoading}
                                          >
                                            {this.state.isLoading && (
                                              <i className="fa fa-spinner fa-spin"></i>
                                            )}
                                            Save
                                          </button>
                                        </>
                                      ) : (
                                        ""
                                      )}
                                    </>
                                  )}
                                </>
                              ) : (
                                <>
                                  {!isVerifyFlow ? (
                                    <button
                                      style={{ marginTop: "8px" }}
                                      className="btn btn-primary sw-btn-next"
                                      type="button"
                                      onClick={() => this.saveGeneralDoc(1)}
                                      disabled={this.state.isLoading}
                                    >
                                      {this.state.isLoading && (
                                        <i className="fa fa-spinner fa-spin"></i>
                                      )}
                                      Save
                                    </button>
                                  ) : null}
                                </>
                              )}
                            </a>
                          </div>
                          {/* : null} */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* {this.state.showTable == true &&
              this.state.natureDocN == "Agri" && (
                <>
                  <div
                    style={{
                      paddingTop: "11px",
                      paddingBottom: "15px",
                    }}
                    className="card"
                  >
                    <b>
                      <h2
                        style={{
                          textAlign: "center",
                          fontSize: "34px !important",
                          fontWeight: "unset",
                        }}
                      >
                        Agri
                      </h2>
                    </b>
                    {this.state.surveyDetailsTD &&
                    this.state.surveyDetailsTD.length
                      ? this.state.surveyDetailsTD.map(
                          (sched: any, schIndex) => {
                            return (
                              <table
                                id="previewTable"
                                style={{
                                  width: "70%",
                                  margin: "auto",
                                }}
                                className="table table-striped table-bordered nowrap"
                              >
                                <tr className="query-table-row cursor-pointer noBoxShadow">
                                  <td className="text-align-center padding4">
                                    i
                                  </td>
                                  <td className="padding4"></td>
                                  {sched.survey_type == "survey_no" && (
                                    <td className="padding4">Survey No.</td>
                                  )}
                                  {sched.survey_type == "ts_no" && (
                                    <td className="padding4">TS No.</td>
                                  )}{" "}
                                  {sched.survey_type == "natham_survey_no" && (
                                    <td className="padding4">
                                      Natham Survey No.
                                    </td>
                                  )}
                                  <td className="padding4">As per new Patta</td>
                                  <td className="padding4">Extent</td>
                                </tr>
                                <tr className="query-table-row cursor-pointer noBoxShadow">
                                  <td className="padding4"></td>
                                  <td className="padding4"></td>
                                  {sched.survey_type == "survey_no" &&
                                    sched.old_survey_no != "" && (
                                      <td className="padding4">
                                        Old S.No- {sched.old_survey_no}, After
                                        Sub Division New S.No- {sched.survey_no}
                                      </td>
                                    )}
                                  {sched.survey_type == "survey_no" &&
                                    sched.old_survey_no == "" && (
                                      <td className="padding4">
                                        S.No- {sched.survey_no}
                                      </td>
                                    )}
                                  {sched.survey_type == "natham_survey_no" &&
                                    sched.old_natham_survey_no != "" && (
                                      <td className="padding4">
                                        Old Natham S.No-
                                        {sched.old_natham_survey_no}, New Natham
                                        S.No- {sched.natham_survey_no}
                                      </td>
                                    )}
                                  {sched.survey_type == "natham_survey_no" &&
                                    sched.old_natham_survey_no == "" && (
                                      <td className="padding4">
                                        Natham S.No- {sched.natham_survey_no}
                                      </td>
                                    )}
                                  {sched.survey_type == "ts_no" &&
                                    sched.old_ts_no != "" && (
                                      <td className="padding4">
                                        Old TS No-{sched.old_ts_no}, New TS No-
                                        {sched.ts_no}, Ward- {sched.ts_ward},
                                        Block- {sched.ts_block}
                                      </td>
                                    )}
                                  {sched.survey_type == "ts_no" &&
                                    sched.old_ts_no == "" && (
                                      <td className="padding4">
                                        TS No- {sched.ts_no}, Ward-{" "}
                                        {sched.ts_ward}, Block- {sched.ts_block}
                                      </td>
                                    )}
                                  <td className="padding4">
                                    {sched.revenue_record}
                                  </td>
                                  <td className="padding4">
                                    {sched.extent} {sched.sur_extent_unit}
                                  </td>
                                </tr>
                                <tr className="query-table-row cursor-pointer noBoxShadow">
                                  <td className="padding4"></td>
                                  <td className="padding4"></td>
                                  <td className="padding4"></td>
                                  <td className="padding4">Total Extent</td>
                                  <td className="padding4">
                                    {sched.extent} {sched.sur_extent_unit}
                                  </td>
                                </tr>
                                <tr className="query-table-row cursor-pointer noBoxShadow">
                                  <td className="text-align-center padding4">
                                    ii
                                  </td>
                                  <td colSpan={2} className="padding4">
                                    Location like name of the place, village,
                                    city, registration, sub- district etc.
                                  </td>
                                  <td colSpan={2} className="padding4">
                                    {this.state.address}
                                  </td>
                                </tr>
                                <tr className="query-table-row cursor-pointer noBoxShadow">
                                  <td className="brdrClr">iii</td>
                                  <td className="brdrClr" colSpan={4}>
                                    {sched.boundary_details &&
                                    sched.boundary_details.length
                                      ? sched.boundary_details.map(
                                          (schedB: any, schIndex: 0) => {
                                            return (
                                              <>
                                                <b className="textUnderline">
                                                  {schIndex + 1}.Boundaries for{" "}
                                                  {schedB.land_aries}{" "}
                                                  {schedB.unit} of land
                                                </b>
                                                <br></br>
                                                <b className="textUnderline">
                                                  North {schedB.direction}
                                                </b>{" "}
                                                - {schedB.north}
                                                <br></br>
                                                <b className="textUnderline">
                                                  South {schedB.direction}
                                                </b>{" "}
                                                - {schedB.south}
                                                <br></br>
                                                <b className="textUnderline">
                                                  East {schedB.direction}
                                                </b>{" "}
                                                - {schedB.east}
                                                <br></br>
                                                <b className="textUnderline">
                                                  West {schedB.direction}
                                                </b>{" "}
                                                - {schedB.west}
                                                <br></br>
                                                {this.state.measureList &&
                                                this.state.measureList.length
                                                  ? this.state.measureList.map(
                                                      (
                                                        dirLabel: any,
                                                        index,
                                                      ) => {
                                                        return (
                                                          <>
                                                            {dirLabel.meas_dir_list &&
                                                              dirLabel
                                                                .meas_dir_list
                                                                .length > 0 &&
                                                              dirLabel
                                                                .meas_dir_list[0]
                                                                .label_name !=
                                                                null && (
                                                                <>
                                                                  <b>
                                                                    <h4
                                                                      style={{
                                                                        textAlign:
                                                                          "center",
                                                                        fontSize:
                                                                          "34px !important",
                                                                        fontWeight:
                                                                          "unset",
                                                                      }}
                                                                    >
                                                                      Measurement
                                                                      Details
                                                                    </h4>
                                                                  </b>
                                                                  <table>
                                                                    {this.state
                                                                      .measDirList &&
                                                                    this.state
                                                                      .measDirList
                                                                      .length
                                                                      ? this.state.measDirList.map(
                                                                          (
                                                                            dir: any,
                                                                          ) => {
                                                                            return (
                                                                              <>
                                                                                <tr
                                                                                  style={{
                                                                                    margin:
                                                                                      "auto",
                                                                                    display:
                                                                                      "table",
                                                                                    width:
                                                                                      "100%",
                                                                                  }}
                                                                                  className="query-table-row cursor-pointer noBoxShadow"
                                                                                >
                                                                                  {dir.label !=
                                                                                    "8" && (
                                                                                    <td
                                                                                      className="padding4"
                                                                                      style={{
                                                                                        width:
                                                                                          "60%",
                                                                                        textAlign:
                                                                                          "center",
                                                                                      }}
                                                                                    >
                                                                                      {
                                                                                        dir.label_name
                                                                                      }
                                                                                    </td>
                                                                                  )}
                                                                                  {dir.label ==
                                                                                    "8" && (
                                                                                    <td
                                                                                      className="padding4"
                                                                                      style={{
                                                                                        width:
                                                                                          "60%",
                                                                                        textAlign:
                                                                                          "center",
                                                                                      }}
                                                                                    >
                                                                                      {
                                                                                        dir.measure_custom
                                                                                      }
                                                                                    </td>
                                                                                  )}
                                                                                  <td
                                                                                    className="padding4"
                                                                                    style={{
                                                                                      width:
                                                                                        "40%",
                                                                                      textAlign:
                                                                                        "center",
                                                                                    }}
                                                                                  >
                                                                                    {
                                                                                      dir.value
                                                                                    }{" "}
                                                                                    {
                                                                                      dirLabel.l_unit
                                                                                    }
                                                                                  </td>
                                                                                </tr>
                                                                              </>
                                                                            );
                                                                          },
                                                                        )
                                                                      : ""}
                                                                  </table>
                                                                  <h6
                                                                    style={{
                                                                      paddingTop:
                                                                        "14px",
                                                                    }}
                                                                  >
                                                                    With all
                                                                    easements
                                                                    Rights and
                                                                    Pathway
                                                                  </h6>
                                                                </>
                                                              )}
                                                          </>
                                                        );
                                                      },
                                                    )
                                                  : ""}
                                              </>
                                            );
                                          },
                                        )
                                      : ""}
                                  </td>
                                </tr>
                              </table>
                            );
                          },
                        )
                      : ""}
                    <div className="btn-toolbar sw-toolbar sw-toolbar-bottom justify-content-end">
                      <div className="btn-group mr-2 sw-btn-group" role="group">
                        <button
                          className="btn mt-2 btn-warning sw-btn-next"
                          type="button"
                          onClick={() => {
                            isVerifyFlow
                              ? window.history.back()
                              : this.props.history.push(
                                  "/work-file/1/" + this.props.match.params.id,
                                );
                          }}
                        >
                          Back
                        </button>
                      </div>
                      <div
                        className="btn-group mr-2 mt-2 sw-btn-group"
                        role="group"
                      >
                        {this.state.autoAssign &&
                        this.state.autoAssign.find(
                          (data: any) =>
                            data.module_name === "Auto Assign" && data.status,
                        ) ? (
                          <>
                            {takenfile == currentfile ? (
                              <>
                                <button
                                  className="btn btn-success sw-btn-next"
                                  type="button"
                                  onClick={() => this.saveGeneralDoc(2)}
                                  disabled={this.state.isLoading}
                                >
                                  {this.state.isLoading && (
                                    <i className="fa fa-spinner fa-spin"></i>
                                  )}
                                  Save & Submit
                                </button>
                              </>
                            ) : (
                              <>
                                {isVerifyFlow ? (
                                  <>
                                    <button
                                      className="btn btn-success sw-btn-next"
                                      type="button"
                                      onClick={() => this.saveGeneralDoc(2)}
                                      disabled={this.state.isLoading}
                                    >
                                      {this.state.isLoading && (
                                        <i className="fa fa-spinner fa-spin"></i>
                                      )}
                                      Save & Submit
                                    </button>
                                  </>
                                ) : (
                                  ""
                                )}
                              </>
                            )}
                          </>
                        ) : (
                          <>
                            <button
                              className="btn btn-success sw-btn-next"
                              type="button"
                              onClick={() => this.saveGeneralDoc(2)}
                              disabled={this.state.isLoading}
                            >
                              {this.state.isLoading && (
                                <i className="fa fa-spinner fa-spin"></i>
                              )}
                              Save & Submit
                            </button>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </>
              )}
            {this.state.showTable == true &&
              this.state.natureDocN == "Existing building" && (
                <>
                  <div
                    style={{
                      paddingTop: "11px",
                      paddingBottom: "15px",
                    }}
                    className="card"
                  >
                    <b>
                      <h2
                        style={{
                          textAlign: "center",
                          fontSize: "34px !important",
                          fontWeight: "unset",
                        }}
                      >
                        Existing building
                      </h2>
                    </b>
                    {this.state.schedules && this.state.schedules.length
                      ? this.state.schedules.map(
                          (schList: any, schListIndex) => {
                            return (
                              <>
                                {" "}
                                {schList.survey_details &&
                                schList.survey_details.length
                                  ? schList.survey_details.map(
                                      (sched: any, schIndex) => {
                                        return (
                                          <table
                                            id="previewTable"
                                            style={{
                                              width: "70%",
                                              margin: "auto",
                                            }}
                                            className="table table-striped table-bordered nowrap"
                                          >
                                            <tr className="query-table-row cursor-pointer noBoxShadow">
                                              <td className="text-align-center padding4">
                                                i
                                              </td>
                                              {sched.survey_type ==
                                                "survey_no" && (
                                                <td className="padding4">
                                                  Survey No.
                                                </td>
                                              )}
                                              {sched.survey_type == "ts_no" && (
                                                <td className="padding4">
                                                  TS No.
                                                </td>
                                              )}{" "}
                                              {sched.survey_type ==
                                                "natham_survey_no" && (
                                                <td className="padding4">
                                                  Natham Survey No.
                                                </td>
                                              )}
                                              {sched.survey_type ==
                                                "survey_no" &&
                                                sched.old_survey_no != "" && (
                                                  <td className="padding4">
                                                    Old S.No-{" "}
                                                    {sched.old_survey_no}, After
                                                    Sub Division New S.No-{" "}
                                                    {sched.survey_no}
                                                  </td>
                                                )}
                                              {sched.survey_type ==
                                                "survey_no" &&
                                                sched.old_survey_no == "" && (
                                                  <td className="padding4">
                                                    S.No- {sched.survey_no}
                                                  </td>
                                                )}
                                              {sched.survey_type ==
                                                "natham_survey_no" &&
                                                sched.old_natham_survey_no !=
                                                  "" && (
                                                  <td className="padding4">
                                                    Old Natham S.No-
                                                    {sched.old_natham_survey_no}
                                                    , New Natham S.No-{" "}
                                                    {sched.natham_survey_no}
                                                  </td>
                                                )}
                                              {sched.survey_type ==
                                                "natham_survey_no" &&
                                                sched.old_natham_survey_no ==
                                                  "" && (
                                                  <td className="padding4">
                                                    Natham S.No-{" "}
                                                    {sched.natham_survey_no}
                                                  </td>
                                                )}
                                              {sched.survey_type == "ts_no" &&
                                                sched.old_ts_no != "" && (
                                                  <td className="padding4">
                                                    Old TS No-{sched.old_ts_no},
                                                    New TS No-{sched.ts_no},
                                                    Ward- {sched.ts_ward},
                                                    Block- {sched.ts_block}
                                                  </td>
                                                )}
                                              {sched.survey_type == "ts_no" &&
                                                sched.old_ts_no == "" && (
                                                  <td className="padding4">
                                                    TS No- {sched.ts_no}, Ward-{" "}
                                                    {sched.ts_ward}, Block-{" "}
                                                    {sched.ts_block}
                                                  </td>
                                                )}
                                            </tr>
                                            <tr className="query-table-row cursor-pointer noBoxShadow">
                                              <td className="text-align-center padding4">
                                                ii
                                              </td>
                                              <td className="padding4">
                                                As per Revenue Record
                                              </td>
                                              <td className="padding4">
                                                {sched.revenue_record}
                                              </td>
                                            </tr>
                                            <tr className="query-table-row cursor-pointer noBoxShadow">
                                              <td className="text-align-center padding4">
                                                iii
                                              </td>
                                              <td className="padding4">
                                                Total Extent
                                              </td>
                                              <td className="padding4">
                                                {sched.extent}{" "}
                                                {sched.sur_extent_unit}
                                              </td>
                                            </tr>
                                            {this.state.showdoor_no == true && (
                                              <>
                                                <tr className="query-table-row cursor-pointer noBoxShadow">
                                                  <td className="text-align-center padding4">
                                                    iv
                                                  </td>
                                                  <td className="padding4">
                                                    Door No (As per property
                                                    tax)
                                                  </td>
                                                  <td className="padding4">
                                                    {schList.door_no}
                                                  </td>
                                                </tr>
                                              </>
                                            )}
                                            <tr className="query-table-row cursor-pointer noBoxShadow">
                                              {this.state.showdoor_no ==
                                              true ? (
                                                <>
                                                  <td className="text-align-center padding4">
                                                    v
                                                  </td>
                                                </>
                                              ) : (
                                                <>
                                                  <td className="text-align-center padding4">
                                                    iv
                                                  </td>
                                                </>
                                              )}
                                              <td className="padding4">
                                                Location like name of the place,
                                                village, city, registration,
                                                sub- district etc.
                                              </td>
                                              <td className="padding4">
                                                {this.state.address}
                                              </td>
                                            </tr>
                                            <tr className="query-table-row cursor-pointer noBoxShadow">
                                              {this.state.showdoor_no ==
                                              true ? (
                                                <>
                                                  <td className="text-align-center padding4">
                                                    vi
                                                  </td>
                                                </>
                                              ) : (
                                                <>
                                                  <td className="brdrClr">v</td>
                                                </>
                                              )}

                                              <td
                                                className="brdrClr"
                                                colSpan={2}
                                              >
                                                {sched.boundary_details &&
                                                sched.boundary_details.length
                                                  ? sched.boundary_details.map(
                                                      (
                                                        schedB: any,
                                                        schIndex: 0,
                                                      ) => {
                                                        return (
                                                          <>
                                                            <b className="textUnderline">
                                                              {schIndex + 1}
                                                              .Boundaries for{" "}
                                                              {
                                                                schedB.land_aries
                                                              }{" "}
                                                              {schedB.unit} of
                                                              land
                                                            </b>
                                                            <br></br>
                                                            <b className="textUnderline">
                                                              North{" "}
                                                              {schedB.direction}
                                                            </b>{" "}
                                                            - {schedB.north}
                                                            <br></br>
                                                            <b className="textUnderline">
                                                              South{" "}
                                                              {schedB.direction}
                                                            </b>{" "}
                                                            - {schedB.south}
                                                            <br></br>
                                                            <b className="textUnderline">
                                                              East{" "}
                                                              {schedB.direction}
                                                            </b>{" "}
                                                            - {schedB.east}
                                                            <br></br>
                                                            <b className="textUnderline">
                                                              West{" "}
                                                              {schedB.direction}
                                                            </b>{" "}
                                                            - {schedB.west}
                                                            <br></br>
                                                            {this.state
                                                              .measureList &&
                                                            this.state
                                                              .measureList
                                                              .length
                                                              ? this.state.measureList.map(
                                                                  (
                                                                    dirLabel: any,
                                                                    index,
                                                                  ) => {
                                                                    return (
                                                                      <>
                                                                        {dirLabel.meas_dir_list &&
                                                                          dirLabel
                                                                            .meas_dir_list
                                                                            .length >
                                                                            0 &&
                                                                          dirLabel
                                                                            .meas_dir_list[0]
                                                                            .label_name !=
                                                                            null && (
                                                                            <>
                                                                              <b>
                                                                                <h4
                                                                                  style={{
                                                                                    textAlign:
                                                                                      "center",
                                                                                    fontSize:
                                                                                      "34px !important",
                                                                                    fontWeight:
                                                                                      "unset",
                                                                                  }}
                                                                                >
                                                                                  Measurement
                                                                                  Details
                                                                                </h4>
                                                                              </b>
                                                                              <table>
                                                                                {this
                                                                                  .state
                                                                                  .measDirList &&
                                                                                this
                                                                                  .state
                                                                                  .measDirList
                                                                                  .length
                                                                                  ? this.state.measDirList.map(
                                                                                      (
                                                                                        dir: any,
                                                                                      ) => {
                                                                                        return (
                                                                                          <>
                                                                                            <tr
                                                                                              style={{
                                                                                                margin:
                                                                                                  "auto",
                                                                                                display:
                                                                                                  "table",
                                                                                                width:
                                                                                                  "100%",
                                                                                              }}
                                                                                              className="query-table-row cursor-pointer noBoxShadow"
                                                                                            >
                                                                                              {dir.label !=
                                                                                                "8" && (
                                                                                                <td
                                                                                                  className="padding4"
                                                                                                  style={{
                                                                                                    width:
                                                                                                      "60%",
                                                                                                    textAlign:
                                                                                                      "center",
                                                                                                  }}
                                                                                                >
                                                                                                  {
                                                                                                    dir.label_name
                                                                                                  }
                                                                                                </td>
                                                                                              )}
                                                                                              {dir.label ==
                                                                                                "8" && (
                                                                                                <td
                                                                                                  className="padding4"
                                                                                                  style={{
                                                                                                    width:
                                                                                                      "60%",
                                                                                                    textAlign:
                                                                                                      "center",
                                                                                                  }}
                                                                                                >
                                                                                                  {
                                                                                                    dir.measure_custom
                                                                                                  }
                                                                                                </td>
                                                                                              )}
                                                                                              <td
                                                                                                className="padding4"
                                                                                                style={{
                                                                                                  width:
                                                                                                    "40%",
                                                                                                  textAlign:
                                                                                                    "center",
                                                                                                }}
                                                                                              >
                                                                                                {
                                                                                                  dir.value
                                                                                                }{" "}
                                                                                                {
                                                                                                  dirLabel.l_unit
                                                                                                }
                                                                                              </td>
                                                                                            </tr>
                                                                                          </>
                                                                                        );
                                                                                      },
                                                                                    )
                                                                                  : ""}
                                                                              </table>
                                                                              <h6
                                                                                style={{
                                                                                  paddingTop:
                                                                                    "14px",
                                                                                }}
                                                                              >
                                                                                With
                                                                                all
                                                                                easements
                                                                                Rights
                                                                                and
                                                                                Pathway
                                                                              </h6>
                                                                            </>
                                                                          )}
                                                                      </>
                                                                    );
                                                                  },
                                                                )
                                                              : ""}
                                                          </>
                                                        );
                                                      },
                                                    )
                                                  : ""}
                                              </td>
                                            </tr>
                                          </table>
                                        );
                                      },
                                    )
                                  : ""}
                              </>
                            );
                          },
                        )
                      : ""}
                    <div className="btn-toolbar sw-toolbar sw-toolbar-bottom justify-content-end">
                      <div className="btn-group mr-2 sw-btn-group" role="group">
                        <button
                          className="btn mt-2 btn-warning sw-btn-next"
                          type="button"
                          onClick={() => {
                            isVerifyFlow
                              ? window.history.back()
                              : this.props.history.push(
                                  "/work-file/1/" + this.props.match.params.id,
                                );
                          }}
                        >
                          Back
                        </button>
                      </div>
                      <div
                        className="btn-group mr-2 mt-2 sw-btn-group"
                        role="group"
                      >
                        {this.state.autoAssign &&
                        this.state.autoAssign.find(
                          (data: any) =>
                            data.module_name === "Auto Assign" && data.status,
                        ) ? (
                          <>
                            {takenfile == currentfile ? (
                              <>
                                <button
                                  className="btn btn-success sw-btn-next"
                                  type="button"
                                  onClick={() => this.saveGeneralDoc(2)}
                                  disabled={this.state.isLoading}
                                >
                                  {this.state.isLoading && (
                                    <i className="fa fa-spinner fa-spin"></i>
                                  )}
                                  Save & Submit
                                </button>
                              </>
                            ) : (
                              <>
                                {isVerifyFlow ? (
                                  <>
                                    <button
                                      className="btn btn-success sw-btn-next"
                                      type="button"
                                      onClick={() => this.saveGeneralDoc(2)}
                                      disabled={this.state.isLoading}
                                    >
                                      {this.state.isLoading && (
                                        <i className="fa fa-spinner fa-spin"></i>
                                      )}
                                      Save & Submit
                                    </button>
                                  </>
                                ) : (
                                  ""
                                )}
                              </>
                            )}
                          </>
                        ) : (
                          <>
                            <button
                              className="btn btn-success sw-btn-next"
                              type="button"
                              onClick={() => this.saveGeneralDoc(2)}
                              disabled={this.state.isLoading}
                            >
                              {this.state.isLoading && (
                                <i className="fa fa-spinner fa-spin"></i>
                              )}
                              Save & Submit
                            </button>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </>
              )}
            {this.state.showTable == true &&
              this.state.natureDocN == "Under construction" && (
                <div
                  style={{
                    paddingTop: "11px",
                    paddingBottom: "15px",
                  }}
                  className="card"
                >
                  <b>
                    <h2
                      style={{
                        textAlign: "center",
                        fontSize: "34px !important",
                        fontWeight: "unset",
                      }}
                    >
                      Under construction
                    </h2>
                  </b>
                  {this.state.schedules && this.state.schedules.length
                    ? this.state.schedules.map((schList: any, schListIndex) => {
                        return (
                          <>
                            {schList.survey_details &&
                            schList.survey_details.length
                              ? schList.survey_details.map(
                                  (sched: any, schIndex) => {
                                    return (
                                      <table
                                        id="previewTable"
                                        style={{
                                          width: "70%",
                                          margin: "auto",
                                        }}
                                        className="table table-striped table-bordered nowrap"
                                      >
                                        <tr className="query-table-row cursor-pointer noBoxShadow">
                                          <td className="text-align-center padding4">
                                            i
                                          </td>
                                          {sched.survey_type == "survey_no" && (
                                            <td className="padding4">
                                              Survey No.
                                            </td>
                                          )}
                                          {sched.survey_type == "ts_no" && (
                                            <td className="padding4">TS No.</td>
                                          )}{" "}
                                          {sched.survey_type ==
                                            "natham_survey_no" && (
                                            <td className="padding4">
                                              Natham Survey No.
                                            </td>
                                          )}
                                          {sched.survey_type == "survey_no" &&
                                            sched.old_survey_no != "" && (
                                              <td className="padding4">
                                                Old S.No- {sched.old_survey_no},
                                                After Sub Division New S.No-{" "}
                                                {sched.survey_no}
                                              </td>
                                            )}
                                          {sched.survey_type == "survey_no" &&
                                            sched.old_survey_no == "" && (
                                              <td className="padding4">
                                                S.No- {sched.survey_no}
                                              </td>
                                            )}
                                          {sched.survey_type ==
                                            "natham_survey_no" &&
                                            sched.old_natham_survey_no !=
                                              "" && (
                                              <td className="padding4">
                                                Old Natham S.No-
                                                {sched.old_natham_survey_no},
                                                New Natham S.No-{" "}
                                                {sched.natham_survey_no}
                                              </td>
                                            )}
                                          {sched.survey_type ==
                                            "natham_survey_no" &&
                                            sched.old_natham_survey_no ==
                                              "" && (
                                              <td className="padding4">
                                                Natham S.No-{" "}
                                                {sched.natham_survey_no}
                                              </td>
                                            )}
                                          {sched.survey_type == "ts_no" &&
                                            sched.old_ts_no != "" && (
                                              <td className="padding4">
                                                Old TS No-{sched.old_ts_no}, New
                                                TS No-{sched.ts_no}, Ward-{" "}
                                                {sched.ts_ward}, Block-{" "}
                                                {sched.ts_block}
                                              </td>
                                            )}
                                          {sched.survey_type == "ts_no" &&
                                            sched.old_ts_no == "" && (
                                              <td className="padding4">
                                                TS No- {sched.ts_no}, Ward-{" "}
                                                {sched.ts_ward}, Block-{" "}
                                                {sched.ts_block}
                                              </td>
                                            )}
                                        </tr>
                                        <tr className="query-table-row cursor-pointer noBoxShadow">
                                          <td className="text-align-center padding4">
                                            ii
                                          </td>
                                          <td className="padding4">
                                            As per Revenue Record
                                          </td>
                                          <td className="padding4">
                                            {sched.revenue_record}
                                          </td>
                                        </tr>
                                        <tr className="query-table-row cursor-pointer noBoxShadow">
                                          <td className="text-align-center padding4">
                                            iii
                                          </td>
                                          <td className="padding4">
                                            Total Extent
                                          </td>
                                          <td className="padding4">
                                            {sched.extent}{" "}
                                            {sched.sur_extent_unit}
                                          </td>
                                        </tr>
                                        <tr className="query-table-row cursor-pointer noBoxShadow">
                                          <td className="text-align-center padding4">
                                            iv
                                          </td>
                                          <td className="padding4">
                                            Door No (As per property tax)
                                          </td>
                                          <td className="padding4">
                                            {schList.door_no}
                                          </td>
                                        </tr>
                                        <tr className="query-table-row cursor-pointer noBoxShadow">
                                          <td className="text-align-center padding4">
                                            v
                                          </td>
                                          <td className="padding4">
                                            Location like name of the place,
                                            village, city, registration, sub-
                                            district etc.
                                          </td>
                                          <td className="padding4">
                                            {this.state.address}
                                          </td>
                                        </tr>
                                        <tr className="query-table-row cursor-pointer noBoxShadow">
                                          <td className="brdrClr">vi</td>
                                          <td className="brdrClr" colSpan={2}>
                                            {sched.boundary_details &&
                                            sched.boundary_details.length
                                              ? sched.boundary_details.map(
                                                  (
                                                    schedB: any,
                                                    schIndex: 0,
                                                  ) => {
                                                    return (
                                                      <>
                                                        <b className="textUnderline">
                                                          {schIndex + 1}.
                                                          Boundaries for{" "}
                                                          {schedB.land_aries}{" "}
                                                          {schedB.unit} of land
                                                        </b>
                                                        <br></br>
                                                        <b className="textUnderline">
                                                          North{" "}
                                                          {schedB.direction}
                                                        </b>{" "}
                                                        - {schedB.north}
                                                        <br></br>
                                                        <b className="textUnderline">
                                                          South{" "}
                                                          {schedB.direction}
                                                        </b>{" "}
                                                        - {schedB.south}
                                                        <br></br>
                                                        <b className="textUnderline">
                                                          East{" "}
                                                          {schedB.direction}
                                                        </b>{" "}
                                                        - {schedB.east}
                                                        <br></br>
                                                        <b className="textUnderline">
                                                          West{" "}
                                                          {schedB.direction}
                                                        </b>{" "}
                                                        - {schedB.west}
                                                        <br></br>
                                                        {this.state
                                                          .measureList &&
                                                        this.state.measureList
                                                          .length
                                                          ? this.state.measureList.map(
                                                              (
                                                                dirLabel: any,
                                                                index,
                                                              ) => {
                                                                return (
                                                                  <>
                                                                    {dirLabel.meas_dir_list &&
                                                                      dirLabel
                                                                        .meas_dir_list
                                                                        .length >
                                                                        0 &&
                                                                      dirLabel
                                                                        .meas_dir_list[0]
                                                                        .label_name !=
                                                                        null && (
                                                                        <>
                                                                          <b>
                                                                            <h4
                                                                              style={{
                                                                                textAlign:
                                                                                  "center",
                                                                                fontSize:
                                                                                  "34px !important",
                                                                                fontWeight:
                                                                                  "unset",
                                                                              }}
                                                                            >
                                                                              Measurement
                                                                              Details
                                                                            </h4>
                                                                          </b>
                                                                          <table>
                                                                            {this
                                                                              .state
                                                                              .measDirList &&
                                                                            this
                                                                              .state
                                                                              .measDirList
                                                                              .length
                                                                              ? this.state.measDirList.map(
                                                                                  (
                                                                                    dir: any,
                                                                                  ) => {
                                                                                    return (
                                                                                      <>
                                                                                        <tr
                                                                                          style={{
                                                                                            margin:
                                                                                              "auto",
                                                                                            display:
                                                                                              "table",
                                                                                            width:
                                                                                              "100%",
                                                                                          }}
                                                                                          className="query-table-row cursor-pointer noBoxShadow"
                                                                                        >
                                                                                          {dir.label !=
                                                                                            "8" && (
                                                                                            <td
                                                                                              className="padding4"
                                                                                              style={{
                                                                                                width:
                                                                                                  "60%",
                                                                                                textAlign:
                                                                                                  "center",
                                                                                              }}
                                                                                            >
                                                                                              {
                                                                                                dir.label_name
                                                                                              }
                                                                                            </td>
                                                                                          )}
                                                                                          {dir.label ==
                                                                                            "8" && (
                                                                                            <td
                                                                                              className="padding4"
                                                                                              style={{
                                                                                                width:
                                                                                                  "60%",
                                                                                                textAlign:
                                                                                                  "center",
                                                                                              }}
                                                                                            >
                                                                                              {
                                                                                                dir.measure_custom
                                                                                              }
                                                                                            </td>
                                                                                          )}
                                                                                          <td
                                                                                            className="padding4"
                                                                                            style={{
                                                                                              width:
                                                                                                "40%",
                                                                                              textAlign:
                                                                                                "center",
                                                                                            }}
                                                                                          >
                                                                                            {
                                                                                              dir.value
                                                                                            }{" "}
                                                                                            {
                                                                                              dirLabel.l_unit
                                                                                            }
                                                                                          </td>
                                                                                        </tr>
                                                                                      </>
                                                                                    );
                                                                                  },
                                                                                )
                                                                              : ""}
                                                                          </table>
                                                                          <h6
                                                                            style={{
                                                                              paddingTop:
                                                                                "14px",
                                                                            }}
                                                                          >
                                                                            With
                                                                            all
                                                                            easements
                                                                            Rights
                                                                            and
                                                                            Pathway
                                                                          </h6>
                                                                        </>
                                                                      )}
                                                                  </>
                                                                );
                                                              },
                                                            )
                                                          : ""}
                                                      </>
                                                    );
                                                  },
                                                )
                                              : ""}
                                          </td>
                                        </tr>
                                      </table>
                                    );
                                  },
                                )
                              : ""}
                          </>
                        );
                      })
                    : ""}
                  <div className="btn-toolbar sw-toolbar sw-toolbar-bottom justify-content-end">
                    <div className="btn-group mr-2 sw-btn-group" role="group">
                      <button
                        className="btn mt-2 btn-warning sw-btn-next"
                        type="button"
                        onClick={() => {
                          isVerifyFlow
                            ? window.history.back()
                            : this.props.history.push(
                                "/work-file/1/" + this.props.match.params.id,
                              );
                        }}
                      >
                        Back
                      </button>
                    </div>
                    <div
                      className="btn-group mr-2 mt-2 sw-btn-group"
                      role="group"
                    >
                      {this.state.autoAssign &&
                      this.state.autoAssign.find(
                        (data: any) =>
                          data.module_name === "Auto Assign" && data.status,
                      ) ? (
                        <>
                          {takenfile == currentfile ? (
                            <>
                              <button
                                className="btn btn-success sw-btn-next"
                                type="button"
                                onClick={() => this.saveGeneralDoc(2)}
                                disabled={this.state.isLoading}
                              >
                                {this.state.isLoading && (
                                  <i className="fa fa-spinner fa-spin"></i>
                                )}
                                Save & Submit
                              </button>
                            </>
                          ) : (
                            <>
                              {isVerifyFlow ? (
                                <>
                                  <button
                                    className="btn btn-success sw-btn-next"
                                    type="button"
                                    onClick={() => this.saveGeneralDoc(2)}
                                    disabled={this.state.isLoading}
                                  >
                                    {this.state.isLoading && (
                                      <i className="fa fa-spinner fa-spin"></i>
                                    )}
                                    Save & Submit
                                  </button>
                                </>
                              ) : (
                                ""
                              )}
                            </>
                          )}
                        </>
                      ) : (
                        <>
                          <button
                            className="btn btn-success sw-btn-next"
                            type="button"
                            onClick={() => this.saveGeneralDoc(2)}
                            disabled={this.state.isLoading}
                          >
                            {this.state.isLoading && (
                              <i className="fa fa-spinner fa-spin"></i>
                            )}
                            Save & Submit
                          </button>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              )} */}
            {/* {this.state.showTable == true &&
              this.state.natureDocN == "vacant land" && (
                <div
                  style={{
                    paddingTop: "11px",
                    paddingBottom: "15px",
                  }}
                  className="card"
                >
                  <b>
                    <h2
                      style={{
                        textAlign: "center",
                        fontSize: "34px !important",
                        fontWeight: "unset",
                      }}
                    >
                      Vacant land
                    </h2>
                  </b>
                  {this.state.schedules && this.state.schedules.length
                    ? this.state.schedules.map((schList: any, schListIndex) => {
                        return (
                          <>
                            {schList.survey_details &&
                            schList.survey_details.length
                              ? schList.survey_details.map(
                                  (sched: any, schIndex) => {
                                    return (
                                      <table
                                        id="previewTable"
                                        style={{
                                          width: "70%",
                                          margin: "auto",
                                        }}
                                        className="table table-striped table-bordered nowrap"
                                      >
                                        <tr className="query-table-row cursor-pointer noBoxShadow">
                                          <td className="text-align-center padding4">
                                            i
                                          </td>
                                          {sched.survey_type == "survey_no" && (
                                            <td className="padding4">
                                              Survey No.
                                            </td>
                                          )}
                                          {sched.survey_type == "ts_no" && (
                                            <td className="padding4">TS No.</td>
                                          )}{" "}
                                          {sched.survey_type ==
                                            "natham_survey_no" && (
                                            <td className="padding4">
                                              Natham Survey No.
                                            </td>
                                          )}
                                          {sched.survey_type == "survey_no" &&
                                            sched.old_survey_no != "" && (
                                              <td className="padding4">
                                                Old S.No- {sched.old_survey_no},
                                                After Sub Division New S.No-{" "}
                                                {sched.survey_no}
                                              </td>
                                            )}
                                          {sched.survey_type == "survey_no" &&
                                            sched.old_survey_no == "" && (
                                              <td className="padding4">
                                                S.No- {sched.survey_no}
                                              </td>
                                            )}
                                          {sched.survey_type ==
                                            "natham_survey_no" &&
                                            sched.old_natham_survey_no !=
                                              "" && (
                                              <td className="padding4">
                                                Old Natham S.No-
                                                {sched.old_natham_survey_no},
                                                New Natham S.No-{" "}
                                                {sched.natham_survey_no}
                                              </td>
                                            )}
                                          {sched.survey_type ==
                                            "natham_survey_no" &&
                                            sched.old_natham_survey_no ==
                                              "" && (
                                              <td className="padding4">
                                                Natham S.No-{" "}
                                                {sched.natham_survey_no}
                                              </td>
                                            )}
                                          {sched.survey_type == "ts_no" &&
                                            sched.old_ts_no != "" && (
                                              <td className="padding4">
                                                Old TS No-{sched.old_ts_no}, New
                                                TS No-{sched.ts_no}, Ward-{" "}
                                                {sched.ts_ward}, Block-{" "}
                                                {sched.ts_block}
                                              </td>
                                            )}
                                          {sched.survey_type == "ts_no" &&
                                            sched.old_ts_no == "" && (
                                              <td className="padding4">
                                                TS No- {sched.ts_no}, Ward-{" "}
                                                {sched.ts_ward}, Block-{" "}
                                                {sched.ts_block}
                                              </td>
                                            )}
                                        </tr>
                                        <tr className="query-table-row cursor-pointer noBoxShadow">
                                          <td className="text-align-center padding4">
                                            ii
                                          </td>
                                          <td className="padding4">
                                            As per Revenue Record
                                          </td>
                                          <td className="padding4">
                                            {sched.revenue_record}
                                          </td>
                                        </tr>
                                        <tr className="query-table-row cursor-pointer noBoxShadow">
                                          <td className="text-align-center padding4">
                                            iii
                                          </td>
                                          <td className="padding4">
                                            Total Extent
                                          </td>
                                          <td className="padding4">
                                            {sched.extent}{" "}
                                            {sched.sur_extent_unit}
                                          </td>
                                        </tr>
                                        <tr className="query-table-row cursor-pointer noBoxShadow">
                                          <td className="text-align-center padding4">
                                            iv
                                          </td>
                                          <td className="padding4">
                                            Door No (As per property tax)
                                          </td>
                                          <td className="padding4">
                                            {schList.door_no}
                                          </td>
                                        </tr>
                                        <tr className="query-table-row cursor-pointer noBoxShadow">
                                          <td className="text-align-center padding4">
                                            v
                                          </td>
                                          <td className="padding4">
                                            Location like name of the place,
                                            village, city, registration, sub-
                                            district etc.
                                          </td>
                                          <td className="padding4">
                                            {this.state.address}
                                          </td>
                                        </tr>
                                        <tr className="query-table-row cursor-pointer noBoxShadow">
                                          <td className="brdrClr">vi</td>
                                          <td className="brdrClr" colSpan={2}>
                                            {sched.boundary_details &&
                                            sched.boundary_details.length
                                              ? sched.boundary_details.map(
                                                  (
                                                    schedB: any,
                                                    schIndex: 0,
                                                  ) => {
                                                    return (
                                                      <>
                                                        <b className="textUnderline">
                                                          {schIndex + 1}.
                                                          Boundaries for{" "}
                                                          {schedB.land_aries}{" "}
                                                          {schedB.unit} of land
                                                        </b>
                                                        <br></br>
                                                        <b className="textUnderline">
                                                          North{" "}
                                                          {schedB.direction}
                                                        </b>{" "}
                                                        - {schedB.north}
                                                        <br></br>
                                                        <b className="textUnderline">
                                                          South{" "}
                                                          {schedB.direction}
                                                        </b>{" "}
                                                        - {schedB.south}
                                                        <br></br>
                                                        <b className="textUnderline">
                                                          East{" "}
                                                          {schedB.direction}
                                                        </b>{" "}
                                                        - {schedB.east}
                                                        <br></br>
                                                        <b className="textUnderline">
                                                          West{" "}
                                                          {schedB.direction}
                                                        </b>{" "}
                                                        - {schedB.west}
                                                        <br></br>
                                                        {this.state
                                                          .measureList &&
                                                        this.state.measureList
                                                          .length
                                                          ? this.state.measureList.map(
                                                              (
                                                                dirLabel: any,
                                                                index,
                                                              ) => {
                                                                return (
                                                                  <>
                                                                    {dirLabel.meas_dir_list &&
                                                                      dirLabel
                                                                        .meas_dir_list
                                                                        .length >
                                                                        0 &&
                                                                      dirLabel
                                                                        .meas_dir_list[0]
                                                                        .label_name !=
                                                                        null && (
                                                                        <>
                                                                          <b>
                                                                            <h4
                                                                              style={{
                                                                                textAlign:
                                                                                  "center",
                                                                                fontSize:
                                                                                  "34px !important",
                                                                                fontWeight:
                                                                                  "unset",
                                                                              }}
                                                                            >
                                                                              Measurement
                                                                              Details
                                                                            </h4>
                                                                          </b>
                                                                          <table>
                                                                            {this
                                                                              .state
                                                                              .measDirList &&
                                                                            this
                                                                              .state
                                                                              .measDirList
                                                                              .length
                                                                              ? this.state.measDirList.map(
                                                                                  (
                                                                                    dir: any,
                                                                                  ) => {
                                                                                    return (
                                                                                      <>
                                                                                        <tr
                                                                                          style={{
                                                                                            margin:
                                                                                              "auto",
                                                                                            display:
                                                                                              "table",
                                                                                            width:
                                                                                              "100%",
                                                                                          }}
                                                                                          className="query-table-row cursor-pointer noBoxShadow"
                                                                                        >
                                                                                          {dir.label !=
                                                                                            "8" && (
                                                                                            <td
                                                                                              className="padding4"
                                                                                              style={{
                                                                                                width:
                                                                                                  "60%",
                                                                                                textAlign:
                                                                                                  "center",
                                                                                              }}
                                                                                            >
                                                                                              {
                                                                                                dir.label_name
                                                                                              }
                                                                                            </td>
                                                                                          )}
                                                                                          {dir.label ==
                                                                                            "8" && (
                                                                                            <td
                                                                                              className="padding4"
                                                                                              style={{
                                                                                                width:
                                                                                                  "60%",
                                                                                                textAlign:
                                                                                                  "center",
                                                                                              }}
                                                                                            >
                                                                                              {
                                                                                                dir.measure_custom
                                                                                              }
                                                                                            </td>
                                                                                          )}
                                                                                          <td
                                                                                            className="padding4"
                                                                                            style={{
                                                                                              width:
                                                                                                "40%",
                                                                                              textAlign:
                                                                                                "center",
                                                                                            }}
                                                                                          >
                                                                                            {
                                                                                              dir.value
                                                                                            }{" "}
                                                                                            {
                                                                                              dirLabel.l_unit
                                                                                            }
                                                                                          </td>
                                                                                        </tr>
                                                                                      </>
                                                                                    );
                                                                                  },
                                                                                )
                                                                              : ""}
                                                                          </table>
                                                                          <h6
                                                                            style={{
                                                                              paddingTop:
                                                                                "14px",
                                                                            }}
                                                                          >
                                                                            With
                                                                            all
                                                                            easements
                                                                            Rights
                                                                            and
                                                                            Pathway
                                                                          </h6>
                                                                        </>
                                                                      )}
                                                                  </>
                                                                );
                                                              },
                                                            )
                                                          : ""}
                                                      </>
                                                    );
                                                  },
                                                )
                                              : ""}
                                          </td>
                                        </tr>
                                      </table>
                                    );
                                  },
                                )
                              : ""}
                          </>
                        );
                      })
                    : ""}
                  <div className="btn-toolbar sw-toolbar sw-toolbar-bottom justify-content-end">
                    <div className="btn-group mr-2 sw-btn-group" role="group">
                      <button
                        className="btn mt-2 btn-warning sw-btn-next"
                        type="button"
                        onClick={() => {
                          isVerifyFlow
                            ? window.history.back()
                            : this.props.history.push(
                                "/work-file/1/" + this.props.match.params.id,
                              );
                        }}
                      >
                        Back
                      </button>
                    </div>
                    <div
                      className="btn-group mr-2 mt-2 sw-btn-group"
                      role="group"
                    >
                      {this.state.autoAssign &&
                      this.state.autoAssign.find(
                        (data: any) =>
                          data.module_name === "Auto Assign" && data.status,
                      ) ? (
                        <>
                          {takenfile == currentfile ? (
                            <>
                              <button
                                className="btn btn-success sw-btn-next"
                                type="button"
                                onClick={() => this.saveGeneralDoc(2)}
                                disabled={this.state.isLoading}
                              >
                                {this.state.isLoading && (
                                  <i className="fa fa-spinner fa-spin"></i>
                                )}
                                Save & Submit
                              </button>
                            </>
                          ) : (
                            <>
                              {isVerifyFlow ? (
                                <>
                                  <button
                                    className="btn btn-success sw-btn-next"
                                    type="button"
                                    onClick={() => this.saveGeneralDoc(2)}
                                    disabled={this.state.isLoading}
                                  >
                                    {this.state.isLoading && (
                                      <i className="fa fa-spinner fa-spin"></i>
                                    )}
                                    Save & Submit
                                  </button>
                                </>
                              ) : (
                                ""
                              )}
                            </>
                          )}
                        </>
                      ) : (
                        <>
                          <button
                            className="btn btn-success sw-btn-next"
                            type="button"
                            onClick={() => this.saveGeneralDoc(2)}
                            disabled={this.state.isLoading}
                          >
                            {this.state.isLoading && (
                              <i className="fa fa-spinner fa-spin"></i>
                            )}
                            Save & Submit
                          </button>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              )} */}
            {this.state.showTable == true &&
              this.state.natureDocN == "Agri" && (
                <>
                  <div
                    style={{
                      paddingTop: "11px",
                      paddingBottom: "15px",
                    }}
                    className="card"
                  >
                    <b>
                      <h2
                        style={{
                          textAlign: "center",
                          fontSize: "34px !important",
                          fontWeight: "unset",
                        }}
                      >
                        Agri
                      </h2>
                    </b>
                    {this.state.surveyDetailsTD &&
                    this.state.surveyDetailsTD.length
                      ? this.state.surveyDetailsTD.map(
                          (sched: any, schIndex) => {
                            return (
                              <table
                                id="previewTable"
                                style={{
                                  width: "70%",
                                  margin: "auto",
                                }}
                                className="table table-striped table-bordered nowrap"
                              >
                                <tr className="query-table-row cursor-pointer noBoxShadow">
                                  <td className="text-align-center padding4">
                                    i
                                  </td>
                                  <td className="padding4"></td>
                                  {sched.survey_type == "survey_no" && (
                                    <td className="padding4">Survey No.</td>
                                  )}
                                  {sched.survey_type == "ts_no" && (
                                    <td className="padding4">TS No.</td>
                                  )}{" "}
                                  {sched.survey_type == "natham_survey_no" && (
                                    <td className="padding4">
                                      Natham Survey No.
                                    </td>
                                  )}
                                  <td className="padding4">As per new Patta</td>
                                  <td className="padding4">Extent</td>
                                </tr>
                                <tr className="query-table-row cursor-pointer noBoxShadow">
                                  <td className="padding4"></td>
                                  <td className="padding4"></td>
                                  {sched.survey_type == "survey_no" &&
                                    sched.old_survey_no != "" && (
                                      <td className="padding4">
                                        Old S.No- {sched.old_survey_no}, After
                                        Sub Division New S.No- {sched.survey_no}
                                      </td>
                                    )}
                                  {sched.survey_type == "survey_no" &&
                                    sched.old_survey_no == "" && (
                                      <td className="padding4">
                                        S.No- {sched.survey_no}
                                      </td>
                                    )}
                                  {sched.survey_type == "natham_survey_no" &&
                                    sched.old_natham_survey_no != "" && (
                                      <td className="padding4">
                                        Old Natham S.No-
                                        {sched.old_natham_survey_no}, New Natham
                                        S.No- {sched.natham_survey_no}
                                      </td>
                                    )}
                                  {sched.survey_type == "natham_survey_no" &&
                                    sched.old_natham_survey_no == "" && (
                                      <td className="padding4">
                                        Natham S.No- {sched.natham_survey_no}
                                      </td>
                                    )}
                                  {sched.survey_type == "ts_no" &&
                                    sched.old_ts_no != "" && (
                                      <td className="padding4">
                                        Old TS No-{sched.old_ts_no}, New TS No-
                                        {sched.ts_no}, Ward- {sched.ts_ward},
                                        Block- {sched.ts_block}
                                      </td>
                                    )}
                                  {sched.survey_type == "ts_no" &&
                                    sched.old_ts_no == "" && (
                                      <td className="padding4">
                                        TS No- {sched.ts_no}, Ward-{" "}
                                        {sched.ts_ward}, Block- {sched.ts_block}
                                      </td>
                                    )}
                                  <td className="padding4">
                                    {sched.revenue_record}
                                  </td>
                                  <td className="padding4">
                                    {sched.extent} {sched.sur_extent_unit}
                                  </td>
                                </tr>
                                <tr className="query-table-row cursor-pointer noBoxShadow">
                                  <td className="padding4"></td>
                                  <td className="padding4"></td>
                                  <td className="padding4"></td>
                                  <td className="padding4">Total Extent</td>
                                  <td className="padding4">
                                    {sched.extent} {sched.sur_extent_unit}
                                  </td>
                                </tr>
                                <tr className="query-table-row cursor-pointer noBoxShadow">
                                  <td className="text-align-center padding4">
                                    ii
                                  </td>
                                  <td colSpan={2} className="padding4">
                                    Location like name of the place, village,
                                    city, registration, sub- district etc.
                                  </td>
                                  <td colSpan={2} className="padding4">
                                    {this.state.address}
                                  </td>
                                </tr>
                                <tr className="query-table-row cursor-pointer noBoxShadow">
                                  <td className="brdrClr">iii</td>
                                  <td className="brdrClr" colSpan={4}>
                                    {sched.boundary_details &&
                                    sched.boundary_details.length
                                      ? sched.boundary_details.map(
                                          (
                                            schedB: any,
                                            boundaryIndex: number,
                                          ) => {
                                            return (
                                              <div
                                                key={boundaryIndex}
                                                style={{ marginBottom: "30px" }}
                                              >
                                                <b className="textUnderline">
                                                  {boundaryIndex + 1}.
                                                  Boundaries for{" "}
                                                  {schedB.land_aries}{" "}
                                                  {schedB.unit} of land
                                                </b>
                                                <br></br>
                                                <b className="textUnderline">
                                                  North {schedB.direction}
                                                </b>{" "}
                                                - {schedB.north}
                                                <br></br>
                                                <b className="textUnderline">
                                                  South {schedB.direction}
                                                </b>{" "}
                                                - {schedB.south}
                                                <br></br>
                                                <b className="textUnderline">
                                                  East {schedB.direction}
                                                </b>{" "}
                                                - {schedB.east}
                                                <br></br>
                                                <b className="textUnderline">
                                                  West {schedB.direction}
                                                </b>{" "}
                                                - {schedB.west}
                                                <br></br>
                                                {schedB.measurement_list &&
                                                schedB.measurement_list.length
                                                  ? schedB.measurement_list.map(
                                                      (
                                                        measurement: any,
                                                        measurementIndex: number,
                                                      ) => {
                                                        return (
                                                          <div
                                                            key={
                                                              measurementIndex
                                                            }
                                                          >
                                                            {measurement.meas_dir_list &&
                                                              measurement
                                                                .meas_dir_list
                                                                .length > 0 && (
                                                                <>
                                                                  <b>
                                                                    <h4
                                                                      style={{
                                                                        textAlign:
                                                                          "center",
                                                                        fontSize:
                                                                          "34px !important",
                                                                        fontWeight:
                                                                          "unset",
                                                                        marginTop:
                                                                          "20px",
                                                                        marginBottom:
                                                                          "10px",
                                                                      }}
                                                                    >
                                                                      Measurement
                                                                      Details
                                                                    </h4>
                                                                  </b>
                                                                  <table
                                                                    style={{
                                                                      width:
                                                                        "100%",
                                                                      borderCollapse:
                                                                        "collapse",
                                                                      margin:
                                                                        "10px 0",
                                                                      border:
                                                                        "1px solid #ddd",
                                                                    }}
                                                                  >
                                                                    <tbody>
                                                                      {measurement.meas_dir_list.map(
                                                                        (
                                                                          dir: any,
                                                                          dirIndex: number,
                                                                        ) => {
                                                                          return (
                                                                            <tr
                                                                              key={
                                                                                dirIndex
                                                                              }
                                                                              style={{
                                                                                borderBottom:
                                                                                  "1px solid #ddd",
                                                                              }}
                                                                              className="query-table-row cursor-pointer noBoxShadow"
                                                                            >
                                                                              <td
                                                                                className="padding4"
                                                                                style={{
                                                                                  width:
                                                                                    "60%",
                                                                                  textAlign:
                                                                                    "center",
                                                                                  padding:
                                                                                    "8px",
                                                                                }}
                                                                              >
                                                                                {dir.label ==
                                                                                "8"
                                                                                  ? dir.measure_custom
                                                                                  : dir.label_name}
                                                                              </td>
                                                                              <td
                                                                                className="padding4"
                                                                                style={{
                                                                                  width:
                                                                                    "40%",
                                                                                  textAlign:
                                                                                    "center",
                                                                                  padding:
                                                                                    "8px",
                                                                                }}
                                                                              >
                                                                                {
                                                                                  dir.value
                                                                                }{" "}
                                                                                {
                                                                                  measurement.l_unit
                                                                                }
                                                                              </td>
                                                                            </tr>
                                                                          );
                                                                        },
                                                                      )}
                                                                    </tbody>
                                                                  </table>
                                                                  <h6
                                                                    style={{
                                                                      paddingTop:
                                                                        "14px",
                                                                    }}
                                                                  >
                                                                    With all
                                                                    easements
                                                                    Rights and
                                                                    Pathway
                                                                  </h6>
                                                                </>
                                                              )}
                                                          </div>
                                                        );
                                                      },
                                                    )
                                                  : ""}
                                              </div>
                                            );
                                          },
                                        )
                                      : ""}
                                  </td>
                                </tr>
                              </table>
                            );
                          },
                        )
                      : ""}
                    <div className="btn-toolbar sw-toolbar sw-toolbar-bottom justify-content-end">
                      <div className="btn-group mr-2 sw-btn-group" role="group">
                        <button
                          className="btn mt-2 btn-warning sw-btn-next"
                          type="button"
                          onClick={() => {
                            isVerifyFlow
                              ? window.history.back()
                              : this.props.history.push(
                                  "/work-file/1/" + this.props.match.params.id,
                                );
                          }}
                        >
                          Back
                        </button>
                      </div>
                      <div
                        className="btn-group mr-2 mt-2 sw-btn-group"
                        role="group"
                      >
                        {this.state.autoAssign &&
                        this.state.autoAssign.find(
                          (data: any) =>
                            data.module_name === "Auto Assign" && data.status,
                        ) ? (
                          <>
                            {takenfile == currentfile ? (
                              <>
                                <button
                                  className="btn btn-success sw-btn-next"
                                  type="button"
                                  onClick={() => this.saveGeneralDoc(2)}
                                  disabled={this.state.isLoading}
                                >
                                  {this.state.isLoading && (
                                    <i className="fa fa-spinner fa-spin"></i>
                                  )}
                                  Save & Submit
                                </button>
                              </>
                            ) : (
                              <>
                                {isVerifyFlow ? (
                                  <>
                                    <button
                                      className="btn btn-success sw-btn-next"
                                      type="button"
                                      onClick={() => this.saveGeneralDoc(2)}
                                      disabled={this.state.isLoading}
                                    >
                                      {this.state.isLoading && (
                                        <i className="fa fa-spinner fa-spin"></i>
                                      )}
                                      Save & Submit
                                    </button>
                                  </>
                                ) : (
                                  ""
                                )}
                              </>
                            )}
                          </>
                        ) : (
                          <>
                            <button
                              className="btn btn-success sw-btn-next"
                              type="button"
                              onClick={() => this.saveGeneralDoc(2)}
                              disabled={this.state.isLoading}
                            >
                              {this.state.isLoading && (
                                <i className="fa fa-spinner fa-spin"></i>
                              )}
                              Save & Submit
                            </button>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </>
              )}
            {this.state.showTable == true &&
              this.state.natureDocN == "Existing building" && (
                <>
                  <div
                    style={{
                      paddingTop: "11px",
                      paddingBottom: "15px",
                    }}
                    className="card"
                  >
                    <b>
                      <h2
                        style={{
                          textAlign: "center",
                          fontSize: "34px !important",
                          fontWeight: "unset",
                        }}
                      >
                        Existing building
                      </h2>
                    </b>
                    {this.state.schedules && this.state.schedules.length
                      ? this.state.schedules.map(
                          (schList: any, schListIndex) => {
                            return (
                              <>
                                {schList.survey_details &&
                                schList.survey_details.length
                                  ? schList.survey_details.map(
                                      (sched: any, schIndex) => {
                                        return (
                                          <table
                                            id="previewTable"
                                            style={{
                                              width: "70%",
                                              margin: "auto",
                                            }}
                                            className="table table-striped table-bordered nowrap"
                                          >
                                            <tr className="query-table-row cursor-pointer noBoxShadow">
                                              <td className="text-align-center padding4">
                                                i
                                              </td>
                                              {sched.survey_type ==
                                                "survey_no" && (
                                                <td className="padding4">
                                                  Survey No.
                                                </td>
                                              )}
                                              {sched.survey_type == "ts_no" && (
                                                <td className="padding4">
                                                  TS No.
                                                </td>
                                              )}{" "}
                                              {sched.survey_type ==
                                                "natham_survey_no" && (
                                                <td className="padding4">
                                                  Natham Survey No.
                                                </td>
                                              )}
                                              {sched.survey_type ==
                                                "survey_no" &&
                                                sched.old_survey_no != "" && (
                                                  <td className="padding4">
                                                    Old S.No-{" "}
                                                    {sched.old_survey_no}, After
                                                    Sub Division New S.No-{" "}
                                                    {sched.survey_no}
                                                  </td>
                                                )}
                                              {sched.survey_type ==
                                                "survey_no" &&
                                                sched.old_survey_no == "" && (
                                                  <td className="padding4">
                                                    S.No- {sched.survey_no}
                                                  </td>
                                                )}
                                              {sched.survey_type ==
                                                "natham_survey_no" &&
                                                sched.old_natham_survey_no !=
                                                  "" && (
                                                  <td className="padding4">
                                                    Old Natham S.No-
                                                    {sched.old_natham_survey_no}
                                                    , New Natham S.No-{" "}
                                                    {sched.natham_survey_no}
                                                  </td>
                                                )}
                                              {sched.survey_type ==
                                                "natham_survey_no" &&
                                                sched.old_natham_survey_no ==
                                                  "" && (
                                                  <td className="padding4">
                                                    Natham S.No-{" "}
                                                    {sched.natham_survey_no}
                                                  </td>
                                                )}
                                              {sched.survey_type == "ts_no" &&
                                                sched.old_ts_no != "" && (
                                                  <td className="padding4">
                                                    Old TS No-{sched.old_ts_no},
                                                    New TS No-{sched.ts_no},
                                                    Ward- {sched.ts_ward},
                                                    Block- {sched.ts_block}
                                                  </td>
                                                )}
                                              {sched.survey_type == "ts_no" &&
                                                sched.old_ts_no == "" && (
                                                  <td className="padding4">
                                                    TS No- {sched.ts_no}, Ward-{" "}
                                                    {sched.ts_ward}, Block-{" "}
                                                    {sched.ts_block}
                                                  </td>
                                                )}
                                            </tr>
                                            <tr className="query-table-row cursor-pointer noBoxShadow">
                                              <td className="text-align-center padding4">
                                                ii
                                              </td>
                                              <td className="padding4">
                                                As per Revenue Record
                                              </td>
                                              <td className="padding4">
                                                {sched.revenue_record}
                                              </td>
                                            </tr>
                                            <tr className="query-table-row cursor-pointer noBoxShadow">
                                              <td className="text-align-center padding4">
                                                iii
                                              </td>
                                              <td className="padding4">
                                                Total Extent
                                              </td>
                                              <td className="padding4">
                                                {sched.extent}{" "}
                                                {sched.sur_extent_unit}
                                              </td>
                                            </tr>
                                            {this.state.showdoor_no == true && (
                                              <>
                                                <tr className="query-table-row cursor-pointer noBoxShadow">
                                                  <td className="text-align-center padding4">
                                                    iv
                                                  </td>
                                                  <td className="padding4">
                                                    Door No (As per property
                                                    tax)
                                                  </td>
                                                  <td className="padding4">
                                                    {schList.door_no}
                                                  </td>
                                                </tr>
                                              </>
                                            )}
                                            <tr className="query-table-row cursor-pointer noBoxShadow">
                                              {this.state.showdoor_no ==
                                              true ? (
                                                <>
                                                  <td className="text-align-center padding4">
                                                    v
                                                  </td>
                                                </>
                                              ) : (
                                                <>
                                                  <td className="text-align-center padding4">
                                                    iv
                                                  </td>
                                                </>
                                              )}
                                              <td className="padding4">
                                                Location like name of the place,
                                                village, city, registration,
                                                sub- district etc.
                                              </td>
                                              <td className="padding4">
                                                {this.state.address}
                                              </td>
                                            </tr>
                                            <tr className="query-table-row cursor-pointer noBoxShadow">
                                              {this.state.showdoor_no ==
                                              true ? (
                                                <>
                                                  <td className="text-align-center padding4">
                                                    vi
                                                  </td>
                                                </>
                                              ) : (
                                                <>
                                                  <td className="brdrClr">v</td>
                                                </>
                                              )}

                                              <td
                                                className="brdrClr"
                                                colSpan={2}
                                              >
                                                {sched.boundary_details &&
                                                sched.boundary_details.length
                                                  ? sched.boundary_details.map(
                                                      (
                                                        schedB: any,
                                                        boundaryIndex: number,
                                                      ) => {
                                                        return (
                                                          <div
                                                            key={boundaryIndex}
                                                            style={{
                                                              marginBottom:
                                                                "30px",
                                                            }}
                                                          >
                                                            <b className="textUnderline">
                                                              {boundaryIndex +
                                                                1}
                                                              . Boundaries for{" "}
                                                              {
                                                                schedB.land_aries
                                                              }{" "}
                                                              {schedB.unit} of
                                                              land
                                                            </b>
                                                            <br></br>
                                                            <b className="textUnderline">
                                                              North{" "}
                                                              {schedB.direction}
                                                            </b>{" "}
                                                            - {schedB.north}
                                                            <br></br>
                                                            <b className="textUnderline">
                                                              South{" "}
                                                              {schedB.direction}
                                                            </b>{" "}
                                                            - {schedB.south}
                                                            <br></br>
                                                            <b className="textUnderline">
                                                              East{" "}
                                                              {schedB.direction}
                                                            </b>{" "}
                                                            - {schedB.east}
                                                            <br></br>
                                                            <b className="textUnderline">
                                                              West{" "}
                                                              {schedB.direction}
                                                            </b>{" "}
                                                            - {schedB.west}
                                                            <br></br>
                                                            {schedB.measurement_list &&
                                                            schedB
                                                              .measurement_list
                                                              .length
                                                              ? schedB.measurement_list.map(
                                                                  (
                                                                    measurement: any,
                                                                    measurementIndex: number,
                                                                  ) => {
                                                                    return (
                                                                      <div
                                                                        key={
                                                                          measurementIndex
                                                                        }
                                                                      >
                                                                        {measurement.meas_dir_list &&
                                                                          measurement
                                                                            .meas_dir_list
                                                                            .length >
                                                                            0 && (
                                                                            <>
                                                                              <b>
                                                                                <h4
                                                                                  style={{
                                                                                    textAlign:
                                                                                      "center",
                                                                                    fontSize:
                                                                                      "34px !important",
                                                                                    fontWeight:
                                                                                      "unset",
                                                                                    marginTop:
                                                                                      "20px",
                                                                                    marginBottom:
                                                                                      "10px",
                                                                                  }}
                                                                                >
                                                                                  Measurement
                                                                                  Details
                                                                                </h4>
                                                                              </b>
                                                                              <table
                                                                                style={{
                                                                                  width:
                                                                                    "100%",
                                                                                  borderCollapse:
                                                                                    "collapse",
                                                                                  margin:
                                                                                    "10px 0",
                                                                                  border:
                                                                                    "1px solid #ddd",
                                                                                }}
                                                                              >
                                                                                <tbody>
                                                                                  {measurement.meas_dir_list.map(
                                                                                    (
                                                                                      dir: any,
                                                                                      dirIndex: number,
                                                                                    ) => {
                                                                                      return (
                                                                                        <tr
                                                                                          key={
                                                                                            dirIndex
                                                                                          }
                                                                                          style={{
                                                                                            borderBottom:
                                                                                              "1px solid #ddd",
                                                                                          }}
                                                                                          className="query-table-row cursor-pointer noBoxShadow"
                                                                                        >
                                                                                          <td
                                                                                            className="padding4"
                                                                                            style={{
                                                                                              width:
                                                                                                "60%",
                                                                                              textAlign:
                                                                                                "center",
                                                                                              padding:
                                                                                                "8px",
                                                                                            }}
                                                                                          >
                                                                                            {dir.label ==
                                                                                            "8"
                                                                                              ? dir.measure_custom
                                                                                              : dir.label_name}
                                                                                          </td>
                                                                                          <td
                                                                                            className="padding4"
                                                                                            style={{
                                                                                              width:
                                                                                                "40%",
                                                                                              textAlign:
                                                                                                "center",
                                                                                              padding:
                                                                                                "8px",
                                                                                            }}
                                                                                          >
                                                                                            {
                                                                                              dir.value
                                                                                            }{" "}
                                                                                            {
                                                                                              measurement.l_unit
                                                                                            }
                                                                                          </td>
                                                                                        </tr>
                                                                                      );
                                                                                    },
                                                                                  )}
                                                                                </tbody>
                                                                              </table>
                                                                              <h6
                                                                                style={{
                                                                                  paddingTop:
                                                                                    "14px",
                                                                                }}
                                                                              >
                                                                                With
                                                                                all
                                                                                easements
                                                                                Rights
                                                                                and
                                                                                Pathway
                                                                              </h6>
                                                                            </>
                                                                          )}
                                                                      </div>
                                                                    );
                                                                  },
                                                                )
                                                              : ""}
                                                          </div>
                                                        );
                                                      },
                                                    )
                                                  : ""}
                                              </td>
                                            </tr>
                                          </table>
                                        );
                                      },
                                    )
                                  : ""}
                              </>
                            );
                          },
                        )
                      : ""}
                    <div className="btn-toolbar sw-toolbar sw-toolbar-bottom justify-content-end">
                      <div className="btn-group mr-2 sw-btn-group" role="group">
                        <button
                          className="btn mt-2 btn-warning sw-btn-next"
                          type="button"
                          onClick={() => {
                            isVerifyFlow
                              ? window.history.back()
                              : this.props.history.push(
                                  "/work-file/1/" + this.props.match.params.id,
                                );
                          }}
                        >
                          Back
                        </button>
                      </div>
                      <div
                        className="btn-group mr-2 mt-2 sw-btn-group"
                        role="group"
                      >
                        {this.state.autoAssign &&
                        this.state.autoAssign.find(
                          (data: any) =>
                            data.module_name === "Auto Assign" && data.status,
                        ) ? (
                          <>
                            {takenfile == currentfile ? (
                              <>
                                <button
                                  className="btn btn-success sw-btn-next"
                                  type="button"
                                  onClick={() => this.saveGeneralDoc(2)}
                                  disabled={this.state.isLoading}
                                >
                                  {this.state.isLoading && (
                                    <i className="fa fa-spinner fa-spin"></i>
                                  )}
                                  Save & Submit
                                </button>
                              </>
                            ) : (
                              <>
                                {isVerifyFlow ? (
                                  <>
                                    <button
                                      className="btn btn-success sw-btn-next"
                                      type="button"
                                      onClick={() => this.saveGeneralDoc(2)}
                                      disabled={this.state.isLoading}
                                    >
                                      {this.state.isLoading && (
                                        <i className="fa fa-spinner fa-spin"></i>
                                      )}
                                      Save & Submit
                                    </button>
                                  </>
                                ) : (
                                  ""
                                )}
                              </>
                            )}
                          </>
                        ) : (
                          <>
                            <button
                              className="btn btn-success sw-btn-next"
                              type="button"
                              onClick={() => this.saveGeneralDoc(2)}
                              disabled={this.state.isLoading}
                            >
                              {this.state.isLoading && (
                                <i className="fa fa-spinner fa-spin"></i>
                              )}
                              Save & Submit
                            </button>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </>
              )}
            {this.state.showTable == true &&
              this.state.natureDocN == "Under construction" && (
                <div
                  style={{
                    paddingTop: "11px",
                    paddingBottom: "15px",
                  }}
                  className="card"
                >
                  <b>
                    <h2
                      style={{
                        textAlign: "center",
                        fontSize: "34px !important",
                        fontWeight: "unset",
                      }}
                    >
                      Under construction
                    </h2>
                  </b>
                  {this.state.schedules && this.state.schedules.length
                    ? this.state.schedules.map((schList: any, schListIndex) => {
                        return (
                          <>
                            {schList.survey_details &&
                            schList.survey_details.length
                              ? schList.survey_details.map(
                                  (sched: any, schIndex) => {
                                    return (
                                      <table
                                        id="previewTable"
                                        style={{
                                          width: "70%",
                                          margin: "auto",
                                        }}
                                        className="table table-striped table-bordered nowrap"
                                      >
                                        <tr className="query-table-row cursor-pointer noBoxShadow">
                                          <td className="text-align-center padding4">
                                            i
                                          </td>
                                          {sched.survey_type == "survey_no" && (
                                            <td className="padding4">
                                              Survey No.
                                            </td>
                                          )}
                                          {sched.survey_type == "ts_no" && (
                                            <td className="padding4">TS No.</td>
                                          )}{" "}
                                          {sched.survey_type ==
                                            "natham_survey_no" && (
                                            <td className="padding4">
                                              Natham Survey No.
                                            </td>
                                          )}
                                          {sched.survey_type == "survey_no" &&
                                            sched.old_survey_no != "" && (
                                              <td className="padding4">
                                                Old S.No- {sched.old_survey_no},
                                                After Sub Division New S.No-{" "}
                                                {sched.survey_no}
                                              </td>
                                            )}
                                          {sched.survey_type == "survey_no" &&
                                            sched.old_survey_no == "" && (
                                              <td className="padding4">
                                                S.No- {sched.survey_no}
                                              </td>
                                            )}
                                          {sched.survey_type ==
                                            "natham_survey_no" &&
                                            sched.old_natham_survey_no !=
                                              "" && (
                                              <td className="padding4">
                                                Old Natham S.No-
                                                {sched.old_natham_survey_no},
                                                New Natham S.No-{" "}
                                                {sched.natham_survey_no}
                                              </td>
                                            )}
                                          {sched.survey_type ==
                                            "natham_survey_no" &&
                                            sched.old_natham_survey_no ==
                                              "" && (
                                              <td className="padding4">
                                                Natham S.No-{" "}
                                                {sched.natham_survey_no}
                                              </td>
                                            )}
                                          {sched.survey_type == "ts_no" &&
                                            sched.old_ts_no != "" && (
                                              <td className="padding4">
                                                Old TS No-{sched.old_ts_no}, New
                                                TS No-{sched.ts_no}, Ward-{" "}
                                                {sched.ts_ward}, Block-{" "}
                                                {sched.ts_block}
                                              </td>
                                            )}
                                          {sched.survey_type == "ts_no" &&
                                            sched.old_ts_no == "" && (
                                              <td className="padding4">
                                                TS No- {sched.ts_no}, Ward-{" "}
                                                {sched.ts_ward}, Block-{" "}
                                                {sched.ts_block}
                                              </td>
                                            )}
                                        </tr>
                                        <tr className="query-table-row cursor-pointer noBoxShadow">
                                          <td className="text-align-center padding4">
                                            ii
                                          </td>
                                          <td className="padding4">
                                            As per Revenue Record
                                          </td>
                                          <td className="padding4">
                                            {sched.revenue_record}
                                          </td>
                                        </tr>
                                        <tr className="query-table-row cursor-pointer noBoxShadow">
                                          <td className="text-align-center padding4">
                                            iii
                                          </td>
                                          <td className="padding4">
                                            Total Extent
                                          </td>
                                          <td className="padding4">
                                            {sched.extent}{" "}
                                            {sched.sur_extent_unit}
                                          </td>
                                        </tr>
                                        <tr className="query-table-row cursor-pointer noBoxShadow">
                                          <td className="text-align-center padding4">
                                            iv
                                          </td>
                                          <td className="padding4">
                                            Door No (As per property tax)
                                          </td>
                                          <td className="padding4">
                                            {schList.door_no}
                                          </td>
                                        </tr>
                                        <tr className="query-table-row cursor-pointer noBoxShadow">
                                          <td className="text-align-center padding4">
                                            v
                                          </td>
                                          <td className="padding4">
                                            Location like name of the place,
                                            village, city, registration, sub-
                                            district etc.
                                          </td>
                                          <td className="padding4">
                                            {this.state.address}
                                          </td>
                                        </tr>
                                        <tr className="query-table-row cursor-pointer noBoxShadow">
                                          <td className="brdrClr">vi</td>
                                          <td className="brdrClr" colSpan={2}>
                                            {sched.boundary_details &&
                                            sched.boundary_details.length
                                              ? sched.boundary_details.map(
                                                  (
                                                    schedB: any,
                                                    boundaryIndex: number,
                                                  ) => {
                                                    return (
                                                      <div
                                                        key={boundaryIndex}
                                                        style={{
                                                          marginBottom: "30px",
                                                        }}
                                                      >
                                                        <b className="textUnderline">
                                                          {boundaryIndex + 1}.
                                                          Boundaries for{" "}
                                                          {schedB.land_aries}{" "}
                                                          {schedB.unit} of land
                                                        </b>
                                                        <br></br>
                                                        <b className="textUnderline">
                                                          North{" "}
                                                          {schedB.direction}
                                                        </b>{" "}
                                                        - {schedB.north}
                                                        <br></br>
                                                        <b className="textUnderline">
                                                          South{" "}
                                                          {schedB.direction}
                                                        </b>{" "}
                                                        - {schedB.south}
                                                        <br></br>
                                                        <b className="textUnderline">
                                                          East{" "}
                                                          {schedB.direction}
                                                        </b>{" "}
                                                        - {schedB.east}
                                                        <br></br>
                                                        <b className="textUnderline">
                                                          West{" "}
                                                          {schedB.direction}
                                                        </b>{" "}
                                                        - {schedB.west}
                                                        <br></br>
                                                        {schedB.measurement_list &&
                                                        schedB.measurement_list
                                                          .length
                                                          ? schedB.measurement_list.map(
                                                              (
                                                                measurement: any,
                                                                measurementIndex: number,
                                                              ) => {
                                                                return (
                                                                  <div
                                                                    key={
                                                                      measurementIndex
                                                                    }
                                                                  >
                                                                    {measurement.meas_dir_list &&
                                                                      measurement
                                                                        .meas_dir_list
                                                                        .length >
                                                                        0 && (
                                                                        <>
                                                                          <b>
                                                                            <h4
                                                                              style={{
                                                                                textAlign:
                                                                                  "center",
                                                                                fontSize:
                                                                                  "34px !important",
                                                                                fontWeight:
                                                                                  "unset",
                                                                                marginTop:
                                                                                  "20px",
                                                                                marginBottom:
                                                                                  "10px",
                                                                              }}
                                                                            >
                                                                              Measurement
                                                                              Details
                                                                            </h4>
                                                                          </b>
                                                                          <table
                                                                            style={{
                                                                              width:
                                                                                "100%",
                                                                              borderCollapse:
                                                                                "collapse",
                                                                              margin:
                                                                                "10px 0",
                                                                              border:
                                                                                "1px solid #ddd",
                                                                            }}
                                                                          >
                                                                            <tbody>
                                                                              {measurement.meas_dir_list.map(
                                                                                (
                                                                                  dir: any,
                                                                                  dirIndex: number,
                                                                                ) => {
                                                                                  return (
                                                                                    <tr
                                                                                      key={
                                                                                        dirIndex
                                                                                      }
                                                                                      style={{
                                                                                        borderBottom:
                                                                                          "1px solid #ddd",
                                                                                      }}
                                                                                      className="query-table-row cursor-pointer noBoxShadow"
                                                                                    >
                                                                                      <td
                                                                                        className="padding4"
                                                                                        style={{
                                                                                          width:
                                                                                            "60%",
                                                                                          textAlign:
                                                                                            "center",
                                                                                          padding:
                                                                                            "8px",
                                                                                        }}
                                                                                      >
                                                                                        {dir.label ==
                                                                                        "8"
                                                                                          ? dir.measure_custom
                                                                                          : dir.label_name}
                                                                                      </td>
                                                                                      <td
                                                                                        className="padding4"
                                                                                        style={{
                                                                                          width:
                                                                                            "40%",
                                                                                          textAlign:
                                                                                            "center",
                                                                                          padding:
                                                                                            "8px",
                                                                                        }}
                                                                                      >
                                                                                        {
                                                                                          dir.value
                                                                                        }{" "}
                                                                                        {
                                                                                          measurement.l_unit
                                                                                        }
                                                                                      </td>
                                                                                    </tr>
                                                                                  );
                                                                                },
                                                                              )}
                                                                            </tbody>
                                                                          </table>
                                                                          <h6
                                                                            style={{
                                                                              paddingTop:
                                                                                "14px",
                                                                            }}
                                                                          >
                                                                            With
                                                                            all
                                                                            easements
                                                                            Rights
                                                                            and
                                                                            Pathway
                                                                          </h6>
                                                                        </>
                                                                      )}
                                                                  </div>
                                                                );
                                                              },
                                                            )
                                                          : ""}
                                                      </div>
                                                    );
                                                  },
                                                )
                                              : ""}
                                          </td>
                                        </tr>
                                      </table>
                                    );
                                  },
                                )
                              : ""}
                          </>
                        );
                      })
                    : ""}
                  <div className="btn-toolbar sw-toolbar sw-toolbar-bottom justify-content-end">
                    <div className="btn-group mr-2 sw-btn-group" role="group">
                      <button
                        className="btn mt-2 btn-warning sw-btn-next"
                        type="button"
                        onClick={() => {
                          isVerifyFlow
                            ? window.history.back()
                            : this.props.history.push(
                                "/work-file/1/" + this.props.match.params.id,
                              );
                        }}
                      >
                        Back
                      </button>
                    </div>
                    <div
                      className="btn-group mr-2 mt-2 sw-btn-group"
                      role="group"
                    >
                      {this.state.autoAssign &&
                      this.state.autoAssign.find(
                        (data: any) =>
                          data.module_name === "Auto Assign" && data.status,
                      ) ? (
                        <>
                          {takenfile == currentfile ? (
                            <>
                              <button
                                className="btn btn-success sw-btn-next"
                                type="button"
                                onClick={() => this.saveGeneralDoc(2)}
                                disabled={this.state.isLoading}
                              >
                                {this.state.isLoading && (
                                  <i className="fa fa-spinner fa-spin"></i>
                                )}
                                Save & Submit
                              </button>
                            </>
                          ) : (
                            <>
                              {isVerifyFlow ? (
                                <>
                                  <button
                                    className="btn btn-success sw-btn-next"
                                    type="button"
                                    onClick={() => this.saveGeneralDoc(2)}
                                    disabled={this.state.isLoading}
                                  >
                                    {this.state.isLoading && (
                                      <i className="fa fa-spinner fa-spin"></i>
                                    )}
                                    Save & Submit
                                  </button>
                                </>
                              ) : (
                                ""
                              )}
                            </>
                          )}
                        </>
                      ) : (
                        <>
                          <button
                            className="btn btn-success sw-btn-next"
                            type="button"
                            onClick={() => this.saveGeneralDoc(2)}
                            disabled={this.state.isLoading}
                          >
                            {this.state.isLoading && (
                              <i className="fa fa-spinner fa-spin"></i>
                            )}
                            Save & Submit
                          </button>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              )}
            {this.state.showTable == true &&
              this.state.natureDocN == "vacant land" && (
                <>
                  <div
                    style={{
                      paddingTop: "11px",
                      paddingBottom: "15px",
                    }}
                    className="card"
                  >
                    <b>
                      <h2
                        style={{
                          textAlign: "center",
                          fontSize: "34px !important",
                          fontWeight: "unset",
                        }}
                      >
                        Vacant land
                      </h2>
                    </b>
                    {this.state.surveyDetailsTD &&
                    this.state.surveyDetailsTD.length
                      ? this.state.surveyDetailsTD.map(
                          (sched: any, schIndex) => {
                            return (
                              <table
                                id="previewTable"
                                style={{
                                  width: "70%",
                                  margin: "auto",
                                }}
                                className="table table-striped table-bordered nowrap"
                              >
                                <tr className="query-table-row cursor-pointer noBoxShadow">
                                  <td className="text-align-center padding4">
                                    i
                                  </td>
                                  <td className="padding4"></td>
                                  {sched.survey_type == "survey_no" && (
                                    <td className="padding4">Survey No.</td>
                                  )}
                                  {sched.survey_type == "ts_no" && (
                                    <td className="padding4">TS No.</td>
                                  )}{" "}
                                  {sched.survey_type == "natham_survey_no" && (
                                    <td className="padding4">
                                      Natham Survey No.
                                    </td>
                                  )}
                                  <td className="padding4">As per new Patta</td>
                                  <td className="padding4">Extent</td>
                                </tr>
                                <tr className="query-table-row cursor-pointer noBoxShadow">
                                  <td className="padding4"></td>
                                  <td className="padding4"></td>
                                  {sched.survey_type == "survey_no" &&
                                    sched.old_survey_no != "" && (
                                      <td className="padding4">
                                        Old S.No- {sched.old_survey_no}, After
                                        Sub Division New S.No- {sched.survey_no}
                                      </td>
                                    )}
                                  {sched.survey_type == "survey_no" &&
                                    sched.old_survey_no == "" && (
                                      <td className="padding4">
                                        S.No- {sched.survey_no}
                                      </td>
                                    )}
                                  {sched.survey_type == "natham_survey_no" &&
                                    sched.old_natham_survey_no != "" && (
                                      <td className="padding4">
                                        Old Natham S.No-
                                        {sched.old_natham_survey_no}, New Natham
                                        S.No- {sched.natham_survey_no}
                                      </td>
                                    )}
                                  {sched.survey_type == "natham_survey_no" &&
                                    sched.old_natham_survey_no == "" && (
                                      <td className="padding4">
                                        Natham S.No- {sched.natham_survey_no}
                                      </td>
                                    )}
                                  {sched.survey_type == "ts_no" &&
                                    sched.old_ts_no != "" && (
                                      <td className="padding4">
                                        Old TS No-{sched.old_ts_no}, New TS No-
                                        {sched.ts_no}, Ward- {sched.ts_ward},
                                        Block- {sched.ts_block}
                                      </td>
                                    )}
                                  {sched.survey_type == "ts_no" &&
                                    sched.old_ts_no == "" && (
                                      <td className="padding4">
                                        TS No- {sched.ts_no}, Ward-{" "}
                                        {sched.ts_ward}, Block- {sched.ts_block}
                                      </td>
                                    )}
                                  <td className="padding4">
                                    {sched.revenue_record}
                                  </td>
                                  <td className="padding4">
                                    {sched.extent} {sched.sur_extent_unit}
                                  </td>
                                </tr>
                                <tr className="query-table-row cursor-pointer noBoxShadow">
                                  <td className="padding4"></td>
                                  <td className="padding4"></td>
                                  <td className="padding4"></td>
                                  <td className="padding4">Total Extent</td>
                                  <td className="padding4">
                                    {sched.extent} {sched.sur_extent_unit}
                                  </td>
                                </tr>
                                <tr className="query-table-row cursor-pointer noBoxShadow">
                                  <td className="text-align-center padding4">
                                    ii
                                  </td>
                                  <td colSpan={2} className="padding4">
                                    Location like name of the place, village,
                                    city, registration, sub- district etc.
                                  </td>
                                  <td colSpan={2} className="padding4">
                                    {this.state.address}
                                  </td>
                                </tr>
                                <tr className="query-table-row cursor-pointer noBoxShadow">
                                  <td className="brdrClr">iii</td>
                                  <td className="brdrClr" colSpan={4}>
                                    {sched.boundary_details &&
                                    sched.boundary_details.length
                                      ? sched.boundary_details.map(
                                          (
                                            schedB: any,
                                            boundaryIndex: number,
                                          ) => {
                                            return (
                                              <div
                                                key={boundaryIndex}
                                                style={{ marginBottom: "30px" }}
                                              >
                                                <b className="textUnderline">
                                                  {boundaryIndex + 1}.
                                                  Boundaries for{" "}
                                                  {schedB.land_aries}{" "}
                                                  {schedB.unit} of land
                                                </b>
                                                <br></br>
                                                <b className="textUnderline">
                                                  North {schedB.direction}
                                                </b>{" "}
                                                - {schedB.north}
                                                <br></br>
                                                <b className="textUnderline">
                                                  South {schedB.direction}
                                                </b>{" "}
                                                - {schedB.south}
                                                <br></br>
                                                <b className="textUnderline">
                                                  East {schedB.direction}
                                                </b>{" "}
                                                - {schedB.east}
                                                <br></br>
                                                <b className="textUnderline">
                                                  West {schedB.direction}
                                                </b>{" "}
                                                - {schedB.west}
                                                <br></br>
                                                {schedB.measurement_list &&
                                                schedB.measurement_list.length
                                                  ? schedB.measurement_list.map(
                                                      (
                                                        measurement: any,
                                                        measurementIndex: number,
                                                      ) => {
                                                        return (
                                                          <div
                                                            key={
                                                              measurementIndex
                                                            }
                                                          >
                                                            {measurement.meas_dir_list &&
                                                              measurement
                                                                .meas_dir_list
                                                                .length > 0 && (
                                                                <>
                                                                  <b>
                                                                    <h4
                                                                      style={{
                                                                        textAlign:
                                                                          "center",
                                                                        fontSize:
                                                                          "34px !important",
                                                                        fontWeight:
                                                                          "unset",
                                                                        marginTop:
                                                                          "20px",
                                                                        marginBottom:
                                                                          "10px",
                                                                      }}
                                                                    >
                                                                      Measurement
                                                                      Details
                                                                    </h4>
                                                                  </b>
                                                                  <table
                                                                    style={{
                                                                      width:
                                                                        "100%",
                                                                      borderCollapse:
                                                                        "collapse",
                                                                      margin:
                                                                        "10px 0",
                                                                      border:
                                                                        "1px solid #ddd",
                                                                    }}
                                                                  >
                                                                    <tbody>
                                                                      {measurement.meas_dir_list.map(
                                                                        (
                                                                          dir: any,
                                                                          dirIndex: number,
                                                                        ) => {
                                                                          return (
                                                                            <tr
                                                                              key={
                                                                                dirIndex
                                                                              }
                                                                              style={{
                                                                                borderBottom:
                                                                                  "1px solid #ddd",
                                                                              }}
                                                                              className="query-table-row cursor-pointer noBoxShadow"
                                                                            >
                                                                              <td
                                                                                className="padding4"
                                                                                style={{
                                                                                  width:
                                                                                    "60%",
                                                                                  textAlign:
                                                                                    "center",
                                                                                  padding:
                                                                                    "8px",
                                                                                }}
                                                                              >
                                                                                {dir.label ==
                                                                                "8"
                                                                                  ? dir.measure_custom
                                                                                  : dir.label_name}
                                                                              </td>
                                                                              <td
                                                                                className="padding4"
                                                                                style={{
                                                                                  width:
                                                                                    "40%",
                                                                                  textAlign:
                                                                                    "center",
                                                                                  padding:
                                                                                    "8px",
                                                                                }}
                                                                              >
                                                                                {
                                                                                  dir.value
                                                                                }{" "}
                                                                                {
                                                                                  measurement.l_unit
                                                                                }
                                                                              </td>
                                                                            </tr>
                                                                          );
                                                                        },
                                                                      )}
                                                                    </tbody>
                                                                  </table>
                                                                  <h6
                                                                    style={{
                                                                      paddingTop:
                                                                        "14px",
                                                                    }}
                                                                  >
                                                                    With all
                                                                    easements
                                                                    Rights and
                                                                    Pathway
                                                                  </h6>
                                                                </>
                                                              )}
                                                          </div>
                                                        );
                                                      },
                                                    )
                                                  : ""}
                                              </div>
                                            );
                                          },
                                        )
                                      : ""}
                                  </td>
                                </tr>
                              </table>
                            );
                          },
                        )
                      : ""}
                    <div className="btn-toolbar sw-toolbar sw-toolbar-bottom justify-content-end">
                      <div className="btn-group mr-2 sw-btn-group" role="group">
                        <button
                          className="btn mt-2 btn-warning sw-btn-next"
                          type="button"
                          onClick={() => {
                            isVerifyFlow
                              ? window.history.back()
                              : this.props.history.push(
                                  "/work-file/1/" + this.props.match.params.id,
                                );
                          }}
                        >
                          Back
                        </button>
                      </div>
                      <div
                        className="btn-group mr-2 mt-2 sw-btn-group"
                        role="group"
                      >
                        {this.state.autoAssign &&
                        this.state.autoAssign.find(
                          (data: any) =>
                            data.module_name === "Auto Assign" && data.status,
                        ) ? (
                          <>
                            {takenfile == currentfile ? (
                              <>
                                <button
                                  className="btn btn-success sw-btn-next"
                                  type="button"
                                  onClick={() => this.saveGeneralDoc(2)}
                                  disabled={this.state.isLoading}
                                >
                                  {this.state.isLoading && (
                                    <i className="fa fa-spinner fa-spin"></i>
                                  )}
                                  Save & Submit
                                </button>
                              </>
                            ) : (
                              <>
                                {isVerifyFlow ? (
                                  <>
                                    <button
                                      className="btn btn-success sw-btn-next"
                                      type="button"
                                      onClick={() => this.saveGeneralDoc(2)}
                                      disabled={this.state.isLoading}
                                    >
                                      {this.state.isLoading && (
                                        <i className="fa fa-spinner fa-spin"></i>
                                      )}
                                      Save & Submit
                                    </button>
                                  </>
                                ) : (
                                  ""
                                )}
                              </>
                            )}
                          </>
                        ) : (
                          <>
                            <button
                              className="btn btn-success sw-btn-next"
                              type="button"
                              onClick={() => this.saveGeneralDoc(2)}
                              disabled={this.state.isLoading}
                            >
                              {this.state.isLoading && (
                                <i className="fa fa-spinner fa-spin"></i>
                              )}
                              Save & Submit
                            </button>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </>
              )}

            {this.state.showTable == true &&
              this.state.natureDocN == "appartment" && (
                <div
                  style={{
                    paddingTop: "11px",
                    paddingBottom: "15px",
                  }}
                  className="card"
                >
                  <b>
                    <h2
                      style={{
                        textAlign: "center",
                        fontSize: "34px !important",
                        fontWeight: "unset",
                      }}
                    >
                      Apartment
                    </h2>
                  </b>
                  {this.state.schedules && this.state.schedules.length
                    ? this.state.schedules.map((schList: any, schListIndex) => {
                        return (
                          <>
                            {schList.survey_details &&
                            schList.survey_details.length
                              ? schList.survey_details.map(
                                  (sched: any, schIndex) => {
                                    return (
                                      <table
                                        id="previewTable"
                                        style={{
                                          width: "70%",
                                          margin: "auto",
                                        }}
                                        className="table table-striped table-bordered nowrap"
                                      >
                                        <tr className="query-table-row cursor-pointer noBoxShadow">
                                          <td className="text-align-center padding4">
                                            i
                                          </td>
                                          {sched.survey_type == "survey_no" && (
                                            <td className="padding4">
                                              Survey No.
                                            </td>
                                          )}
                                          {sched.survey_type == "ts_no" && (
                                            <td className="padding4">TS No.</td>
                                          )}{" "}
                                          {sched.survey_type ==
                                            "natham_survey_no" && (
                                            <td className="padding4">
                                              Natham Survey No.
                                            </td>
                                          )}
                                          {sched.survey_type == "survey_no" &&
                                            sched.old_survey_no != "" && (
                                              <td className="padding4">
                                                Old S.No- {sched.old_survey_no},
                                                After Sub Division New S.No-{" "}
                                                {sched.survey_no}
                                              </td>
                                            )}
                                          {sched.survey_type == "survey_no" &&
                                            sched.old_survey_no == "" && (
                                              <td className="padding4">
                                                S.No- {sched.survey_no}
                                              </td>
                                            )}
                                          {sched.survey_type ==
                                            "natham_survey_no" &&
                                            sched.old_natham_survey_no !=
                                              "" && (
                                              <td className="padding4">
                                                Old Natham S.No-
                                                {sched.old_natham_survey_no},
                                                New Natham S.No-{" "}
                                                {sched.natham_survey_no}
                                              </td>
                                            )}
                                          {sched.survey_type ==
                                            "natham_survey_no" &&
                                            sched.old_natham_survey_no ==
                                              "" && (
                                              <td className="padding4">
                                                Natham S.No-{" "}
                                                {sched.natham_survey_no}
                                              </td>
                                            )}
                                          {sched.survey_type == "ts_no" &&
                                            sched.old_ts_no != "" && (
                                              <td className="padding4">
                                                Old TS No-{sched.old_ts_no}, New
                                                TS No-{sched.ts_no}, Ward-{" "}
                                                {sched.ts_ward}, Block-{" "}
                                                {sched.ts_block}
                                              </td>
                                            )}
                                          {sched.survey_type == "ts_no" &&
                                            sched.old_ts_no == "" && (
                                              <td className="padding4">
                                                TS No- {sched.ts_no}, Ward-{" "}
                                                {sched.ts_ward}, Block-{" "}
                                                {sched.ts_block}
                                              </td>
                                            )}
                                        </tr>
                                        <tr className="query-table-row cursor-pointer noBoxShadow">
                                          <td className="padding4"></td>
                                          <td className="padding4">
                                            As per Revenue Record
                                          </td>
                                          <td className="padding4">
                                            {sched.revenue_record}
                                          </td>
                                        </tr>
                                        <tr className="query-table-row cursor-pointer noBoxShadow">
                                          <td className="text-align-center padding4">
                                            ii
                                          </td>
                                          <td className="padding4">
                                            Total Extent
                                          </td>
                                          <td className="padding4">
                                            {sched.extent}{" "}
                                            {sched.sur_extent_unit} in this UDS{" "}
                                            {schList.uds} {schList.uds_unit}
                                          </td>
                                        </tr>
                                        <tr className="query-table-row cursor-pointer noBoxShadow">
                                          <td className="text-align-center padding4">
                                            iii
                                          </td>
                                          <td className="padding4">
                                            Door No / Flat No as per builders
                                            Agreement / Floor No / Apartment
                                            Name
                                          </td>
                                          <td className="padding4">
                                            Door No- {schList.door_no}, Flat No-{" "}
                                            {schList.flat_no}, Floor No-{" "}
                                            {schList.floor}, Apartment name-{" "}
                                            {schList.appt_name}
                                          </td>
                                        </tr>
                                        <tr className="query-table-row cursor-pointer noBoxShadow">
                                          <td className="padding4"></td>
                                          <td className="padding4">
                                            Extent area including plinth built
                                            up area in case of house property /
                                            as per building Agreement
                                          </td>
                                          <td className="padding4">
                                            {schList.buildup}{" "}
                                            {schList.builtup_unit}- Plinth Area
                                            Including common area,
                                          </td>
                                        </tr>
                                        <tr className="query-table-row cursor-pointer noBoxShadow">
                                          <td className="text-align-center padding4">
                                            iv
                                          </td>
                                          <td className="padding4">
                                            Location like name of the place,
                                            village, city, registration, sub-
                                            district etc.
                                          </td>
                                          <td className="padding4">
                                            {this.state.address}
                                          </td>
                                        </tr>
                                        <tr className="query-table-row cursor-pointer noBoxShadow">
                                          <td className="text-align-center padding4">
                                            v
                                          </td>
                                          <td className="brdrClr" colSpan={2}>
                                            {sched.boundary_details &&
                                            sched.boundary_details.length
                                              ? sched.boundary_details.map(
                                                  (
                                                    schedB: any,
                                                    boundaryIndex: number,
                                                  ) => {
                                                    return (
                                                      <div
                                                        key={boundaryIndex}
                                                        style={{
                                                          marginBottom: "30px",
                                                        }}
                                                      >
                                                        <b className="textUnderline">
                                                          {boundaryIndex + 1}.
                                                          Boundaries for{" "}
                                                          {schedB.land_aries}{" "}
                                                          {schedB.unit} of land
                                                        </b>
                                                        <br></br>
                                                        <b className="textUnderline">
                                                          North{" "}
                                                          {schedB.direction}
                                                        </b>{" "}
                                                        - {schedB.north}
                                                        <br></br>
                                                        <b className="textUnderline">
                                                          South{" "}
                                                          {schedB.direction}
                                                        </b>{" "}
                                                        - {schedB.south}
                                                        <br></br>
                                                        <b className="textUnderline">
                                                          East{" "}
                                                          {schedB.direction}
                                                        </b>{" "}
                                                        - {schedB.east}
                                                        <br></br>
                                                        <b className="textUnderline">
                                                          West{" "}
                                                          {schedB.direction}
                                                        </b>{" "}
                                                        - {schedB.west}
                                                        <br></br>
                                                        {schedB.measurement_list &&
                                                        schedB.measurement_list
                                                          .length
                                                          ? schedB.measurement_list.map(
                                                              (
                                                                measurement: any,
                                                                measurementIndex: number,
                                                              ) => {
                                                                return (
                                                                  <div
                                                                    key={
                                                                      measurementIndex
                                                                    }
                                                                  >
                                                                    {measurement.meas_dir_list &&
                                                                      measurement
                                                                        .meas_dir_list
                                                                        .length >
                                                                        0 && (
                                                                        <>
                                                                          <b>
                                                                            <h4
                                                                              style={{
                                                                                textAlign:
                                                                                  "center",
                                                                                fontSize:
                                                                                  "34px !important",
                                                                                fontWeight:
                                                                                  "unset",
                                                                                marginTop:
                                                                                  "20px",
                                                                                marginBottom:
                                                                                  "10px",
                                                                              }}
                                                                            >
                                                                              Measurement
                                                                              Details
                                                                            </h4>
                                                                          </b>
                                                                          <table
                                                                            style={{
                                                                              width:
                                                                                "100%",
                                                                              borderCollapse:
                                                                                "collapse",
                                                                              margin:
                                                                                "10px 0",
                                                                              border:
                                                                                "1px solid #ddd",
                                                                            }}
                                                                          >
                                                                            <tbody>
                                                                              {measurement.meas_dir_list.map(
                                                                                (
                                                                                  dir: any,
                                                                                  dirIndex: number,
                                                                                ) => {
                                                                                  return (
                                                                                    <tr
                                                                                      key={
                                                                                        dirIndex
                                                                                      }
                                                                                      style={{
                                                                                        borderBottom:
                                                                                          "1px solid #ddd",
                                                                                      }}
                                                                                      className="query-table-row cursor-pointer noBoxShadow"
                                                                                    >
                                                                                      <td
                                                                                        className="padding4"
                                                                                        style={{
                                                                                          width:
                                                                                            "60%",
                                                                                          textAlign:
                                                                                            "center",
                                                                                          padding:
                                                                                            "8px",
                                                                                        }}
                                                                                      >
                                                                                        {dir.label ==
                                                                                        "8"
                                                                                          ? dir.measure_custom
                                                                                          : dir.label_name}
                                                                                      </td>
                                                                                      <td
                                                                                        className="padding4"
                                                                                        style={{
                                                                                          width:
                                                                                            "40%",
                                                                                          textAlign:
                                                                                            "center",
                                                                                          padding:
                                                                                            "8px",
                                                                                        }}
                                                                                      >
                                                                                        {
                                                                                          dir.value
                                                                                        }{" "}
                                                                                        {
                                                                                          measurement.l_unit
                                                                                        }
                                                                                      </td>
                                                                                    </tr>
                                                                                  );
                                                                                },
                                                                              )}
                                                                            </tbody>
                                                                          </table>
                                                                          <h6
                                                                            style={{
                                                                              paddingTop:
                                                                                "14px",
                                                                            }}
                                                                          >
                                                                            With
                                                                            all
                                                                            easements
                                                                            Rights
                                                                            and
                                                                            Pathway
                                                                          </h6>
                                                                        </>
                                                                      )}
                                                                  </div>
                                                                );
                                                              },
                                                            )
                                                          : ""}
                                                      </div>
                                                    );
                                                  },
                                                )
                                              : ""}
                                          </td>
                                        </tr>
                                      </table>
                                    );
                                  },
                                )
                              : ""}
                          </>
                        );
                      })
                    : ""}
                  <div className="btn-toolbar sw-toolbar sw-toolbar-bottom justify-content-end">
                    <div className="btn-group mr-2 sw-btn-group" role="group">
                      <button
                        className="btn mt-2 btn-warning sw-btn-next"
                        type="button"
                        onClick={() => {
                          isVerifyFlow
                            ? window.history.back()
                            : this.props.history.push(
                                "/work-file/1/" + this.props.match.params.id,
                              );
                        }}
                      >
                        Back
                      </button>
                    </div>
                    <div
                      className="btn-group mr-2 mt-2 sw-btn-group"
                      role="group"
                    >
                      {this.state.autoAssign &&
                      this.state.autoAssign.find(
                        (data: any) =>
                          data.module_name === "Auto Assign" && data.status,
                      ) ? (
                        <>
                          {takenfile == currentfile ? (
                            <>
                              <button
                                className="btn btn-success sw-btn-next"
                                type="button"
                                onClick={() => this.saveGeneralDoc(2)}
                                disabled={this.state.isLoading}
                              >
                                {this.state.isLoading && (
                                  <i className="fa fa-spinner fa-spin"></i>
                                )}
                                Save & Submit
                              </button>
                            </>
                          ) : (
                            <>
                              {isVerifyFlow ? (
                                <>
                                  <button
                                    className="btn btn-success sw-btn-next"
                                    type="button"
                                    onClick={() => this.saveGeneralDoc(2)}
                                    disabled={this.state.isLoading}
                                  >
                                    {this.state.isLoading && (
                                      <i className="fa fa-spinner fa-spin"></i>
                                    )}
                                    Save & Submit
                                  </button>
                                </>
                              ) : (
                                ""
                              )}
                            </>
                          )}
                        </>
                      ) : (
                        <>
                          <button
                            className="btn btn-success sw-btn-next"
                            type="button"
                            onClick={() => this.saveGeneralDoc(2)}
                            disabled={this.state.isLoading}
                          >
                            {this.state.isLoading && (
                              <i className="fa fa-spinner fa-spin"></i>
                            )}
                            Save & Submit
                          </button>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              )}
            {/* {this.state.showTable == true &&
              this.state.natureDocN == "appartment" && (
                <div
                  style={{
                    paddingTop: "11px",
                    paddingBottom: "15px",
                  }}
                  className="card"
                >
                  <b>
                    <h2
                      style={{
                        textAlign: "center",
                        fontSize: "34px !important",
                        fontWeight: "unset",
                      }}
                    >
                      Apartment
                    </h2>
                  </b>
                  {this.state.schedules && this.state.schedules.length
                    ? this.state.schedules.map((schList: any, schListIndex) => {
                        return (
                          <>
                            {schList.survey_details &&
                            schList.survey_details.length
                              ? schList.survey_details.map(
                                  (sched: any, schIndex) => {
                                    return (
                                      <table
                                        id="previewTable"
                                        style={{
                                          width: "70%",
                                          margin: "auto",
                                        }}
                                        className="table table-striped table-bordered nowrap"
                                      >
                                        <tr className="query-table-row cursor-pointer noBoxShadow">
                                          <td className="text-align-center padding4">
                                            i
                                          </td>
                                          {sched.survey_type == "survey_no" && (
                                            <td className="padding4">
                                              Survey No.
                                            </td>
                                          )}
                                          {sched.survey_type == "ts_no" && (
                                            <td className="padding4">TS No.</td>
                                          )}{" "}
                                          {sched.survey_type ==
                                            "natham_survey_no" && (
                                            <td className="padding4">
                                              Natham Survey No.
                                            </td>
                                          )}
                                          {sched.survey_type == "survey_no" &&
                                            sched.old_survey_no != "" && (
                                              <td className="padding4">
                                                Old S.No- {sched.old_survey_no},
                                                After Sub Division New S.No-{" "}
                                                {sched.survey_no}
                                              </td>
                                            )}
                                          {sched.survey_type == "survey_no" &&
                                            sched.old_survey_no == "" && (
                                              <td className="padding4">
                                                S.No- {sched.survey_no}
                                              </td>
                                            )}
                                          {sched.survey_type ==
                                            "natham_survey_no" &&
                                            sched.old_natham_survey_no !=
                                              "" && (
                                              <td className="padding4">
                                                Old Natham S.No-
                                                {sched.old_natham_survey_no},
                                                New Natham S.No-{" "}
                                                {sched.natham_survey_no}
                                              </td>
                                            )}
                                          {sched.survey_type ==
                                            "natham_survey_no" &&
                                            sched.old_natham_survey_no ==
                                              "" && (
                                              <td className="padding4">
                                                Natham S.No-{" "}
                                                {sched.natham_survey_no}
                                              </td>
                                            )}
                                          {sched.survey_type == "ts_no" &&
                                            sched.old_ts_no != "" && (
                                              <td className="padding4">
                                                Old TS No-{sched.old_ts_no}, New
                                                TS No-{sched.ts_no}, Ward-{" "}
                                                {sched.ts_ward}, Block-{" "}
                                                {sched.ts_block}
                                              </td>
                                            )}
                                          {sched.survey_type == "ts_no" &&
                                            sched.old_ts_no == "" && (
                                              <td className="padding4">
                                                TS No- {sched.ts_no}, Ward-{" "}
                                                {sched.ts_ward}, Block-{" "}
                                                {sched.ts_block}
                                              </td>
                                            )}
                                        </tr>
                                        <tr className="query-table-row cursor-pointer noBoxShadow">
                                          <td className="padding4"></td>
                                          <td className="padding4">
                                            As per Revenue Record
                                          </td>
                                          <td className="padding4">
                                            {sched.revenue_record}
                                          </td>
                                        </tr>
                                        <tr className="query-table-row cursor-pointer noBoxShadow">
                                          <td className="text-align-center padding4">
                                            ii
                                          </td>
                                          <td className="padding4">
                                            Total Extent
                                          </td>
                                          <td className="padding4">
                                            {sched.extent}{" "}
                                            {sched.sur_extent_unit} in this UDS{" "}
                                            {schList.uds} {schList.uds_unit}
                                          </td>
                                        </tr>
                                        <tr className="query-table-row cursor-pointer noBoxShadow">
                                          <td className="text-align-center padding4">
                                            iii
                                          </td>
                                          <td className="padding4">
                                            Door No / Flat No as per builders
                                            Agreement / Floor No / Apartment
                                            Name
                                          </td>
                                          <td className="padding4">
                                            Door No- {schList.door_no}, Flat No-{" "}
                                            {schList.flat_no}, Floor No-{" "}
                                            {schList.floor}, Apartment name-{" "}
                                            {schList.appt_name}
                                          </td>
                                        </tr>
                                        <tr className="query-table-row cursor-pointer noBoxShadow">
                                          <td className="padding4"></td>
                                          <td className="padding4">
                                            Extent area including plinth built
                                            up area in case of house property /
                                            as per building Agreement
                                          </td>
                                          <td className="padding4">
                                            {schList.buildup}{" "}
                                            {schList.builtup_unit}- Plinth Area
                                            Including common area,
                                          </td>
                                        </tr>
                                        <tr className="query-table-row cursor-pointer noBoxShadow">
                                          <td className="text-align-center padding4">
                                            iv
                                          </td>
                                          <td className="padding4">
                                            Location like name of the place,
                                            village, city, registration, sub-
                                            district etc.
                                          </td>
                                          <td className="padding4">
                                            {this.state.address}
                                          </td>
                                        </tr>
                                        <tr className="query-table-row cursor-pointer noBoxShadow">
                                          <td className="text-align-center padding4">
                                            v
                                          </td>
                                          <td className="brdrClr" colSpan={2}>
                                            {sched.boundary_details &&
                                            sched.boundary_details.length
                                              ? sched.boundary_details.map(
                                                  (
                                                    schedB: any,
                                                    schIndex: 0,
                                                  ) => {
                                                    return (
                                                      <>
                                                        <b className="textUnderline">
                                                          {schIndex + 1}.
                                                          Boundaries for{" "}
                                                          {schedB.land_aries}{" "}
                                                          {schedB.unit} of land
                                                        </b>
                                                        <br></br>
                                                        <b className="textUnderline">
                                                          North{" "}
                                                          {schedB.direction}
                                                        </b>{" "}
                                                        - {schedB.north}
                                                        <br></br>
                                                        <b className="textUnderline">
                                                          South{" "}
                                                          {schedB.direction}
                                                        </b>{" "}
                                                        - {schedB.south}
                                                        <br></br>
                                                        <b className="textUnderline">
                                                          East{" "}
                                                          {schedB.direction}
                                                        </b>{" "}
                                                        - {schedB.east}
                                                        <br></br>
                                                        <b className="textUnderline">
                                                          West{" "}
                                                          {schedB.direction}
                                                        </b>{" "}
                                                        - {schedB.west}
                                                        <br></br>
                                                        {this.state
                                                          .measureList &&
                                                        this.state.measureList
                                                          .length
                                                          ? this.state.measureList.map(
                                                              (
                                                                dirLabel: any,
                                                                index,
                                                              ) => {
                                                                return (
                                                                  <>
                                                                    {dirLabel.meas_dir_list &&
                                                                      dirLabel
                                                                        .meas_dir_list
                                                                        .length >
                                                                        0 &&
                                                                      dirLabel
                                                                        .meas_dir_list[0]
                                                                        .label_name !=
                                                                        null && (
                                                                        <>
                                                                          <b>
                                                                            <h4
                                                                              style={{
                                                                                textAlign:
                                                                                  "center",
                                                                                fontSize:
                                                                                  "34px !important",
                                                                                fontWeight:
                                                                                  "unset",
                                                                              }}
                                                                            >
                                                                              Measurement
                                                                              Details
                                                                            </h4>
                                                                          </b>
                                                                          <table>
                                                                            {this
                                                                              .state
                                                                              .measDirList &&
                                                                            this
                                                                              .state
                                                                              .measDirList
                                                                              .length
                                                                              ? this.state.measDirList.map(
                                                                                  (
                                                                                    dir: any,
                                                                                  ) => {
                                                                                    return (
                                                                                      <>
                                                                                        <tr
                                                                                          style={{
                                                                                            margin:
                                                                                              "auto",
                                                                                            display:
                                                                                              "table",
                                                                                            width:
                                                                                              "100%",
                                                                                          }}
                                                                                          className="query-table-row cursor-pointer noBoxShadow"
                                                                                        >
                                                                                          {dir.label !=
                                                                                            "8" && (
                                                                                            <td
                                                                                              className="padding4"
                                                                                              style={{
                                                                                                width:
                                                                                                  "60%",
                                                                                                textAlign:
                                                                                                  "center",
                                                                                              }}
                                                                                            >
                                                                                              {
                                                                                                dir.label_name
                                                                                              }
                                                                                            </td>
                                                                                          )}
                                                                                          {dir.label ==
                                                                                            "8" && (
                                                                                            <td
                                                                                              className="padding4"
                                                                                              style={{
                                                                                                width:
                                                                                                  "60%",
                                                                                                textAlign:
                                                                                                  "center",
                                                                                              }}
                                                                                            >
                                                                                              {
                                                                                                dir.measure_custom
                                                                                              }
                                                                                            </td>
                                                                                          )}
                                                                                          <td
                                                                                            className="padding4"
                                                                                            style={{
                                                                                              width:
                                                                                                "40%",
                                                                                              textAlign:
                                                                                                "center",
                                                                                            }}
                                                                                          >
                                                                                            {
                                                                                              dir.value
                                                                                            }{" "}
                                                                                            {
                                                                                              dirLabel.l_unit
                                                                                            }
                                                                                          </td>
                                                                                        </tr>
                                                                                      </>
                                                                                    );
                                                                                  },
                                                                                )
                                                                              : ""}
                                                                          </table>
                                                                          <h6
                                                                            style={{
                                                                              paddingTop:
                                                                                "14px",
                                                                            }}
                                                                          >
                                                                            With
                                                                            all
                                                                            easements
                                                                            Rights
                                                                            and
                                                                            Pathway
                                                                          </h6>
                                                                        </>
                                                                      )}
                                                                  </>
                                                                );
                                                              },
                                                            )
                                                          : ""}
                                                      </>
                                                    );
                                                  },
                                                )
                                              : ""}
                                          </td>
                                        </tr>
                                      </table>
                                    );
                                  },
                                )
                              : ""}
                          </>
                        );
                      })
                    : ""}
                  <div className="btn-toolbar sw-toolbar sw-toolbar-bottom justify-content-end">
                    <div className="btn-group mr-2 sw-btn-group" role="group">
                      <button
                        className="btn mt-2 btn-warning sw-btn-next"
                        type="button"
                        onClick={() => {
                          isVerifyFlow
                            ? window.history.back()
                            : this.props.history.push(
                                "/work-file/1/" + this.props.match.params.id,
                              );
                        }}
                      >
                        Back
                      </button>
                    </div>
                    <div
                      className="btn-group mr-2 mt-2 sw-btn-group"
                      role="group"
                    >
                      {this.state.autoAssign &&
                      this.state.autoAssign.find(
                        (data: any) =>
                          data.module_name === "Auto Assign" && data.status,
                      ) ? (
                        <>
                          {takenfile == currentfile ? (
                            <>
                              <button
                                className="btn btn-success sw-btn-next"
                                type="button"
                                onClick={() => this.saveGeneralDoc(2)}
                                disabled={this.state.isLoading}
                              >
                                {this.state.isLoading && (
                                  <i className="fa fa-spinner fa-spin"></i>
                                )}
                                Save & Submit
                              </button>
                            </>
                          ) : (
                            <>
                              {isVerifyFlow ? (
                                <>
                                  <button
                                    className="btn btn-success sw-btn-next"
                                    type="button"
                                    onClick={() => this.saveGeneralDoc(2)}
                                    disabled={this.state.isLoading}
                                  >
                                    {this.state.isLoading && (
                                      <i className="fa fa-spinner fa-spin"></i>
                                    )}
                                    Save & Submit
                                  </button>
                                </>
                              ) : (
                                ""
                              )}
                            </>
                          )}
                        </>
                      ) : (
                        <>
                          <button
                            className="btn btn-success sw-btn-next"
                            type="button"
                            onClick={() => this.saveGeneralDoc(2)}
                            disabled={this.state.isLoading}
                          >
                            {this.state.isLoading && (
                              <i className="fa fa-spinner fa-spin"></i>
                            )}
                            Save & Submit
                          </button>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              )} */}
          </div>

          <div
            className="modal fade"
            id="doc-preview"
            role="dialog"
            aria-hidden="true"
          >
            <div className="modal-dialog modal-lg" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Document Preview</h5>
                  <button
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div className="modal-body">
                  {this.state.isDocPreviewLoading && (
                    <div
                      className="spin-container"
                      style={{ width: "55em", height: "30em" }}
                    >
                      <span className="imgLoader" />
                    </div>
                  )}
                  <iframe
                    width="100%"
                    height="400"
                    frameBorder="0"
                    src={this.state.docReportForPreview}
                  ></iframe>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    data-dismiss="modal"
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div
            className={`modal ${this.state.docToPreview ? "open" : ""}`}
            id="preview-document"
            role="dialog"
            aria-hidden="true"
          >
            <div
              className="modal-dialog modal-xl"
              role="document"
              style={{ maxWidth: "90%" }}
            >
              <div className="modal-content">
                <div className="modal-header">
                  <button
                    type="button"
                    className="close cursor-pointer"
                    data-dismiss="modal"
                    aria-label="Close"
                    onClick={() => this.setState({ docToPreview: false })}
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div
                  className="modal-body"
                  style={{ transform: `rotate(${this.state.rotation}deg)` }}
                >
                  {this.state.base && this.state.isHightlightsLoaded && (
                    <PDFHighlighter
                      url={this.state.base}
                      onHighlightsChange={this.onHighlightsChange}
                      highlights={this.state.highlights}
                      rotation={this.state.rotation}
                      isPopup
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
